import { arrayRange } from '../utils/dataManipulations';

//constants used to create the filter options
const make = [
    'Audi',
    'Chevrolet',
    'Cadillac',
    'Acura',
    'BMW',
    'Chrysler',
    'Ford',
    'Buick',
    'INFINITI',
    'GMC',
    'Honda',
    'Hyundai',
    'Jeep',
    'Genesis',
    'Dodge',
    'Jaguar',
    'Kia',
    'Land Rover',
    'Lexus',
    'Mercedes-Benz',
    'Mitsubishi',
    'Lincoln',
    'MAZDA',
    'Nissan',
    'MINI',
    'Porsche',
    'Ram',
    'Subaru',
    'Toyota',
    'Volkswagen',
    'Volvo',
    'Alfa Romeo',
    'FIAT',
    'Freightliner',
    'Maserati',
    'Tesla',
    'Aston Martin',
    'Bentley',
    'Ferrari',
    'Lamborghini',
    'Lotus',
    'McLaren',
    'Rolls-Royce',
    'smart',
    'Scion',
    'SRT',
    'Suzuki',
    'Fisker',
    'Maybach',
    'Mercury',
    'Saab',
    'HUMMER',
    'Pontiac',
    'Saturn',
    'Isuzu',
    'Panoz',
    'Oldsmobile',
    'Daewoo',
    'Plymouth',
    'Eagle',
    'Geo',
    'Daihatsu',
    'Polestar',
    'Rivian',
];
// color options
const colors = [
    'Orange',
    'Pearl',
    'Pink',
    'Brown',
    'Purple',
    'Red',
    'Yellow',
    'Teal',
    'Gold',
    'Off white',
    'Green',
    'Matt Black',
    'Burgundy',
    'Ivory',
    'Black',
    'White',
    'Silver',
    'Blue',
    'Gray',
    'Beige',
    'Other',
];
const sportBrands = {
    6202: [
        'Behringer',
        'Casio',
        'Fender',
        'Ibanez',
        'Yamaha',
        'ADMIRA',
        'Agile',
        'Aguilar',
        'Alembic',
        'Alhambra',
        'Allparts',
        'Alvarez',
        'ammoon',
        'Amptweaker',
        'Analog Man',
        'Aria',
        'Art & Lutherie',
        'Artist',
        'Asturias',
        'Augustine',
        'Avatar',
        'AXL',
        'B-Band',
        'Baker',
        'Bare Knuckle',
        'BK Butler',
        'Black Arts Toneworks',
        'Black Cat',
        'Black Diamond',
        'Blade',
        'Bogner',
        'Boss',
        'Burns',
        'Burswood',
        'Cardinal',
        'Cole Clark',
        'Composite Acoustics',
        'Conklin',
        'Cort',
        'Crafter',
        'Crescent',
        'CTS',
        'Custom',
        "D'Addario",
        'DBZ',
        'Dean Guitars',
        'Diezel',
        'DigiTech',
        'Donner',
        'DR',
        'Duncan Designed',
        'Eastman',
        'Eastwood',
        'Encore Electronics',
        'Epiphone',
        'ESP',
        'Esp Guitars',
        'Esteban',
        'EVH',
        'Fernandes',
        'First Act',
        'Fretlight',
        'G&L',
        'Gallien-Krueger',
        'Gator',
        'Gibson',
        'Gold Tone',
        'Greco',
        'Gretsch',
        'Gruv Gear',
        'Guild',
        'Hallmark-UK',
        'Halo',
        'Hamer',
        'Harley Benton',
        'Harmony',
        'Headway',
        'Hi-Story',
        'Italia',
        'JB Player',
        'Ken Smith',
        'Kona',
        'L.R. Baggs',
        'LAG',
        'Line 6',
        'LTD',
        'LUNA',
        'Maestro',
        'Magnatone',
        'Manuel Rodriguez',
        'Markbass',
        'Marshall',
        'Martin',
        'Martin Guitars',
        'Maxam',
        'Michael Kelly',
        'Mitchell',
        'Mooer',
        'Morgan Monroe',
        'Music Man',
        'National',
        'NUX',
        'One Control',
        'Oscar Schmidt',
        'Ovation',
        'Parker',
        'Peavey',
        'Pedulla',
        'Phil Jones Bass',
        'Pro-Line Racing',
        'PRS',
        'Red Panda',
        'Reverend',
        'Richwood',
        'Rockbox',
        'Rockman',
        'Rogue',
        'Samick',
        'Schecter',
        'Seymour Duncan',
        'Shine',
        'Sigma',
        'Silvertone',
        'SKB',
        'Source Audio',
        'Squier',
        'Suhr',
        'Supro',
        'Suzuki',
        'SX',
        'Tacoma',
        'Tanglewood',
        'Taylor',
        'Tom Anderson',
        'Truetone',
        'Tune',
        'Two-Rock',
        'Univox',
        'VENTURA',
        'Vibramate',
        'Vox',
        'Washburn',
        'Westfield',
        'Westone',
        'Wolf',
        'YAMAKI',
        'Z.Vex',
        'Other',
    ],
    6203: [
        'American Fitness',
        'Bodyfit',
        'Bodygym',
        'Everlast',
        'Universal',
        '3G Cardio',
        '66Fit',
        'A&W',
        'Ab Coaster',
        'Ab Doer Twist',
        'Ab Rocket',
        'Abgymnic',
        'Abtronic',
        'Adidas',
        'Afg',
        'Afrocanfit',
        'Airex',
        'Ancheer',
        'Apollo',
        'Aquajogger',
        'Arena',
        'Artengo',
        'Asics',
        'Avex',
        'Babolat',
        'Bally',
        'Best Choice Products',
        'Bestway',
        'Bh Fitness',
        'Black Mountain',
        'Blue Idea',
        'Bmx',
        'Body Sculpture',
        'Body-Solid',
        'Bodyblade',
        'Bodyflex',
        'Bodylastics',
        'Bodyworx',
        'Bosu',
        'Bowflex',
        'Bremshey',
        'Brooks',
        'Btwin',
        'Callaway',
        'Cap',
        'Capital Sports',
        'Captains Of Crush',
        'Carlton',
        'Casall',
        'Champion',
        'Christopeit',
        'Confidence Fitness',
        'Costway',
        'Cybex',
        'De Young',
        'Diamond Back',
        'Domyos',
        'Drive',
        'Dunlop',
        'Dynamix',
        'Easy 8',
        'Eco-Fit',
        'Elevation',
        'Elops',
        'Emrad Billards',
        'Endurance',
        'Energetics',
        'Enjoy Fit',
        'Ergo-Fit',
        'Everfit',
        'Exerpeutic',
        'Fdf',
        'Fila',
        'Fit4Home',
        'Fitball',
        'Fitness Quest',
        'Fitness Reality',
        'Fitnessclub',
        'Fitnex',
        'Flx',
        'Forclaz',
        'Fortis',
        'Freemotion',
        'Fuelbelt',
        'Garmin',
        'Gategold',
        'Generic',
        'Genesis',
        'Genki',
        'German Machine',
        'Getfit',
        'Ght',
        'Giant',
        'Gng Fitness',
        'Gofit',
        "Gold's Gym",
        'Gramax',
        'Gripmaster',
        'Gym Master',
        'Gymboss',
        'Gymstick',
        'Haggai',
        'Hammer',
        'Harbinger',
        'Head',
        'Hero',
        'Hippie Runner',
        'Horizon',
        'Horizon Fitness',
        'Housefit',
        'Hudora',
        'Huffy',
        'Hy-Skate',
        'Icon Health & Fitness',
        'Impulse',
        'Intex',
        'Iron Gym',
        'Ironman',
        'Ironmind',
        'J&S',
        'Jako',
        'Weslo',
        'Wilson',
        'Wish',
        'Wonder Core',
        'Woodway',
        'Xterra',
        'Xterra Fitness',
        'Revolt',
        'Riley',
        'Rio',
        'Rockrider',
        'Rumbleroller',
        'Sand Socks',
        'Schwinn',
        'Scsports',
        'Shimano',
        'Sigma',
        'Simba',
        'Simply Fit',
        'Six Pack Care',
        'Skyland',
        'Smith',
        'Sole',
        'Sole Fitness',
        'Soozier',
        'Spalding',
        'Spec',
        'Speedo',
        'Spibelt',
        'Spirit',
        'Spirit Fitness',
        'Sport Schmidt',
        'Sportcraft',
        'Sportplus',
        'Sportsart',
        'Spot On',
        'Spri',
        'Stairmaster',
        'Stamina',
        'Star Trac',
        'Stiga',
        'Striker Butterfly',
        'Supermax',
        'Supermax Pro',
        'Suunto',
        'Suzanne Somers',
        'Talon',
        'Tarmak',
        'Tcm',
        'Technofitness',
        'Technogym',
        'Tempo Fitness',
        'Tempt',
        'The Firm',
        'Total Core',
        'Total Gym',
        'Trackmaster',
        'Trek',
        'Triban',
        'Trojan',
        'True Fitness',
        'Tummy Trimmer',
        'Tunturi',
        'Uhlsport',
        'Umbro',
        'Unbranded',
        'Upper Bounce',
        'V-Fit',
        'Valeo',
        'Venum',
        'Vibro Action',
        'Vision',
        'Vision Fitness',
        'Weider',
        'Well Care',
        'Jll',
        'Joola',
        'Jumpking',
        'Jumpsport',
        'Jx',
        'K2',
        'Kazu',
        'Kettler',
        'Keys Fitness',
        'La Gear',
        'Landice',
        'Leadsuper',
        'Li Link',
        'Life Fitness',
        'Lifeline',
        'Lifespan',
        'Loki',
        'LSG',
        'Magnum Fitness',
        'Marcy',
        'Marin',
        'Marshal Fitness',
        'Matrix',
        'Matrix Fitness',
        'Mercedes Benz',
        'Mikasa',
        'Molten',
        'Mongoose',
        'Nashua',
        'New Balance',
        'Newgen',
        'Next',
        'Nike',
        'Ninja',
        'Nordic',
        'Nordictrack',
        'Octane Fitness',
        'Olympus',
        'Opti',
        'Oxelo',
        'Pacemaster',
        'Passion',
        'Perfect Fitness',
        'Physical Company',
        'Ping',
        'Pivot',
        'Power Max',
        'Power Plate',
        'Powerball',
        'Powertrain',
        'Prince',
        'Pro Fitness',
        'Pro Sport',
        'Pro Tech',
        'Proform',
        'Progear',
        'Prolife',
        'Promaxima',
        'Pulse',
        'Puma',
        'Raleigh',
        'Rebounder',
        'Reebok',
        'Yes4All',
        'Yogarat',
        'Yogistar',
        'Yonex',
        'York',
        'York Fitness',
        'Zumba',
        'Other',
    ],
    6206: [
        'A.E.S',
        'ABUS',
        'ACE',
        'Acme',
        'General',
        'ACDelco',
        'activa',
        'Adams',
        'AE Light',
        'AEG',
        'AeroBed',
        'AFC',
        'Aigle',
        'Aladdin',
        'ALEKO',
        'Alite',
        'Allen',
        'Alpine',
        'AMP',
        'Ampro',
        'Amtech',
        'AR',
        'Armstrong',
        'Badger',
        'Barska',
        'Bear Grylls',
        'Berger',
        'Best',
        'BGS',
        'Big K',
        'BLACK+DECKER',
        'Blacks',
        'Brunton',
        'Bush',
        'CAMCO',
        'CamelBak',
        'CAN',
        'CENTURY',
        'Coleman',
        'Craftsman',
        'Do It Best',
        'Easy Camp',
        'EVEREADY',
        'Garden Pleasure',
        'Garmin',
        'GB',
        'Henderson',
        'Hi Gear',
        'Hyundai',
        'Joy',
        'Karrimor',
        'Leisure',
        'Naturehike',
        'Nikon',
        'Outdoor Products',
        'Ozark Trail',
        'PRO',
        'Royal',
        'SILVA',
        'Sunex',
        'Other',
    ],
};
const sportTypes = {
    6201: [
        'TV, DVD & VCR Accessories',
        'Televisions, Plasma & LCD TVs',
        'Smart TV',
        'Other TV, DVD & Video',
        'DVD Players & Recorders',
        'TV Reception & Set-Top Boxes',
        'Satellite & Cable Equipment',
        'Security & Surveillance Systems',
        'Blu-ray Players & Recorders',
        'Video Players & Recorders',
        'TV Projectors',
        'GPS Devices',
        'Portable DVD & Blu-ray Players',
        'Audiobooks',
        'Movies',
        'Music',
        'Training',
        'Tutorial',
        'Other',
    ],
    6202: [
        'Electronic Keyboards',
        'Acoustic Drum Sets',
        'Acoustic Guitars',
        'Bass Guitars',
        'Electric Guitars',
        'Accordions',
        'Bass Drums',
        'Bongo Drums',
        'Bugles',
        'Cellos',
        'Clarinets',
        'Congas',
        'Cornets',
        'Cymbals',
        'Double Basses',
        'Electronic Drum Sets',
        'Flutes',
        'Frame Drums',
        'Guitar & Bass Effects',
        'Guitar Amp Heads',
        'Guitar Cabs',
        'Guitar Combos',
        'Guitar Preamps',
        'Harmonicas',
        'Harps',
        'Horns',
        'Maracas',
        'Melodicas',
        'Midi Keyboards',
        'Music Bags & Cases',
        'Music Stands',
        'Organs',
        'Parts & Accessories',
        'Pianos',
        'Saxophones',
        'Snare Drums',
        'Talking Drums',
        'Tambourines',
        'Tom Drums',
        'Trombones',
        'Trumpets',
        'Tubas',
        'Ukuleles',
        'Violins',
        'Xylophones',
        'Other',
    ],
    6203: [
        'Snooker Tables',
        'Treadmills',
        'Bicycles & Tricycles',
        'Massagers',
        'Tennis Tables',
        'Ab Exercise Machine',
        'Agility Ladders',
        'Air Hockey Tables',
        'Arm Blasters',
        'Badminton Nets',
        'Badminton Rackets',
        'Badminton Stands',
        'Balance Boards',
        'Ball Pumps',
        'Barbells',
        'Baseball Bats',
        'Baseball Gloves',
        'Basketball Balls',
        'Basketball Stands',
        'Benches',
        'Bike Accessories',
        'Bike Baskets',
        'Bike Brakes',
        'Bike Clothes',
        'Bike Computers & GPS',
        'Bike Covers',
        'Bike Fenders',
        'Bike Gloves',
        'Bike Helmets',
        'Bike Horns',
        'Bike Lights & Reflectors',
        'Bike Pedals & Cleats',
        'Bike Phone Holder',
        'Bike Pumps',
        'Bike Repair & Multi-Function Tools',
        'Bike Saddles',
        'Bike Security & Locks',
        'Bike Tyres & Inner Tubes',
        'Bodyboards',
        'Bottle Cage',
        'Boxing Gloves',
        'Boxing Wraps',
        'Cricket Bats',
        'Cross Trainers',
        'Crossfit Racks',
        'Dartboard',
        'Dip Bars',
        'Diving Snorkels',
        'Dumbbells',
        'Exercise Bikes',
        'Exercise Ropes',
        'Flags and Flag Stands',
        'Foam Roller',
        'Football Goals',
        'Football Tables',
        'Goalkeeper Gloves',
        'Golf Balls',
        'Golf Gloves',
        'Golf Sets',
        'Gym Balls',
        'Gym Gloves',
        'Gym Mats',
        'Gymnastics Rings',
        'Hand Grips',
        'Hockey Sticks',
        'Hoverboards',
        'Hula Hoops',
        'Jump Boxes',
        'Kettlebell',
        'Kickboards',
        "Kids' Vehicle",
        'Leg Machines',
        'Medicine Balls & Slam Balls',
        'Multi-Station Gym',
        'Orbitreks',
        'Pedometers',
        'Protective Gear',
        'Pull-Up Bars',
        'Punching Bags',
        'Push-Up Bars',
        'Resistance Power Bands',
        'Roller Skates',
        'Rowing Machines',
        'Rugby Balls',
        'Scooter',
        'Skateboarding Helmets',
        'Skateboards',
        'Skipping Rope',
        'Snooker Balls',
        'Snooker Cue Sticks',
        'Soccer Balls',
        'Squash Balls',
        'Stability Balls',
        'Stair Mills',
        'Step Boards',
        'Steppers',
        'Stopwatches',
        'Substitution Boards',
        'Swimming Caps',
        'Swimming Flippers',
        'Swimming Goggles',
        'Swimming Masks',
        'Swimming Pools',
        'Table Tennis Rackets',
        'Tennis Balls',
        'Tennis Nets & Posts',
        'Tennis Rackets',
        'Training Cones',
        'Trampolines',
        'Twister Disc',
        'Vibrating Platforms',
        'Volleyballs',
        'Wearable Weights',
        'Weight Racks',
        'Weighted Bags',
        'Whistles',
        'Wrist Bandages',
        'Other',
    ],
    6204: [
        'Awards & Trophies',
        'Carving Tools',
        'Crochet Hooks',
        'Drawing Tools',
        'Medals',
        'Pictures',
        'Sculptures',
        'Yarn',
        'Gift Ideas',
        'Other',
    ],
    6205: ['Games', 'Books', 'Others'],
    6206: [
        'Furniture',
        'Cooking Supplies',
        'Compasses',
        'Binoculars',
        'Trekking Poles',
        'Lanterns & Headlamps',
        'Sleeping Bags',
        'Telescopes',
        'Tents',
        'Other',
    ],
};
const motorbikeMake = {
    6301: [
        'Honda',
        'TVS',
        'Bajaj',
        'Yamaha',
        'Qlink',
        'American Ironhorse',
        'Aprilia',
        'Apsonic',
        'Autodex',
        'Beach',
        'Benelli',
        'Bimota',
        'BMW',
        'Boss Hoss',
        'Buell',
        'CAD',
        'Can-Am',
        'CFMoto',
        'CityCoco',
        'Custom Built Motorcycles',
        'Daelim',
        'Daylong',
        'Dayun',
        'Denstar',
        'Ducati',
        'Evalast',
        'Focin',
        'Gilera',
        'Haojin',
        'Haojue',
        'Harley-Davidson',
        'Hero',
        'Husqvarna',
        'Hyosung',
        'Indian',
        'Jinan Qingqi',
        'Jincheng',
        'Kary-Go',
        'Kasea',
        'Kawasaki',
        'KR Motors',
        'KTM',
        'Kymco',
        'Kymstone',
        'Lifan',
        'Mahindra',
        'Max-S',
        'Moto Guzzi',
        'MTR',
        'Muoner',
        'Peugeot',
        'Piaggio',
        'Polaris',
        'Premier',
        'Royal',
        'Sanya',
        'Senke',
        'Sinoki',
        'Skygo',
        'Sonlink',
        'Super Gallant',
        'Suzuki',
        'SYM',
        'Toprich',
        'Tricycle',
        'Triumph',
        'Twinco',
        'Vento',
        'Zongshen',
        'Other',
    ],
    6302: [
        'Vespa',
        'Honda',
        'Piaggio',
        'Yamaha',
        'Suzuki',
        'TVS Motor',
        'Aprilia',
        'Kymco',
        'SYM',
        'Hero MotoCorp',
        'Bajaj Auto',
        'Peugeot',
        'Lambretta',
        'Genuine Scooters',
        'Royal Alloy',
        'SYMPL',
        'Gogoro',
        'Zero Motorcycles',
        'Ola Electric',
        'Segway-Ninebot',
        'Lime',
        'Other',
    ],
};
const motorbikeType = [
    'Cruiser',
    'Dual Sport',
    'Motocross',
    'Quad (ATV)',
    'Retro',
    'Sport Bike',
    'Standard',
    'Touring',
    'Tricycle',
    'Other',
];
const vehcle_price = [
    { label: 'All', value: '' },
    { label: 'Under 1.5m', value: '1500000' },
    { label: '1.5m to 3m', value: '3000000' },
    { label: '3m to 7.5m', value: '7500000' },
    { label: '7.5m to 11m', value: '11000000' },
    { label: '11m and more', value: '>11000000' },
];
const price = [
    { label: 'All', value: '' },
    { label: '0 - 5k', value: '5000' },
    { label: '5k to 10k', value: '10000' },
    { label: '10k - 15k', value: '15000' },
    { label: '15k to 20k', value: '20000' },
    { label: '20k to 30k', value: '30000' },
    { label: '30k and more', value: '>30000' },
];
const mode_of_charge = [
    { name: 'All', value: '' },
    { name: 'TBD', value: 'tbd' },
    { name: 'Estimate', value: 'estimate' },
];
const fuel_type = ['Petrol', 'Electric', 'Gasoline', 'Hybrid'];
const transmission = ['Automatic', 'Manual', 'CVT'];
const condition = [
    { label: 'Nigerian Used', value: 'nigerian use' },
    { label: 'Foreign Used', value: 'foreign use' },
    { label: 'Brand New', value: 'new' },
];
const condition_refub = [
    { label: 'Refurbished', value: 'refurbished' },
    { label: 'Used', value: 'used' },
    { label: 'New', value: 'new' },
];
const size = [
    '28',
    '30',
    '32',
    '33',
    '35',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '29',
    '31',
    '34',
];
const softwareFormat = ['DVD', 'Email', 'Download', 'Subscription', 'USB', 'CD', 'Product keys'];
const age_group = ['All', 'Baby', 'Toddler', 'Kids', 'Teens', 'Adult', 'Senior'];
const vehicle_body = [
    'suv',
    'crossover',
    'hatchback',
    'pick up truck',
    'station wagon',
    'coupe',
    'sports car',
    'sedan',
    'minivan',
    'convertible',
    'van',
    'panel van',
    'compact car',
    'microcar',
    'roadster',
];
const vehicleAccessoriesType = [
    'Car Tuning & Styling',
    'Wheel Rims & Tyres',
    'Exterior Accessories',
    'Brakes, Suspension, Steering',
    'Engine & Drivetrain',
    'Headlights & Lighting',
    'Oils & Fluids',
    'Safety & Security',
    'Wheels & Parts',
    'Motorcycle Parts',
    'Interior Accessories',
    'In-Car Audio & GPS',
    'Watercraft & Boat Parts',
    'Clothes, Helmets & Boots',
    'Other',
];
const otherVehicleType = [
    'LPG Tanks',
    'Forklifts',
    'Tractors',
    'Concrete Mixers',
    'Wheel Loaders',
    'Pneumatic Rollers',
    'Piling Machine',
    'Boom Lifts',
    'Bulldozers',
    'Dumpers Truck',
    'Excavators',
    'Pipe Layers',
    'Road Roller',
    'Scissor Lifts',
    'Storage Tanks',
    'Asphalt Pavers',
    'Crane Forks',
    'Crushers',
    'Drilling Rigs',
    'Farm Machines',
    'Graders',
    'Mobile Crusher',
    'Pallet Stackers',
    'Vibratory Rollers',
    'Concrete Pumps',
    'other',
];
//software category
const softwareTypes = [
    'Operating Systems',
    'Application Software',
    'Utility Software',
    'Programming Software',
    'Database Software',
    'Graphics & Design Software',
    'Communication Software',
    'Media Players & Editors',
    'Educational Software',
    'Financial Software',
    'Gaming Software',
    'Medical & Healthcare Software',
    'Navigation Software',
    'Enterprise Software',
    'Security Software',
    'Project Management Software',
    'CAD',
    'Weather Forecasting Software',
    'Artificial Intelligence',
    'IoT (Internet of Things) Software',
    'Other',
];
const softwarePlatforms = {
    5901: ['Android', 'iOS', 'Linux', 'Mac', 'Windows', 'other'],
    default: [
        'Android',
        'iOS',
        'Linux',
        'Mac',
        'Windows',
        'Microsoft Xbox',
        'Microsoft Xbox One',
        'PC',
        'Sony PlayStation',
        'Sony PlayStation 1-5',
        'Sony PlayStation Vita',
        'Nintendo Switch',
        'Nintendo Wii',
        'other',
    ],
};
const gameGenre = [
    'Action',
    'Adventure',
    'Shooter',
    'Fighting',
    'Racing',
    'Role Playing',
    'Sports',
    'Strategy',
    'Other',
];

const furnitureFor = [
    'Bedroom ',
    'Dining Room',
    'Home Office / Study',
    'Kitchen',
    'Living Room',
    'Attic',
    'Balcony',
    'Basement',
    'Bathroom',
    'Dressing Room',
    'Foyer',
    'Garage',
    'Guestroom',
    'Hallway',
    'Laundry Utility Room',
    'Other',
    'Patio',
    'Playroom ',
    'Porch',
    'Sport Room ',
    'Sunroo',
];

// property
const propertyType = {
    default: [
        'Filling Station',
        'Terraced Duplex',
        'Shop',
        'Hotel',
        'Office Space',
        'Bakery',
        'Church',
        'Factory',
        'Fish Farm',
        'Garage',
        'Gas Plant',
        'Hall',
        'Hospital',
        'Hostel',
        'Laundry Business',
        'Open Space',
        'Pharmacy',
        'Plaza',
        'Poultry Farm',
        'Recreation Centre',
        'Restaurant',
        'Salons',
        'School',
        'Showroom',
        'Supermarket',
        'Tank Farm',
        'Warehouse',
        'Apartment',
        'Penthouse',
        'Villa',
        'Condo',
        'Maisonette',
        'Chalet',
        'Mini Flat',
        'House',
        'Block of Flats',
        'Room & Parlour',
        'Studio Apartment',
        'Bungalow',
        'Mansion',
        'Townhouse/Terrace',
        'Duplex',
    ],
    5105: [
        'Commercial Land',
        'Farmland',
        'Industrial Land',
        'Mixed-Use Land',
        'Quarry',
        'Residential Land',
    ],
};
const propertyFacilities = {
    5101: [
        'Wi-Fi',
        'Wardrobe',
        'Dining Area',
        'Tiled Floor',
        '24-hour Electricity',
        'Air Conditioning',
        'Chandelier',
        'Dishwasher',
        'Hot Water',
        'Kitchen Cabinets',
        'Pre-Paid Meter',
        'Refrigerator',
        'Microwave',
        'Pop Ceiling',
        'Sectionals',
        'TV',
        'Balcony',
        'Parking Space',
        'Jacuzzi Bath',
        'En suites',
        'Ensuite',
    ],
    5105: [
        'Electricity Supply',
        'Gas Supply',
        'Car Parking',
        'Domestic Sewage',
        'Rain Water Drainage',
        'Water Supply',
    ],
    default: [
        'Constant light',
        'Fully furnished',
        'Gated',
        'Furnished',
        'Tarred Road',
        'Semi furnished',
        'C of O',
        'Security',
    ],
};
// Services
const servicesType = {
    5201: [
        'Accounting',
        'Office Service',
        'Writing & Literature',
        'General Office Services',
        'Marketing',
        'Storage',
        'Health & Safety',
        'Courier Services',
        'Recruitment',
        'Advertising Agencies',
        'Leaflet Distribution',
        'Interpreting & Translation',
        'Secretarial Services',
        'Shipping',
        'Printing Services',
        'Tax & Financial services',
        'Other',
    ],
    5202: [
        'Griller',
        'Mesuya',
        'Nutritionist',
        'Restaurants and Bars',
        'Caterer',
        'Groceries',
        'Baker',
        'Chef',
        'Cook',
        'Others',
    ],
    5203: [
        'Photography & Film',
        'Cars & Transportation',
        'Catering & Services',
        'Organisers & Planners',
        'Entertainment',
        'Marquee Hire',
        'Other',
    ],
    5204: ['Babysitting', 'Nannies', 'Childminders', 'Creche', 'Other'],
    5205: [
        'Cleaners',
        'Property Maintenance Services',
        'Housekeepers',
        'Facility managers',
        'Interior Designers',
        'Satellite, Aerial & TV',
        'Drain & Pipe Cleaning',
        'Other',
    ],
    5206: [
        'Lessons',
        'Online',
        'Private Teacher',
        'Training',
        'Academic',
        'Driving Lessons & Instructors',
        'Music',
        'Other',
    ],
    5207: ['Seamstress', 'Tailoring', 'Dry Cleaning & Laundry', 'Other'],
    5208: [
        'Taxi Services',
        'Detailing Services',
        'Car Wash',
        'Auto-tuning Services',
        'Car Repair',
        'Other',
    ],
    5209: [
        'DJ & Disco Hire',
        'Entertainers',
        'Bands & Musicians',
        'Banqueting Facilities',
        'Sound Engineering',
        'Rental Equipments',
        'Music Production',
        'Master of Ceremony Services',
        'Other forms of entertainment',
        'Other',
    ],
    5210: ['Travel & tourism agent', 'Ticketing & Reservation', 'Other'],
    5211: [
        'Manufacturers',
        'Distributors',
        'Writing & Literature',
        'Wholesalers',
        'Retailers',
        'Other',
    ],
    5212: [
        'Business Name Registration',
        'Registration Services',
        'Registration of Business',
        'Preparation of Documents',
        'Legal Consultation',
        'Assignment Deed',
        'Contracts Drafting',
        'Legal Bookkeeping',
        'Land & Property Search',
        'Mediation and Arbitration',
        'Ownership Restructuring',
        'Product Registration',
        'Property Consultant',
        'Real Estate Transactions',
        'Representation of Interests',
        'Civil Proceedings',
        'Clients representation',
        'Sale Contracts',
        'Drafting and Negotiation of NDAs',
        'Review, Negotiation, and Drafting',
        'Trademark Register',
        'Vehicle License Registration',
        'Wills Drafting Services',
        'Other',
        'Mortgage Brokers',
        'Financial Advice',
        'Visa & Immigration',
        'Other',
    ],
    5213: [
        'Car Hire',
        'Bus & Coach',
        'Van & Truck Hire',
        'Taxi',
        'Chauffeur & Limousine Hire',
        'Vehicle Hire',
        'Coach Hire',
        'Other',
    ],
};
const tutorialTopics = [
    'Entrepreneurship',
    'Instruments',
    'IT Certifications',
    'Online Education',
    '3D & Animation',
    'Algebra & Geometry',
    'Advertising',
    'Application Software',
    'Architectural Design',
    'Arts & Crafts',
    'Beauty & Make-Up',
    'Biology',
    'Blockchain & Cryptocurrency',
    'Business Intelligence',
    'Business Software',
    'CAD',
    'Calculus',
    'Career Development',
    'Chemistry',
    'Cloud Services',
    'Communication Skills',
    'Computer Systems Analyst',
    'Content Marketing',
    'Creativity',
    'Data Analysis',
    'Development Tools',
    'Digital Marketing',
    'Digital Photography',
    'Electrical Engineering',
    'English',
    'Fashion Design',
    'Fitness',
    'French',
    'Game Development',
    'German',
    'Graphic Design',
    'Information Technology',
    'IT Security',
    'Interior Design',
    'Management & Leadership',
    'Media',
    'Mobile Apps Development',
    'Network & Security',
    'Music Fundamentals',
    'Product Design',
    'Physics',
    'Product Marketing',
    'Programming Languages',
    'Project Management',
    'Real Estate',
    'Video Editing',
    'Test Prep',
    'Other',
];

// Agriculture
const agricultureTypes = {
    5301: [
        'All',
        'Fish',
        'Snails',
        'Sheeps',
        'Roosters',
        'Pigs',
        'Ostriches',
        'Guinea Fowls',
        'Geese',
        'Ducks',
        'Cane Rats',
        'Cows',
        'Turkeys',
        'Rabbits',
        'Fish',
    ],
    5302: [
        'Palm oil',
        'Rice',
        'Palm kernel',
        'Cassava',
        'Cocoa',
        'Corn',
        'Wheat',
        'Cowpea',
        'Soybean',
        'Cotton',
        'Beans',
        'Other',
    ],
    5303: [
        'Egg Incubators',
        'Knapsack Sprayers',
        'Fish Ponds',
        'Tarpaulin',
        'Irrigation Sprinklers',
        'Scales',
        'Cages',
        'Egg Incubators',
        'Hammer Mills',
        'Irrigation Hoses',
        'Milling Machines',
        'Power Tillers',
        'Rice Destoners',
        'Rice Reapers',
        'Seed Planters',
        'Seed Trays',
        'Weeding Machines',
        'Drinkers',
        'Tiling machine',
        'Filters',
        'Poultry Vaccinators',
        'Seed Trays',
    ],
    5304: [
        'Feeds',
        'Flower Seeds',
        'Supplements',
        'Vegetables Seeds',
        'Fruit Seeds',
        'Herb Seeds',
        'Perennia',
        'Other',
    ],
    5305: [
        'Feeds',
        'Flower Seeds',
        'Supplements',
        'Vegetables Seeds',
        'Fruit Seeds',
        'Herb Seeds',
        'Perennia',
        'Other',
    ],
};
// Electronics
const displaySizes = [
    '10.1"',
    '11" / 11.6"',
    '12" / 12.3"',
    '13" / 13.3"',
    '15" / 15.6"',
    '16"',
    '17" / 17.3"',
    '19"',
    '20.1"',
    '21"',
    '21" and more',
];
const electronicsBrands = {
    5401: [
        'Apple',
        'Dell',
        'HP',
        'Logitech',
        'Universal',
        '4K',
        '4K Ultrahd',
        '4K Hdmi',
        'Acer',
        'Adesso',
        'Airspace',
        'Airtel',
        'Alienware',
        'Allsop',
        'Aluratek',
        'Anker',
        'Aoc',
        'APC',
        'ASUS',
        'Atlantic',
        'Atlona',
        'Barcode Scanner',
        'Baseus',
        'Belkin',
        'Benq',
        'Blackbook',
        'Bluegate',
        'Bolt',
        'BTI',
        'Buyor',
        'Canon',
        'Ch-31',
        'ChargeHub',
        'Chupez',
        'Cisco',
        'Coolbell',
        'CORSAIR',
        'Crossfire',
        'Crown',
        'Cursor',
        'CyberPower',
        'D-Link',
        'Das Keyboard',
        'Dermalog',
        'Digirich',
        'Digital Innovations',
        'Digital Persona',
        'Dynex',
        'E-Clips',
        'Eaget',
        'Eagle',
        'Earldom',
        'Eaton',
        'Enet',
        'ENHANCE',
        'Epson',
        'Ethernet',
        'Evergood',
        'Ezcap',
        'Fellowes',
        'Fujitsu',
        'Futronic',
        'Gaomon',
        'Garmin',
        'Generic',
        'Genius',
        'Google Chrome Cast',
        'Greenlion',
        'Halo',
        'Havit',
        'Haysenser',
        'Hikvision',
        'Hiti',
        'Hiview',
        'Hsdpa',
        'Huawei',
        'Huion',
        'Hyper',
        'HyperX',
        'iBenzer',
        'Incase',
        'Infocus',
        'Itel',
        'j5create',
        'Jabra',
        'Jaster',
        'Jbl',
        'Jedel',
        'Juiceboxx',
        'Kaspersky',
        'Kensington',
        'Key Digital',
        'Keychron',
        'Kingston',
        'Kodak',
        'Kojak Integrated',
        'Kojak Scanner',
        'Kston',
        'Kvm',
        'Kyocera',
        'Lacie',
        'LandingZone',
        'LapGear',
        'Ldnio',
        'Ledetech',
        'Ledger',
        'Lenovo',
        'Lg',
        'Lion',
        'Mac Book',
        'Marsriva',
        'Maxtron',
        'Meetion',
        'Mercury',
        'Microkingdom',
        'Micron',
        'Microsoft',
        'Millennals',
        'Mind Reader',
        'Moshi',
        'Mousepad',
        'Mtn',
        'Netlink',
        'New Age',
        'Nexigo',
        'Norton',
        'Olax',
        'Optoma',
        'Oraimo',
        'Panamax',
        'Panasonic',
        'Penclic',
        'Philips',
        'Porodo',
        'Powerology',
        'Prestige',
        'Qlt',
        'Quick Heal',
        'Rapoo',
        'Razer',
        'REDRAGON',
        'Ricoh',
        'ROCCAT',
        'Romoss',
        'SaharaCase',
        'Samsung',
        'Sandisk',
        'Sanyo',
        'Satechi',
        'Seagate',
        'Secugen',
        'Sharp',
        'Sk Hynix',
        'Smaat',
        'Sony',
        'Spectranet',
        'Starlink',
        'Startech.Com',
        'SteelSeries',
        'Targus',
        'Teamgroup',
        'Telenet',
        'TG3 Electronics',
        'Topaz',
        'Toshiba',
        'TP-Link',
        'Transcend',
        'Transparent',
        'Tt eSPORTS',
        'Twelve South',
        'Ucom',
        'Ugreen',
        'Unbranded',
        'Verbatim',
        'Vinsa',
        'Vivateck',
        'Wacom',
        'WD',
        'Western Digital',
        'Wiwu',
        'X&X',
        'Xiaomi',
        'Xp-Pen',
        'Xprinter',
        'Yoobao',
        'Zealot',
        'Zinox',
        'ZKTeco',
        'Zornwee',
        'ZTE',
        'Other',
    ],
    5402: [
        'HP',
        'Dell',
        'Samsung',
        'LG',
        'Asus',
        'Acer',
        'Alienware',
        'AOC',
        'Apple',
        'Aser',
        'BenQ',
        'Cisco',
        'Fujitsu',
        'Generic',
        'Hanns G',
        'Hisense',
        'Iiyama',
        'Lenovo',
        'Maxview',
        'Medion',
        'MSI',
        'NEC',
        'Newsync',
        'Philips',
        'Porodo',
        'Sceptre',
        'Smaat',
        'Terra',
        'ViewSonic',
        'Xiaomi',
        'Other',
    ],
    5403: [
        'Apple',
        'JBL',
        'Oraimo',
        'Samsung',
        'Sony',
        '1More',
        'A-Audio',
        'Abingo',
        'Accering',
        'Accessonico',
        'Accessory House',
        'Acctrend',
        'Accutone',
        'Acekool',
        'Aceyoon',
        'Acid Eye',
        'Acure',
        'ADJ',
        'Affordable',
        'Aftershokz',
        'Aigital',
        'Ailihen',
        'Ainope',
        'Air Pro',
        'Airbuds',
        'Airpod Skins',
        'Airsounds',
        'AKG',
        'Akz',
        'Alctron',
        'Altec Lansing',
        'Alti Brands',
        'Amazonbasics',
        'Ambar',
        'American Audio',
        'Anker',
        'Antiee',
        'Aproca',
        'Artix',
        'Astro',
        'Audi',
        'Audio-Technica',
        'Audiomate',
        'Aukey',
        'Avantree',
        'Avid',
        'Awei',
        'B39',
        'Banbrick',
        'Bang & Olufsen',
        'Baseman',
        'Baseus',
        'Bass Jaxx',
        'Bcelife',
        'Be Headwear',
        'Beats',
        'Beexcellent',
        'Behringer',
        'Belkin',
        'Beyerdynamic',
        'Blaupunkt',
        'Blueant',
        'Bluedio',
        'Boomph',
        'Bose',
        'Boss',
        'Bosstouch',
        'Brookstone',
        'Bryte Gear',
        'BT',
        'C&E',
        'Candy',
        'Catheadset',
        'Catnee',
        'Celebrat',
        'Cisco',
        'Clarity',
        'Clearsounds',
        'Cloud Fox',
        'Cool Elephant',
        'Coolcat',
        'Corsair',
        'Cowin',
        'Cygnett',
        'D-power',
        'Damson',
        'Dell',
        'Digifon',
        'Direct Sound',
        'Doqaus',
        'Dudios',
        'Ear Bud',
        'Earbudi',
        'Earstudio',
        'Edifier',
        'Enjoy-Unique',
        'Evisu',
        'Fil',
        'Fineblue',
        "Fresh 'n Rebel",
        'Gabba Goods',
        'Generic',
        'Genius',
        'Gerleek',
        'Google',
        'Grde',
        'Greenlion',
        'Groove',
        'H Hifihear',
        'Harman Kardon',
        'Havit',
        'HBQ',
        'Hello Kitty',
        'Hi-Fi',
        'Hifi Walker',
        'Hiotech',
        'Hoco',
        'House Of Marley',
        'HP',
        'Hspro',
        'HTC',
        'Huawei',
        'Humixx',
        'Hyperx',
        'I9S',
        'Icon',
        'Ifrogz',
        'Ihip',
        'Ihome',
        'Ilogic',
        'IMax',
        'Infinix',
        'Interphone',
        'Itel',
        'J&L Brands',
        'Jabra',
        'JAM',
        'Jaybird',
        'Jays',
        'Jlab',
        'JVC',
        'Kitsound',
        'Klipsch',
        'Kptec',
        'KRK',
        'Kscat',
        'KZ',
        'Lenovo',
        'Letsfit',
        'LG',
        'Lightimetunnel',
        'Logitech',
        'Lstn Sound',
        'Magnavox',
        'Maono',
        'Marley',
        'Marshall',
        'Megadream',
        'Merkury Innovations',
        'Meze',
        'Microkingdom',
        'Microsoft',
        'Mifo',
        'MK',
        'Mol',
        'Monster',
        'Monster High',
        'Motorola',
        'Moxom',
        'Mpow',
        'MSI',
        'Ncredible',
        'Neewer',
        'New Age',
        'New Bee',
        'Nia',
        'Noisehush',
        'Nokia',
        'Numark',
        'NYZ',
        'Oculus',
        'Olaf',
        'Omnitech',
        'Oneodio',
        'Oneplus',
        'Onikuma',
        'ONN',
        'Oppo',
        'Orit',
        'P47',
        'P9',
        'Philips',
        'Pinna Labs',
        'Pioneer',
        'Pioneer Dj',
        'Plantronics',
        'Playstation',
        'Pom Gear',
        'Poolee',
        'Porodo',
        'Powerbeast',
        'Powerneer',
        'Presonus',
        'Pro 750',
        'Proht',
        'Promate',
        'Pzoz',
        'QCY',
        'QKZ',
        'Rane',
        'Rapoo',
        'Razer',
        'Realme',
        'Recrsi',
        'Redmi',
        'Remax',
        'RHA',
        'Rock Space',
        'Rocketfish',
        'Ryobi',
        'S2E',
        'Samson Technologies',
        'Sennheiser',
        'Sentry',
        'Shenzhen',
        'Shhr',
        'Shplus',
        'Shure',
        'Silverstone Technology',
        'Skullcandy',
        'Skybuds',
        'Smart Walkie',
        'Sms Street',
        'Sodo',
        'Sol Republic',
        'Sonixx',
        'Soundcore',
        'Soundmagic',
        'Soundpeats',
        'Spigen',
        'Sports Pro',
        'Steelseries',
        'Sudio',
        'Super Me',
        'Takstar',
        'Tall Plus',
        'Targus',
        'Tayogo',
        'Techcode',
        'Tecno',
        'Threecat',
        'Transparent',
        'Tribit',
        'Tronic Master',
        'Trueaudio',
        'Tucci',
        'Turtle Beach',
        'Twayrdio',
        'TWS',
        'Unbrand',
        'Urbanears',
        'Usams',
        'V-Moda',
        'Vivitar',
        'Vivtar',
        'Vjjb',
        'Weile',
        'Wesc',
        'Winwolf',
        'WIW',
        'WXY',
        'XBT',
        'Xiaomi',
        'Xpower',
        'Yamaha',
        'Yison',
        'Yoga',
        'Yogo',
        'Yokon',
        'Yoobao',
        'Zealot',
        'Other',
    ],
    5404: [
        'Canon',
        'Epson',
        'HP',
        'Konica Minolta',
        'Sharp',
        '3D Systems',
        '3M',
        'Acer',
        'Adesso',
        'Agfa',
        'Avision',
        'Bixolon',
        'Black Box',
        'Brady',
        'Brother',
        'Buyor',
        'Card Scanning Solutions',
        'Casio',
        'Citizen',
        'CZUR',
        'Datacard',
        'Datamax',
        'Dell',
        'Develop',
        'DigitalPersona',
        'DNP',
        'Dymo',
        'ECTACO',
        'Evolis',
        'Fargo',
        'Fujitsu',
        'Geeetech',
        'General',
        'Gestetner',
        'HID',
        'HiTi',
        'Honeywell',
        'HPE',
        'IBM',
        'IRIS',
        'Kodak',
        'Kojak',
        'Kyocera',
        'Lexmark',
        'LG',
        'Magnasonic',
        'Mercury',
        'Minolta',
        'Mitsubishi',
        'Mustek',
        'Neat',
        'NEC',
        'Nikon',
        'OKI',
        'Olivetti',
        'Olympus',
        'Output Technology',
        'Panasonic',
        'Pantum',
        'PeriPage',
        'Phomemo',
        'PlanOn',
        'Plustek',
        'Ricoh',
        'RISO',
        'Rollo',
        'Samsung',
        'Sawgrass',
        'Sharper Image',
        'Sony',
        'Star Micronics',
        'Suprema',
        'Toshiba',
        'Unbranded',
        'Utax',
        'Veeda',
        'Xerox',
        'Xiaomi',
        'Xprinter',
        'XYZprinting',
        'Yinghe',
        'Zebra',
        'ZyXEL',
        'Other',
    ],
    5405: [
        'Cisco',
        'D-Link',
        'MTN',
        'TP-Link',
        'Ubiquiti Networks',
        '2Wire',
        '3Com',
        '9Mobile',
        'Acer',
        'ACP',
        'Action-Tec',
        'Aico',
        'Air Live',
        'Airlink',
        'Airtel',
        'Alcatel-Lucent',
        'Alfa-Net',
        'Alink',
        'Amplifi',
        'Apc',
        'Apple',
        'Arris',
        'Aruba Networks',
        'Ashata',
        'ASUS',
        'AT&T',
        'Avaya',
        'Baofeng',
        'Belkin',
        'Bolt+',
        'Brandrex',
        'BT',
        'Busy',
        'Bvot',
        'Cambium Networks',
        'Channel Vision',
        'Check Point',
        'Chupez',
        'Comfast',
        'Commando',
        'Commscope',
        'Comtrend',
        'CP Technologies',
        'CrystalView',
        'CscoSystems',
        'Dahua',
        'Ddk',
        'Dell',
        'Digi',
        'Dintek',
        'DrayTek',
        'Dtech',
        'Dymo',
        'ElctronicStore',
        'EnGenius',
        'Estream Networks',
        'F-Secure',
        'Fortinet',
        'Gateway',
        'Generic',
        'GigaFast',
        'Glo',
        'Glo Netpro',
        'Google',
        'Grandstream',
        'Hikvision',
        'HiLink',
        'HiLook',
        'HooToo',
        'HP',
        'HPE',
        'Hsdpa',
        'Huawei',
        'Ike',
        'Imose',
        'Itel',
        'Jazz',
        'Jio',
        'Juniper Networks',
        'LB-Link',
        'LevelOne',
        'Linksys',
        'Lintratek',
        'Logitech',
        'Lte Cpe',
        'Maxis',
        'Medialink',
        'Mercusys',
        'Microsoft',
        'MikroTik',
        'Millennals',
        'Moniepoint',
        'Motorola',
        'NEC',
        'NetComm',
        'NetGear',
        'Netis',
        'Netlink',
        'Netpro',
        'Nokia',
        'NovAtel',
        'Ntel',
        'OEM',
        'Olax',
        'Onv',
        'Open Mesh',
        'Optus',
        'Oraimo',
        'Palmpay',
        'Panasonic',
        'PIX-Link',
        'Pro-Net',
        'Rock',
        'Ruckus',
        'S-Tech',
        'Samsung',
        'Shux',
        'Siemens',
        'SKE',
        'Smart',
        'SmartWi',
        'SMC',
        'Smile',
        'Sonicwall',
        'Sony',
        'Sophos',
        'Spectranet',
        'Starlink',
        'StarTech',
        'Swift',
        'Synology',
        'Tecno',
        'Tele2',
        'Telenet',
        'Teltonika',
        'Tenda',
        'Tiger',
        'Tulsat',
        'UniFi',
        'Universal',
        'Uniview',
        'Vida',
        'Vis-Link',
        'Vodafone',
        'Vonets',
        'WatchGuard',
        'Wavlink',
        'Western Digital',
        'Wi-Tek',
        'Wifi Repeater',
        'WirEng',
        'Xiaomi',
        'Yeastar',
        'Zonet',
        'Zong',
        'Zonyer',
        'ZTE',
        'ZyXEL',
        'Other',
    ],
    5406: [
        'Apple',
        'Samsung',
        'Tecno',
        'Infinix',
        'Xiaomi',
        'Acer',
        'AEG',
        'Afrione',
        'Alba',
        'Alcatel',
        'AllCall',
        'Allview',
        'Amazon',
        'Asus',
        'AT Mobile',
        'BlackBerry',
        'Blackview',
        'BLU',
        'Bontel',
        'BQ',
        'Casio',
        'Cat',
        'Coolpad',
        'Cubot',
        'Dell',
        'Doogee',
        'Elephone',
        'Essential Products',
        'Fero',
        'Fly',
        'FreeYond',
        'Gionee',
        'Google',
        'H-mobile',
        'Hisense',
        'HomTom',
        'Honor',
        'Hotwav',
        'HP',
        'HTC',
        'Huawei',
        'i-mobile',
        'Imose',
        'InFocus',
        'iPRO',
        'Iridium',
        'Itel',
        'K-Touch',
        'Kenxinda',
        'Kgtel',
        'Kyocera',
        'Lava',
        'LeEco',
        'Lenovo',
        'LG',
        'Lumigon',
        'Maxfone',
        'Meizu',
        'Mi-Tribe',
        'Microsoft',
        'Mione',
        'Motorola',
        'MTN',
        'Nokia',
        'Nothing Phone',
        'Oale',
        'OnePlus',
        'Oppo',
        'Oukitel',
        'Pantech',
        'Poptel',
        'Qmobile',
        'Qtek',
        'Razer',
        'Realme',
        'RED',
        'S-Mobile',
        'Siccoo',
        'Smart+',
        'Smartisan',
        'SmartOpus',
        'Sony',
        'Sony Ericsson',
        'Sowhat',
        'SQ',
        'Sugar',
        'T-Mobile',
        'TCL',
        'Thuraya',
        'Trifone',
        'Ulefone',
        'Umi',
        'Umidigi',
        'Vernee',
        'Vertu',
        'Vivo',
        'Vodafone',
        'Wiko',
        'X-Tigi',
        'ZTE',
        'Other Brand',
    ],
    5407: [
        'Microsoft',
        'Midas',
        'Mighty Pro Audio',
        'Minirig',
        'MIPOW',
        'Monitor Audio',
        'Mosfet',
        'Motorola',
        'MTX',
        'Mxl',
        'N-Jack',
        'N-Tek',
        'Nektar',
        'NEO',
        'Neutrik',
        'Nevir',
        'Newcastle',
        'NewRixing',
        'NINETEC',
        'Nns',
        'Novation',
        'Numan',
        'Numark',
        'Nunix',
        'Nuvo',
        'Nux',
        'NXG',
        'Oceanic',
        'Omax',
        'OMEGA',
        'Onix',
        'Onkyo',
        'ONN',
        'Onyx Studio 6',
        'Onyx Studio 7',
        'Oraimo',
        'OSD Audio',
        'Oxcarcia',
        'Pan Bose',
        'Panasonic',
        'Peakomar',
        'Pearl',
        'Peavey',
        'Philips',
        'Phoenix',
        'Phonic',
        'Pioneer',
        'PodSpeakers',
        'Polk Audio',
        'Polycom',
        'Polystar',
        'Poolee',
        'Porodo',
        'Power Bass',
        'Powerology',
        'Premier England',
        'PreSonus',
        'Prime Audio',
        'Pro Hero Sound',
        'Pro hero soun',
        'Pro Sound',
        'Proel',
        'Proking',
        'Promic',
        'PRONOMIC',
        'PSB',
        'Pyle',
        'R-MUSIC',
        'Rane One',
        'Razer',
        'REL',
        'Remax',
        'RockJam',
        'Rockview',
        'Rode',
        'Rokit',
        'Roland',
        'Royal',
        'Russound',
        'Sabian',
        'Samick',
        'Samson',
        'Samsung',
        'SANYO',
        'Saramonic',
        'Scarlett',
        'Sea Piano',
        'Sennheiser',
        'Serato',
        'Sharp',
        'Signature',
        'Behringer',
        'JBL',
        'LG',
        'Shure',
        'Yamaha',
        '1 BY ONE',
        'A11',
        'Accuphase',
        'Accurian',
        'Adam',
        'ADC',
        'Adesso',
        'ADIN',
        'Aduro',
        'Advent',
        'Aerial Acoustics',
        'Ahuja',
        'Ailipu',
        'AIRIS',
        'Aiwa',
        'Ajc',
        'Ak Super',
        'Akai',
        'AKASO',
        'Akason',
        'Akb',
        'AKG',
        'Alba',
        'Alctron',
        'Alesis',
        'Allen & Heath',
        'Allison',
        'Alphasonik',
        'Alpine',
        'Altec',
        'Alto',
        'Amaz',
        'Amazon',
        'AMP',
        'Ampex',
        'AMX',
        'Anchor',
        'Anker',
        'Apex',
        'Apogee',
        'Apollo',
        'Apple',
        'Approx',
        'Arcam',
        'ArchiTech',
        'Arcus',
        'Arion Legacy',
        'Ariz Sound',
        'Arturia',
        'Arylic',
        'Asound',
        'Astatic',
        'Atalax',
        'Atlantic',
        'Atlantic Technology',
        'Atrend',
        'Audica',
        'Boncadio',
        'Boombeatz',
        'Boombest',
        'Bosch',
        'BOSE',
        'Boss',
        'Bower',
        'Boya',
        'BRAVEN',
        'Britz',
        'Brookstone',
        'Bt 3401',
        'BUC s',
        'Bugera',
        'BUILT',
        'Bush',
        'Bx8',
        'Bytech',
        'Cabasse',
        'Cadence',
        'Cafini',
        'Camac',
        'Canic',
        'Casio',
        'Castle',
        'CAV',
        'Celestion',
        'Celsus',
        'CENTURY',
        'Champion Sound',
        'Ciare',
        'Cisco',
        'Citronic',
        'Clarity',
        'Classic',
        'Classic Audio',
        'ClearOne',
        'Conkar',
        'Conrad',
        'Coral',
        'Costway',
        'Crate Audio',
        'Crosley',
        'Crown',
        'Cvr',
        'Cydon',
        'D-Marc',
        'Dametek',
        'Damson',
        'Darkblue',
        'Darock Pro Audio',
        'Dart',
        'Db',
        'DBX',
        'De Boss',
        'Dell',
        'Denon',
        'Design Acoustics',
        'Deviale',
        'Devon',
        'Diamond',
        'Digifon',
        'Digitrex',
        'Divoom',
        'Djack',
        'Dji',
        'DMX',
        'Dolphin',
        'Dolvin',
        'DOSS',
        'Drummer Boss',
        'Dsppa',
        'Dvon',
        'DYNASONIC',
        'Eagle',
        'eAudio',
        'Eben',
        'ECHO',
        'Edifier',
        'Elostar',
        'Eltax',
        'Emgold',
        'Eminence',
        'Enkor',
        'Eurolite',
        'Evp',
        'Excellent',
        'Exlg',
        'Extreme',
        'F&D',
        'Fane',
        'Fdb',
        'Fender',
        'FIFINE TECHNOLOGY',
        'First Alert',
        'Focusrite',
        'Furman',
        'Fusion',
        'G-Project',
        'Gear4',
        'Gemini',
        'General',
        'Gipson',
        'Global Link',
        'Glorik',
        'Goodmans',
        'Goodnews',
        'Google',
        'Grace',
        'Grace Digital Audio',
        'Grace Sound',
        'Grammar Sound',
        'Greatsound',
        'Green Lion',
        'Greenlight',
        'Gunice',
        'H&H',
        'H@F',
        'Hallmark',
        'Hamson',
        'Harman Kardon',
        'Hartke',
        'HAVIT',
        'Hi-Max',
        'HiFi Works',
        'High Class',
        'Hisense',
        'Hisonic',
        'Hitachi',
        'Homeflower',
        'Honeywell',
        'Hopestar',
        'Ibanez',
        'Icom',
        'Iloud Micro Monitor',
        'Imc',
        'Infinity',
        'Intempo',
        'ION',
        'Irig Stream',
        'Itel',
        'Jabra',
        'Jaguar',
        'Jamo',
        'Jiepak',
        'JL Audio',
        'Jmlab',
        'John Lewis',
        'Juice',
        'JVC',
        'K35',
        'K8',
        'Karma',
        'Kenwood',
        'Kilpsch',
        'Kimiso',
        'King',
        'Kisonli',
        'Koda',
        'Koleer',
        'Komplete',
        'Korg',
        'KRK',
        'Kustom',
        'L8S',
        'Lava',
        'Lavalier',
        'Lax',
        'Legend',
        'Lensgo',
        'LG XBOOM',
        'Libratone',
        'Lidimi',
        'Line6',
        'Logitech',
        'Lontor',
        'Lp',
        'Lp V6',
        'LTC Audio',
        'Lucky Tone',
        'Luxury Sound',
        'M-Audio',
        'Mackie',
        'Mackkie',
        'Magnat',
        'Magnavox',
        'Magnetic',
        'Majestic',
        'Majority',
        'Maono',
        'Marcsonic',
        'Marshall',
        'Martin Audio',
        'Master Mix',
        'Master Piece',
        'Matushi',
        'Max',
        'Maxell',
        'MEDION',
        'Mega',
        'Meirende',
        'Mercury',
        'Mi',
        'Micro Boom',
        'Temeisheng',
        'Thor',
        'Thorens',
        'THUNDER',
        'Tinmo',
        'Titan',
        'Titanic',
        'Tivoli',
        'Tonor',
        'Toshiba',
        'Tovaste',
        'Tribit',
        'Tronsmart',
        'Trust',
        'Tundra',
        'Tws',
        'UHF',
        'Ulanzi',
        'Ultra',
        'UNITEK',
        'Universal',
        'Universum',
        'Vizio',
        'Volt',
        'Soundmaster',
        'Sp',
        'Speakerlab',
        'Speaqua',
        'Special',
        'Ssl2',
        'Standard (Japan)',
        'Stanton',
        'Steck Audio',
        'Steren',
        'Stereostone',
        'STRONG',
        'Studio Acoustics',
        'Sunbuck',
        'Super Sound',
        'Supersonic',
        'Surpass',
        'Swan',
        'System Audio',
        'T&G',
        'Takstar',
        'Tama',
        'Tannoy',
        'Tascam',
        'TCL',
        'Technics',
        'Tecno',
        'Silver Bird',
        'SilverLabel',
        'Sinclair',
        'Skullcandy',
        'Skytec',
        'Smart',
        'Smarthome',
        'Sonac',
        'Sonance',
        'Sonivia',
        'Sonok',
        'Sonos',
        'Sony',
        'Sonymax',
        'SonyXBoss',
        'Sound Around',
        'Sound Code',
        'Sound Lab',
        'Sound Piece',
        'Sound Prince',
        'Soundcraftsmen',
        'Soundking',
        'Soundklass',
        'Soundlogic',
        'other',
    ],
    5408: [
        'Canon',
        'Dji',
        'Nikon',
        'Panasonic',
        'Sony',
        'AEE',
        'Alpa',
        'Alpha',
        'Andoer',
        'Andowl',
        'Autel',
        'Axis',
        'Baofeng',
        'Benq',
        'Besteker',
        'Blackmagic',
        'Casio',
        'Drone X Pro',
        'Easyn',
        'Epson',
        'Fujifilm',
        'Garmin',
        'GoPro',
        'Hasselblad',
        'Havit',
        'HDRC',
        'Hikvision',
        'Hiview',
        'HP',
        'HVR',
        'ION',
        'JJRC',
        'JVC',
        'Kodak',
        'Konica Minolta',
        'Lumix',
        'Mevo',
        'Ocom',
        'Olympia',
        'Olympus',
        'Pentax',
        'Polaroid',
        'Polo',
        'Polycom',
        'Potensic',
        'Promark',
        'Red5',
        'Samsung',
        'Sandisk',
        'Sanyo',
        'Sharp',
        'Sigma',
        'Universal',
        'Upair',
        'Viewslim',
        'Vivitar',
        'Xiaomi',
        'Yashica',
        'Yongnuo',
        'Yunteng',
        'Other',
    ],
    5409: [
        'HP',
        'Dell',
        'Samsung',
        'LG',
        'Asus',
        'Acer',
        'Alienware',
        'AOC',
        'Apple',
        'Aser',
        'BenQ',
        'Cisco',
        'Fujitsu',
        'Generic',
        'Hanns G',
        'Hisense',
        'Iiyama',
        'Lenovo',
        'Maxview',
        'Medion',
        'MSI',
        'NEC',
        'Newsync',
        'Philips',
        'Porodo',
        'Sceptre',
        'Smaat',
        'Terra',
        'ViewSonic',
        'Xiaomi',
        'Other',
    ],
    5410: [
        'Ausno',
        'Dahua',
        'Generic',
        'Hikvision',
        'ZKTeco',
        '101 Av Inc',
        'A-Zone',
        'Abtech',
        'Acceskings',
        'Alfawise',
        'Alician',
        'Amcrest',
        'Amiccom',
        'Annke',
        'Anran',
        'Anspo',
        'Apexis',
        'Aqara',
        'Arlo',
        'Ashata',
        'Axisvision',
        'Baofeng',
        'Bayit Home',
        'Besd',
        'Blink',
        'BW',
        'Camitel',
        'Cctv Kit',
        'Cctv Power Supply',
        'CencoVision',
        'Centurion',
        'Chloride Uk',
        'Clarion View',
        'Confidence',
        'Costar',
        'CP Plus',
        'Cytex Vision',
        'D-Link',
        'D-Tech',
        'DBM',
        'Dcsec',
        'Detrinity',
        'Digiteck',
        'Dji',
        'EasyN',
        'Eufy',
        'Eversecu',
        'Evertech',
        'Ezviz',
        'Focus',
        'Fourthvision',
        'Garrett',
        'Gawker',
        'Gent',
        'Geovision',
        'Google',
        'GrandVision',
        'GSA',
        'GW Security',
        'GZ SONY',
        'HDVD',
        'HDview',
        'HI Xmedia',
        'Hikview',
        'HiLook',
        'Hiseeu',
        'Hivideo',
        'Honeywell',
        'Huawei',
        'Huaxing',
        'Hybrid',
        'Ike',
        'Imou',
        'Intelligent Lock',
        'Ivtech',
        'Jooan',
        'Jovision',
        'JVC',
        'Kolaura',
        'Kubix',
        'Lechange',
        'Logitech',
        'Longse',
        'Lorex',
        'Low Power',
        'M-Teck',
        'Majestic',
        'Mapesen',
        'Motorola',
        'MultiStar',
        'N-Track',
        'Nemtek',
        'Nest',
        'Optimax',
        'Oscarvision',
        'P T Z Solar Camera',
        'Panasonic',
        'Paxvision',
        'Polyvision',
        'Powerology',
        'Proline Uk',
        'Prolynx',
        'PTZ',
        'Reolink',
        'Ring',
        'Safehome',
        'Samsung',
        'Sannce',
        'Seagate',
        'Sheenwang',
        'Skyvision',
        'Smart Security Club',
        'Smart View',
        'Smartlock',
        'SmartSF',
        'Sonoff',
        'Sony',
        'Sricam',
        'Stanificent',
        'Techtronica',
        'TP-Link',
        'Tuya',
        'Ubiquiti',
        'UK Link',
        'Uniview',
        'Veecome',
        'Videosecu',
        'Viewtec',
        'Vitek CCTV',
        'Vivotek',
        'Vr Cam',
        'Vstarcam',
        'Wanscam',
        'Wansview',
        'Watchmen',
        'Wd Purple',
        'Wecas',
        'Wietec',
        'Winsposse',
        'World Vision',
        'Xiaomi',
        'XMeye',
        'Zebronics',
        'Zmodo',
        'ZunVision',
        'Other',
    ],
    default: [
        'HP',
        'Dell',
        'Apple',
        'Lenovo',
        'Asus',
        '3XS',
        'Acer',
        'Advent',
        'Airis',
        'Alienware',
        'Avantis',
        'Brian',
        'Chuwi',
        'Clevo',
        'Compaq',
        'Cyberpower',
        'CyberpowerPC',
        'E-System',
        'EduPad',
        'eMachines',
        'Evoo',
        'Fujitsu',
        'Gateway',
        'Geo',
        'Gigabyte',
        'Google',
        'Haier',
        'Huawei',
        'i-Life',
        'iBUYPOWER',
        'Itel',
        'LG',
        'Linx',
        'Maingear',
        'Medion',
        'Microsoft',
        'Monster',
        'MSI',
        'NEC',
        'Nextbook',
        'Nokia',
        'Novatech',
        'Origin PC',
        'Packard Bell',
        'Panasonic',
        'Prostar',
        'Razer',
        'RM Minibook',
        'Sager',
        'Samsung',
        'Sony',
        'Stone',
        'Toshiba',
        'Touchmate',
        'Trekstor',
        'Vinovo',
        'Xiaomi',
        'XPG Adata',
        'Yepo',
        'Yoga',
        'Zinox',
        'Zoostorm',
        'Other',
    ],
};
const electronicsType = {
    5404: [
        'Dot-Matrix Printer',
        'Flatbed Scanner',
        'Ink-Jet Printer',
        'Laser Printer',
        'Photo Printer',
        'Photocopier',
        'Portable Scanner',
        'Sheet-Fed Scanner',
        'Other',
    ],
    5405: [
        'Access Point',
        'IP Phones',
        'Mifi',
        'Modem',
        'Network Cables',
        'Router',
        'Switch',
        'WiFi Repeater',
        'Other',
    ],
    5407: [
        'Speakers',
        'Microphones',
        'Home Theater Systems',
        'Sound Systems',
        'Music Mixers',
        'Acoustic Shields & Panels',
        'Amplifiers',
        'Audio Compressors & Limiters',
        'Audio Interfaces',
        'Cassette Players',
        'CD Players',
        'DJ Controller',
        'DJ Mixers',
        'Drum Machines',
        'Equalizers',
        'Hi-Fi Systems',
        'Karaoke',
        'Loudspeakers & Subwoofers',
        'Megaphones',
        'Midi Controllers',
        'MP3 Players',
        'PA Systems',
        'Radios',
        'Receivers',
        'Soundcards',
        'Studio Monitors',
        'Turntables',
        'Voice Recorders',
        'Walkie Talkies',
        'Other',
    ],
    5408: [
        'Action Cameras',
        'Digital Cameras',
        'Drones',
        'DSLR Cameras',
        'Film Cameras',
        'Video Cameras',
        'Other',
    ],
    5410: [
        'Access Control',
        'CCTV Camera',
        'CCTV Kit',
        'CCTV Tester',
        'Digital Video Recorder',
        'IP Camera',
        'Motion Detector',
        'Nanny Cams',
        'Spy Clock',
        'Spy Glasses',
        'Spy Pen',
        'Other',
    ],
    default: null,
};
// Fashion
const fashionBrands = {
    5501: [
        'Louis Vuitton',
        'Alberto Fellini',
        'Adidas',
        'Prada',
        'Versace',
        'Gucci',
        'Air Jordan',
        'Ralph Lauren',
        'Aldo',
        'Balmain',
        'Zanotti',
        'Akube',
        'Aristocrats',
        'Balmain',
        'Ben Sherman',
        'Benetton',
        'Astley Clarke',
        'Armani',
        'Asics',
        'Diadora',
        'DKNY',
        'Dockers',
        'Dolce & Gabbana',
        'DC Shoes',
        'Dunnes',
        'Emporio Armani',
        'Everest',
        'F&F',
        'Fabi',
        'Nike',
        'Other',
    ],
    5503: [
        'Louis Vuitton',
        'Alberto Fellini',
        'Prada',
        'Versace',
        'Gucci',
        'Air Jordan',
        'Ralph Lauren',
        'Aldo',
        'Balmain',
        'Zanotti',
        'Akube',
        'Aristocrats',
        'Balmain',
        'Ben Sherman',
        'Benetton',
        'Astley Clarke',
        'Armani',
        'Asics',
        'Diadora',
        'DKNY',
        'Dockers',
        'Dolce & Gabbana',
        'DC Shoes',
        'Dunnes',
        'Emporio Armani',
        'Everest',
        'F&F',
        'Fabi',
        'Other',
    ],
    5504: [
        'Adore',
        'Affinity Diamond Jewelry',
        'Aldo',
        'Versace',
        'Alexander McQueen',
        'Alfani',
        'Amore',
        'Aldo',
        'Alpha',
        'Aker',
        'Anne Klein',
        'Apollo',
        'Balmain',
        'AURA',
        'Bead Bracelet',
        'Blackstone',
        'Armani',
        'Fendi',
        'Diadora',
        'DKNY',
        'Dockers',
        'Dolce & Gabbana',
        'Cerruti',
        'CHANEL',
        'Cartier',
        'Dior',
        'F&F',
        'Emporio Armani',
        'Other',
    ],
    5506: [
        'Rolex',
        'Hublot',
        'Cartier',
        'Patek Philippe',
        'Acnos',
        'Aigner',
        'Aimecor',
        'Alexandre Christie',
        'Alpha',
        'Aker',
        'Anne Klein',
        'Antoine Preziuso',
        'Apple Watch',
        'Armitron',
        'Baogela',
        'Baume & Mercier',
        'Bell & Ross',
        'Benma',
        'Benyar',
        'Bomberg',
        'Bos',
        'Dolce & Gabbana',
        'Bovet',
        'Bulova',
        'Cartier',
        'Dior',
        'F&F',
        'Emporio Armani',
        'Other',
    ],
    5507: [
        'Weddingstar',
        'Vera Wang',
        'Super Jeweler',
        'Versace',
        'S.L. Fashions',
        'R&M Richards',
        'Nina',
        'LEIN',
        'Jewel',
        'J Kara',
        'Ivory',
        'Grace Loves Lace',
        'Generic',
        'Fifteen Roses',
        'Fair Lady',
        'Ever-Pretty',
        'Aidan Maddox',
        'Amazon Essentials',
        "David's Bridal",
        'Adrianna Papell',
        'Amsale',
        'Atelier Emelia',
        'Claire Pettibone',
        'Emporio Armani',
        'Dreamgirl',
        'Chopard',
        'Fabi',
        'Other',
    ],
    default: [
        'Louis Vuitton',
        'Hermes',
        'Prada',
        'Versace',
        'Gucci',
        'Adire',
        'Ralph Lauren',
        'Aldo',
        'Balmain',
        'Zanotti',
        'Akube',
        'Asooke',
        'Balmain',
        'Ben Sherman',
        'Benetton',
        'Astley Clarke',
        'Armani',
        'Asics',
        'Other',
    ],
};
const fashionTypes = {
    5501: [
        'Loafers',
        'Sandals',
        'Sneakers',
        'Slippers',
        'Boots',
        'Ballet Shoes',
        'Canvas',
        'Chelsea Boots',
        'Clogs',
        'Crocs',
        'Flip-Flops',
        'Brogues',
        'Football Boots',
        'Half Shoes',
        'Moccasins',
        'Slides',
        'Slingbacks Shoes',
        'Snow Boots',
        'Trainers',
        'Wedge Shoes',
        'Other',
    ],
    5503: [
        'Luggage & Travel Bags',
        'Handbags',
        'Shoulder Bags',
        'Backpacks',
        'Clutches',
        'Ankara Bags',
        'Baby & Diaper Bags',
        'Bags Accessories',
        'Baguette Bags',
        'Barrel Bags',
        'Beach Bags',
        'Bra & Lingerie Travel Cases',
        'Brady Bags',
        'Briefcases',
        'Bucket Bags',
        'Business Bags',
        'Carry-All Bags',
        'Chain Bags',
        'Clothes Storage Bags',
        'Crossbody Bags',
        'Doctor Bags',
        'Duffle Bags',
        'Envelope Bags',
        'Flap Bags',
        'Rope Bags',
        'Saddle Bags',
        'School Bags',
        'Tennis Bags',
        'Tote Bags',
        'Vanity Cases',
        'Acetate',
        'Bamboo',
        'Other',
        'Make-Up Bags & Organizers',
        'Lunch Bags',
        'Micro Bags',
        'Lunch Bags',
        'Laptop Bags & Cases',
        'Waist & Belt Bags',
        'Suitcases',
        'Mini Bags',
        'Satchel Bags',
        'Gym & Sport Bags',
        'Gift Bags',
        'Fishing Bags',
        'Flap Bags',
        'Rucksack',
        'Other',
    ],
    5504: [
        'Necklaces',
        'Bracelets',
        'Jewellery Sets',
        'Earrings',
        'Chains',
        'Bangles',
        'Beaded Jewelry',
        'Body Piercing Jewelry',
        'Brooches',
        'Choker Necklaces',
        'Costume Jewelry',
        'Ear Cuffs',
        'Cufflinks',
        'Ear Cuffs',
        'Jewellery Boxes',
        'Pendants',
        'Rings',
        'Stones & Beads',
        'Teeth Grills',
        'Wristbands',
        'Other',
    ],
    5507: [
        'Rings',
        'Bridal Dresses',
        'Suits',
        'Fans & Parasols',
        'Bouquets',
        'Belts & Sashes',
        'Bridal Hair Accessories',
        'Bridal Jewelry',
        'Bridal Robes',
        'Bridesmaid Dresses',
        'Bridesmaid Robes',
        'Handbags & Bags',
        'Fascinators',
        'Invitations',
        'Shoes',
        'Veils',
        'Wedding Gloves',
        'Wraps & Jackets',
        'Other',
    ],
    default: [
        'Fabrics',
        'Suits',
        'Polo',
        'Jeans',
        'Blouses',
        'Shirts',
        'Blazers',
        'Activewear & Sportswear',
        'Jackets & Coats',
        'Joggers',
        'Dresses',
        'Skirts',
        'Pants',
        'Sleepwear & Pyjamas',
        'Socks & Tights',
        'Sweatshirts & Hoodies',
        'Vests',
        'T-Shirts & Tanks',
        'Tuxedos',
        'Jalabiya',
        'Other',
    ],
};
const fashionMaterials = {
    5504: [
        'Gold',
        'Leather',
        'Platinum',
        'Silver',
        'Stainless Steel',
        'Acrylic',
        'Cobalt',
        'Glass',
        'Nickel',
        'Niobium',
        'Palladium',
        'Rhodium',
        'Titanium',
        'Tungsten',
        'Zinc',
        'Other',
    ],
    5506: [
        'Aluminium',
        'Ceramic',
        'Faux Leather',
        'Genuine Leather',
        'Nylon',
        'Polyurethane',
        'Rubber',
        'Stainless Steel',
        'Wood',
        'Other',
    ],
    default: [
        'Voile',
        'Wool',
        'Silk',
        'Polyester',
        'Denim',
        'Cotton',
        'Synthetic',
        'Suede',
        'Velvet',
        'Polycotton',
        'Plastic',
        'Plush',
        'Organza',
        'Net',
        'Nylon',
        'Mesh',
        'Merino Wool',
        'Jersey',
        'Lycra',
        'Latex',
        'Leather',
        'Linen',
        'Flax',
        'Faux Silk',
        'Chiffon',
        'Fur',
        'Corduroy',
        'Brocade',
        'Acrylic',
        'Acetate',
        'Bamboo',
        'Other',
    ],
};
const fashionSizes = {
    5501: ['35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', 'Other'],
    default: ['XL', 'S', 'M', 'XXL', 'L', 'XS', '3XL', '4XL'],
};

// health category
const healthProductFormulation = {
    5603: ['Oil', 'Pencil', 'Roll-on', 'Body spray'],
    default: [
        'Capsule',
        'Drink',
        'Liquid',
        'Powder',
        'Tablets',
        'Caplet',
        'Chewable',
        'Cream',
        'Crystal',
        'Drops',
        'Effervescent Powder',
        'Effervescent Tablet',
        'Gel',
        'Granule',
        'Gum',
        'Gummy',
        'Lozenge',
        'Nutritional Bar',
        'Oil',
        'Paste',
        'Pills',
        'Sachet',
        'Shake',
        'Softgel',
        'Solid',
        'Spray',
        'Stick',
        'Strip',
        'Suppository',
        'Tea',
        'Other',
    ],
};
const healthBrands = {
    5601: [
        'Avon',
        'Aura',
        'Alorepair',
        'Beyond Beauty',
        'Blush',
        'African Pride',
        'Bellezza',
        'Bronner Brothers',
        'Clinic Plus',
        'Creme Of Nature',
        'Dove',
        'Dax',
        'Essence',
        'Fanola',
        'Garnier',
        'Astley Clarke',
        'Armani',
        'Hawaiian Silky',
        'Just For Men',
        "L'Oreal",
        'Mac',
        'Mielle',
        'DC Shoes',
        'Dunnes',
        'Himalaya',
        'Oriflame',
        'Nature Republic',
        'Revlon',
        'Other',
    ],
    5602: [
        'Greenlife',
        'Gsk',
        'GU',
        'H.H.N.P',
        'Hairfinity',
        'Hamdard',
        'Hawaii Pharm',
        'Health Garde',
        'Healthaid',
        'Healthpath Natural',
        'Healthy Mood',
        'Healthy Origins',
        'Hella',
        'Hemani',
        'Hempworx',
        'Herbal Delight',
        'Heshoutang',
        'Hi-Tech',
        'Himalaya',
        'Himalaya Health Care',
        'Himalaya Herbals',
        'Horbaach',
        'Iforce Nutrition',
        'Ironmaxx',
        'Irwin Naturals',
        'J-Chen',
        'Jamu Elita',
        'Jarrow Formulas',
        'Jiangang',
        'Jianxi',
        'Jigsimur',
        'Joju',
        'Juice Plus+',
        'Juvenate',
        'KAL',
        'Kedi',
        'Kedi Healthcare',
        'Kenbroth',
        'Kind',
        'Kirkland Signature',
        'Kosdaq',
        'Kumiko',
        'Kyolic',
        "L'Il Critters",
        'Ladies Shine',
        'Lamosa',
        'Lennox',
        'Lexi',
        'Life Extension',
        'Lilong',
        'Livegood',
        'Livepure',
        'Longrich',
        'Lucky Brand',
        'Magnum',
        'Major',
        'Mannatech',
        'Maritzmayer',
        'Mason Natural',
        'Max Factor',
        'Max International',
        'Megafood',
        'Meiji',
        'Mejic',
        'Met-Rx',
        'Milnapath',
        'Min Min',
        'Miracell',
        'Miracle Seed Ultima',
        'Miracle White',
        'Miss Smarty Pants',
        'Multistream',
        'Muscle Milk',
        'Muscletech',
        'Mutant',
        'Myprotein',
        'Natrol',
        'Naturade',
        'Natural Access',
        'Natural Factors',
        'Natural Vitality',
        'Nature Craft',
        'Nature Cure',
        'Nature Leaf',
        'Nature Made',
        "Nature's Answer",
        'Schiff',
        'Scitec Nutrition',
        'Secret',
        'Seven Seas',
        'Shineway',
        'Shineway Healthcare',
        'Six Star',
        'Skandal',
        'Skinny Body Care',
        'Slim Fast',
        'Smartshake',
        'So White',
        'Softhealth',
        'Solgar',
        'Songtai Life',
        'Source Naturals',
        'Spring Valley',
        'Ssa',
        'Sumifun',
        'Sundown Naturals',
        'Sunhome Technology',
        'Supaworld',
        'Superlife',
        'Supple',
        'Supreme Gluta White',
        'Swanson Health Products',
        'Swisse',
        'Tasly',
        'The Protein Works',
        'Thorne Research',
        'TimJan Wonder',
        'Tradomed',
        'Trevo',
        'Fafor life',
        'Health Plus',
        'Herbalife',
        'Neolife',
        'Norland',
        '21St Century',
        '4Life',
        '5-Hour Energy',
        'A&G',
        'Abbott',
        'Ace',
        'Aci',
        'Acorbic',
        'Activlab',
        'Advocare',
        'Alcon',
        'Alfa',
        'Alfasigma',
        'Alli',
        'Alliance Global',
        'Amazing Herbs',
        'American Health',
        'Animal Pump',
        'Apetamin',
        'Applied Nutrition',
        'APS',
        'Aqua Skin',
        'Arbonne',
        'Atkins',
        'Aura White',
        'Azo',
        'Baidyanath',
        'Basic Supplement',
        'Bausch + Lomb',
        'Bayer',
        'Beachbody',
        'Bell Lifestyle',
        'Benefit',
        'Berocca',
        'Best Naturals',
        'Better Bodies',
        'Bf Suma',
        'Biotech',
        'Biotrend',
        'Biotrust',
        'Bodi Goal',
        'Body Fortress',
        'Boldgains',
        'Boric Acid',
        'BPI',
        'Bragg',
        'Builders',
        'Bulk Powders',
        'Cardiovax',
        'Carlyle',
        'Carrot-Top Drugs',
        'Celerity from Max',
        'Cellucor',
        'Centrum',
        'Clean',
        'Complan',
        'Country Life',
        'Crazymass',
        'Crystal',
        'CVS',
        'Cybergenics',
        'Dabur',
        'Daynee',
        'Detoxi Slim',
        'Deva',
        "Doctor's Best",
        'Double Wood',
        "Dr. Ohhira's",
        'Dxn',
        'Dymatize',
        'Dymatize Nutrition',
        'Dynace',
        'Dynace Global',
        'Dynamic Health',
        'Dynewell',
        'Dynwell',
        'Earth Creation',
        "Earth'S Creation",
        'Edible Herbs',
        'Edmark',
        'Edmark International',
        'Efamol',
        'Elite Nutrition',
        'Elken Global',
        'Emergen-C',
        'Ensure',
        'Equate',
        'Organic India',
        'Organo',
        'Oriflame',
        'Orion',
        'Osteo Biflex',
        'Ozempic',
        'Partner.Co',
        'Perfectil',
        'Pfizer',
        'Pharmanex',
        'Phytoscience',
        'Piping Rock',
        'Precious Skin',
        'Premier Edition',
        'Premier Protein',
        'Prolife',
        'Pure Encapsulations',
        'Pure Protein',
        'Purely Inspired',
        "Puritan's Pride",
        'Rain',
        'Rain International',
        'Redcon1',
        'Revive Active',
        'Revoobit',
        'Rida',
        'Rite Aid',
        'Rule 1',
        'Sambucol',
        'Satin Skinz',
        "Nature's Blend",
        "Nature's Bounty",
        "Nature'S Field",
        "Nature's Life",
        "Nature's Plus",
        "Nature'S Renaissance",
        "Nature's Sunshine",
        "Nature's Way",
        'Naturefield',
        'Natures Aid',
        'Natures Cure',
        'Neocell',
        'Nestle',
        'New Hope Global',
        'New Look',
        'New Nordic',
        'Next Level',
        'Nicole',
        'Nil',
        'Nordic Naturals',
        'Novo Nordisk',
        'Now',
        'Now Foods',
        'Now Sports',
        'Nozie',
        'NRI',
        'Nuevergold',
        'Nutrabolics',
        'Nutrex',
        'Nutricost',
        'Nutrilite',
        'Nvisionu',
        'Olly',
        'One A Day',
        'Onecure',
        'Optimum Nutrition',
        'Orgain',
        'Organic Barley Grass',
        'Organic Health Essence',
        'Eu Natural',
        'Evergreen',
        'Everhealth',
        'Evgenis',
        'EVL',
        'Exeline',
        'Faforon',
        'Fairhaven Health',
        'Farforon',
        'Finaflex',
        'Fitness Labs',
        'Flat Tummy Tea',
        'FM',
        'Fohow',
        'Force Factor',
        'Forever',
        'Forever Living',
        'Frozen',
        'Fudge',
        'Futurebiotics',
        'Gamma',
        'Garden Of Life',
        'Gaspari',
        'Gaspari Nutrition',
        'GAT',
        'Ght',
        'Glaxon',
        'Global Healing Center',
        'Gluta Berry',
        'Gluta Frozen',
        'Gluta Prime',
        'Gluta White',
        'Glutanex',
        'Glutax',
        'GNC',
        'Goli Nutrition',
        'Great',
        'Great Lakes',
        'Greatea',
        'Green World',
        'Twinlab',
        'Tylenol',
        'Uatd',
        'Ultimate Maca',
        'Ultimate Maca Plus',
        'Ultimate Nutrition',
        'Ultra',
        'Unbranded',
        'Universal Nutrition',
        'USN',
        'Usplabs',
        'Vasia Supplement',
        'Vega',
        'Vibrant Health',
        'Vitabiotics',
        'Vitafusion',
        'Vital Proteins',
        'Viva',
        'Viviscal',
        'VPX',
        'Weider',
        'Whey Protein',
        'Wholesome Story',
        'Windmill',
        'Wins Town',
        'Winston',
        'XS',
        'Yes Global',
        'Young Living',
        'Youngevity',
        'Youtheory',
        'Zazzee',
        'Zeal',
        'Zipfizz',
        'Other',
    ],
    5603: [
        'Arabian Perfume',
        'Ard Al Zaafaran',
        'Fragrance World',
        'Lattafa',
        'Oriflame',
        'Accendis',
        'Acqua Di Parisis',
        'Acqua di Parma',
        'Adidas',
        'Afnan',
        'Ajmal',
        'Al Haramain',
        'Al Wataniah',
        'Al-Rehab',
        'Aleda',
        'Alhambra',
        'Alina Corel',
        'Amber Elixir',
        'Amore',
        'Amouage',
        'Amouroud',
        'Angel Schlesser',
        'Annick Goutal',
        'Antonio Banderas',
        'Arabiyat',
        'Aramis',
        'Argerville',
        'Argeville',
        'Armaf',
        'Armand Basi',
        'Aro-Fac',
        'Asdaaf',
        'Avanti',
        'Aventos',
        'Avon',
        'Azzaro',
        'Bebe',
        'Bentley',
        'Berries Weekend',
        'Betres',
        'Beyonce',
        'Bijan',
        'Blend Oud',
        'Boadicea',
        'Body Philosophy',
        'Bond No',
        'Boucheron',
        'Breed',
        'Britney Spears',
        'Burberry',
        'Bvlgari',
        'Byredo',
        'Cacharel',
        'Cadillac',
        'Calvin Klein',
        'Carbbean Vanilla',
        'Carolina Herrera',
        'Cartier',
        'Castle Bejar',
        'Cerruti',
        'Chanel',
        'Chris Adams',
        'Christian Dior',
        'Classic Creation',
        'Clinique',
        'Clive Christian',
        'Concur',
        'Confetti',
        'Cool Girl',
        'Copaci',
        'Creation Lamis',
        'Creed',
        'Crown Perfumes',
        'Cybele',
        'David Beckham',
        'Davidoff',
        'Dhamma',
        'Diesel',
        'DKNY',
        'Dolce & Gabbana',
        'Dunhill',
        'Elie Saab',
        'Fogg',
        'Francis Kurkdjian',
        'Franck Bocklet',
        'Franck Olivier',
        'French Connection',
        'French Oil',
        'Fuse',
        'Gale Hayman',
        'Gandour',
        'Gdk',
        'Genie',
        'Genie Collection',
        'Geoffrey Beene',
        'Ghost',
        'Giorgio Armani',
        'Giorgio Black',
        'Givana',
        'Givanas',
        'Givenchy',
        'Gucci',
        'Guerlain',
        'Guess',
        'Guy Laroche',
        'Hamilton',
        'Havex',
        'Hermes',
        'Hugo Boss',
        'Iceberg',
        'Imperio',
        'Issey Miyake',
        'Jacomo',
        'Jacques Bogart',
        'Jacques Fath',
        'Jaguar',
        'Jean Paul Gaultier',
        'Jeanne Arthes',
        'Jennifer Lopez',
        'Jimmy Choo',
        'Joop',
        'Juicy Couture',
        'Justin Bieber',
        'Kenneth Cole',
        'Kenzo',
        'Khalis',
        'Kilian',
        'Kim Kardashian',
        'Lacoste',
        'Lady Gaga',
        'Lalique',
        'Lancome',
        'Lanvin',
        'Le Labo',
        'Liquides Imaginaires',
        'Lolita Lempicka',
        'Louis Cardin',
        'Louis Vuitton',
        'Madonna',
        'Maison Fragrance',
        'Maison Oud',
        'Mancera',
        'Nishane',
        'Marc Jacobs',
        'Marque',
        'Memo',
        'Mercedes Benz',
        'Milton Lloyd',
        'Ministry Of Oud',
        'Monster Fragrance',
        'Mont Blanc',
        'Moresque',
        'Moschino',
        'Mosuf',
        'Mousuf',
        'My Dear Body',
        'Myk',
        'Mystical',
        'Narciso Rodriguez',
        'Naseem',
        'Nasomatto',
        'Nautica',
        'Nedens',
        'Nina Ricci',
        'Nivea',
        'OAK',
        'Ocean Pacific',
        'Only You',
        'Oros',
        'Oud Luxury Collection',
        'Paco Rabanne',
        'Pandora',
        'Parfums De Marly',
        'Parfums Gres',
        'Paris Corner',
        'Paris Hilton',
        'Pendora Scents',
        "Penhaligon's",
        'Perry Ellis',
        'Philz',
        'Porsche Design',
        'Pra',
        'Prestige',
        'Ralph Lauren',
        'Rasasi',
        'Rave',
        'RB',
        'Repetto',
        'Riggs',
        'Rihanna',
        'Roberto Cavalli',
        'Roja Dove',
        'Rue Broca',
        'Salvatore Ferragamo',
        'Sarah Jessica Parker',
        'Scenabella',
        'Sean John',
        'Secret Amor',
        'Sex In The City',
        'Sillage',
        'Smart Collection',
        'Smart Collections',
        'Smart World',
        'So Oud',
        'Storm',
        'Style Parfums',
        'Suave',
        'Surrati',
        'Thierry Mugler',
        'Tom Ford',
        'Tommy Hilfiger',
        'Touch',
        'Usher',
        'Valentino',
        'Van Cleef & Arpels',
        'Vera Wang',
        'Versace',
        'Vertigo',
        "Victoria's Secret",
        'Viktor & Rolf',
        'Ville',
        'Vince Camuto',
        'Vurv',
        'Yves Saint Laurent',
        'Zandas',
        'Zara',
        'Other Brand',
        'Elizabeth Arden',
        'Elizabeth Taylor',
        'Elysees Fashion',
        'Emir',
        'Emper',
        'Emporio Armani',
        'Enchanteur',
        'Escada',
        'Essencia',
        'Estee Lauder',
        'Etienne Aigner',
        'Explore',
        'FA Paris',
        'Ferrari',
        'other',
    ],
    5604: [
        'Classic Erotica',
        'HOT',
        'No-Name',
        'Oriflame',
        'Sextreme',
        'A&G',
        'Abreva',
        'Aichun Beauty',
        'AMOUR',
        'Apollo',
        'B Swish',
        'Bad Kitty',
        'Baile',
        'Beano',
        'Belgo-Prism',
        'Best Herb',
        'BlissJoy',
        'Blush',
        'Blush Novelties',
        'Bodywand',
        'Butterfly',
        'Carejoy',
        'Classics',
        'Cobeco',
        'Colt',
        'Crystal',
        'CURVE',
        'Diblong',
        'Double Root',
        'Durex',
        'Electrastim',
        'Envy',
        'Everhealthy',
        'Faak',
        'Faforlife',
        'Fairhaven Health',
        'Fantasy',
        'Fashion',
        'Fetish Fantasy',
        'Fleshlight',
        'Fohow',
        'Forever',
        'Foxshow',
        'Fun Factory',
        'Ght',
        'Glas',
        'Gold Fly',
        'Greenlife',
        'Hardtoys',
        'Icicles',
        'Icon',
        'Immeri',
        'IMO',
        'Jigsimur',
        'Johnson & Johnson',
        'Joy',
        'K-Y',
        'Kedi',
        'King',
        'Lilo',
        'Love',
        'Lovehoney',
        'LoveLife',
        'Lovense',
        'LOVETOY',
        'Luvkis',
        'Luxe',
        'Magic Wand',
        'Master Series',
        'Max Man',
        'Mk',
        'Neolife',
        'Norland',
        'Now',
        'Nu Sensuelle',
        'Orion',
        'Passion',
        'Perfect Fit',
        'PINK',
        'Pipedream',
        'Pretty Love',
        'Pure Romance',
        'Samsu',
        'Satisfyer',
        'Secret',
        'SexFlesh',
        'Shineway Healthcare',
        'Size Matters',
        'Spanish Gold Fly',
        'Strap U',
        'STUD',
        'Super Viga',
        'SVAKOM',
        'Tenga',
        'Toy Joy',
        'Ultra',
        'Venus',
        'Viga',
        'Vigrx Plus',
        'Wand Essentials',
        'Wet',
        'Wins Town',
        'XOXO',
        'XR Brand',
        'XR Brands',
        'XS',
        'Yes Global',
        'Yoni',
        'Other',
    ],
    5605: [
        'Motec Beauty',
        'Aura',
        'Oriflame',
        'Avon',
        'Zaron',
        'Alpyn beauty',
        'Avour',
        'BH',
        'Blossom',
        'Classic',
        'Dior',
        'Fayre Gold',
        'Freshlook',
        'GlamGals',
        'Heng Fang',
        'Hudabeauty',
        'Karite',
        'Kylie',
        'Just For Men',
        "L'Oreal",
        'Mac',
        "L'Oreal Paris",
        'Laura Mercier',
        'Lush',
        'MAC',
        'Oriflame',
        'Zikel',
        'Revlon',
        'Other',
    ],
    5606: [
        'Bath & Body Works',
        'B. Braun',
        'Axis',
        'AXE',
        'Avon',
        'Aveeno',
        'Astonish',
        'Asantee',
        'Arm & Hammer',
        'Anthony',
        'Annie',
        'Angel',
        'AMBI',
        'Always',
        'Alpha',
        'Aichun Beauty',
        'Agraria',
        'Adidas',
        'AcneFree',
        'A LA MAISON',
        'Oriflame',
        'On',
        'Fresh',
        'Essential',
        'Clean',
        'Zoya',
        'Zoella',
        'Zion Health',
        'Zest',
        'Zermat',
        'Zen',
        'Yves Saint Laurent',
        'Yves Rocher',
        'Young Living Essential Oils',
        'YES TO',
        'YES',
        'Yardley',
        'Worth',
        'World Market',
        'White Rain',
        'VS',
        'Vogue',
        'Viva',
        'Vitamins',
        'Virgo',
        'Village Naturals',
        'Viktor & Rolf',
        "Victoria's Secret",
        'Vespa',
        'Versace',
        'Veetgold',
        'VEET',
        'Vaseline',
        'United Colors of Benetton',
        'Ultra',
        "Two's Company",
        'Tura',
        'Trussardi',
        "Trader Joe's",
        'Tosowoong',
        'Top Gel',
        'Tommy Hilfiger',
        'Thierry Mugler',
        'The Natural Solution',
        'The Body Shop',
        'Technic',
        'Tea Tree Therapy',
        'Tea Tree',
        'Tampax',
        'TAG',
        'Tabac',
        'SURE',
        'Superior',
        'Sunflower',
        'Sumifun',
        'Sugar',
        'Suave',
        'Star',
        'St. Ives',
        'Spongeables',
        'South Moon',
        'Source Naturals',
        'SOTHYS',
        'Softsoap',
        'Soap Wizards',
        'Soap & Glory',
        'Skin Perfection',
        'Skin Doctor',
        'Sk Duchess',
        'Simple',
        'Shea Moisture',
        'SebaMed',
        'Sea of Spa',
        'Sea Breeze',
        'Sanex',
        'San Francisco Soap',
        'Royal',
        'Right Guard',
        'Rexona',
        'Reviva Labs',
        'Remedy',
        'REFRESH',
        'Q7',
        'Pure Naturals',
        'Pure',
        'Plantlife',
        'PINK',
        'Pierre Cardin',
        'Pier 1',
        'Papaya',
        'Pamper Glow',
        'Palmolive',
        "Palmer's",
        'Paco Rabanne',
        'own',
        'ORIGINAL SOURCE',
        'Original',
        'Organo Gold',
        'Organix',
        'Oral B',
        'Only Natural',
        'Old Spice',
        'Olay',
        "O'Carly",
        'O HUI',
        'Now',
        'NOVA',
        'Nourish',
        'Norland',
        'Non applicabile',
        'No-Name',
        'NIVEA',
        'Neutrogena',
        "Nature's Blend",
        'Nature Secrete',
        'MYSORE SANDAL SOAP',
        'Multistream',
        'MOR',
        'ModelSupplies',
        'Mission',
        'Miracle',
        'Medix 5.5',
        'McKesson',
        'Maxi-Peel',
        'Marvel',
        'Makari',
        'Magno',
        'Ma',
        'Lysol',
        'Lynx',
        'Lux',
        'Love Beauty and Planet',
        'Longrich',
        'Listerine',
        'Le Labo',
        'Lasting Impressions',
        'Lanbena',
        'La Roche-Posay',
        "L'Oreal",
        'Kojiesan',
        'Kojic',
        'Kirkland Signature',
        'Kirkland',
        'Kimberly-Clark',
        'Kedi',
        'K Brothers',
        "JOHNSON'S",
        'Johnson & Johnson',
        'Jimpo Ori',
        'Jergens',
        'Jam',
        'Jack Wills',
        'IT Cosmetics',
        'Irish Spring',
        'Imported',
        'Honest Amish',
        'Homemade',
        'Home Health',
        'Himalaya',
        'Herbal Essences',
        'Hemani',
        'Hask',
        'Goody',
        'Garnier',
        'GANZ',
        'Forever Living',
        'Fashion',
        'Fair And White',
        'Fair & White',
        'Fa',
        'Evyan',
        'Everyone',
        'Eucerin',
        'Essence of Beauty',
        'essence',
        'Emami',
        'Efero',
        'Eelhoe',
        'Eden',
        'dunhill',
        'Dudu-Osun',
        'Dry Dry',
        'Drunk Elephant',
        'DREAM',
        'Dr. Teals',
        'Dr Rashel',
        'Dove',
        'Disaar',
        'Diamond',
        'Dettol',
        'Dermacol',
        'Dead Sea',
        'Cure',
        'Cosrx',
        'Colgate',
        'Clinique',
        'Clearly Natural',
        'CLEAR SKIN',
        'Classics',
        'Cetaphil',
        'Cerave',
        'Castelbel',
        'Carotone',
        'Carolina Herrera',
        'Calvin Klein',
        'Boots',
        'Body Essentials',
        'bliss',
        'Bismid',
        'BIODERMA',
        'BIOAQUA',
        'Beyonce',
        'Bella',
        'Baylis & Harding',
        'other',
    ],
    5607: [
        '3M',
        '21st Century',
        '3W Clinic',
        '4VOO',
        'ACE',
        'AcneFree',
        'Active Plus',
        'Acqua di Parma',
        'A&G',
        'African Pride',
        'Alba Botanica',
        'Almond Herbal',
        'Alpyn beauty',
        'Alpha Skin Care',
        'Alva',
        'American Beauty',
        'Amie',
        'Anne French',
        'Artemis',
        'Astley Clarke',
        'Australian Bodycare',
        'Apeiron',
        'Aura',
        'Avila',
        'Avon',
        'Avour',
        'Aztec Secret',
        'Babyganics',
        'Badger',
        'Bag Balm',
        'Beauty Formulas',
        'Beauty Of Joseon',
        'Becca',
        'Bio Claire',
        'Bio-Oil',
        'Bioderma',
        'Biomaris',
        'Biotique',
        'Blemish Care',
        'bliss',
        'Blossom',
        'Bora',
        'Botanics',
        'Bye Bye Blem',
        'Carebeau',
        'Carmex',
        'Caro white',
        'Cetaphil',
        'Cflair',
        'Charlotte Meentzen',
        'CHI',
        'China Glaze',
        'Christian Breton',
        'Cien',
        'Clarins',
        "Clark's Botanicals",
        'Clean',
        'Clean & Clear',
        'Clear Essence',
        'Clear Skin',
        'Clearasil',
        'Clinic Plus',
        'Clinique',
        'Colageina',
        'Collin Paris',
        'CosMedix',
        'Cosmetic Skin Solutions',
        'Cosrx',
        'Creightons',
        'Crest',
        'Crystal',
        'Cure',
        'CVS',
        'Daggett & Ramsdell',
        'Dead Sea Spa Magik',
        'Depend',
        'Derma',
        'DermaSilk',
        'Dermatix',
        'Dermend',
        'Designer Skin',
        'Devee',
        'DFI',
        'DHC',
        'Differin',
        'Disaar',
        'DKNY',
        'Donna Karan',
        'Dove',
        'Dr Adorable',
        'Dr Davey',
        'Dr James',
        'Dr Meinaier',
        'Dr. Brandt',
        'Dr. Hauschka',
        'Dr. Jart+',
        "Dr. Teal's",
        'E-System',
        'EduPad',
        'eMachines',
        'Essence',
        'Evoo',
        'Fujitsu',
        'Garnier',
        'Geo',
        'Gigabyte',
        'GlamGals',
        'Google',
        'Haier',
        'Hawaiian Silky',
        'Heng Fang',
        'Himalaya',
        'Hudabeauty',
        'Huawei',
        'i-Life',
        'iBUYPOWER',
        'Itel',
        'Just For Men',
        'Kylie',
        "L'Oreal",
        "L'Oreal Paris",
        'Laura Mercier',
        'Linx',
        'Lush',
        'MAC',
        'Maingear',
        'Medion',
        'Microsoft',
        'Mielle',
        'Monster',
        'MSI',
        'Nokia',
        'Novatech',
        'Oriflame',
        'Origin PC',
        'Packard Bell',
        'Panasonic',
        'Prostar',
        'Razer',
        'Revlon',
        'RM Minibook',
        'Sager',
        'Samsung',
        'Secret',
        'SebaMed',
        'Sen',
        'Sense',
        'Sepi White',
        'Serious Skincare',
        'Shea Moisture',
        'Simple',
        'Skin Aqua',
        'Skin Doctor',
        'Skin Doctors',
        'Skin Food',
        'SkinLab',
        'Skinn',
        'Skinny Body Care',
        'Smooth-E',
        'Soap & Glory',
        'Softlips',
        'Some By Mi',
        'Sosu',
        'Source Naturals',
        'St. Ives',
        'Standard Process',
        'Suave',
        'Suki',
        'Sumifun',
        'Sun Cut',
        'Sunday Riley',
        'Supreme White',
        'Sure',
        'Swedish Beauty',
        'Tatcha',
        'Tea Tree',
        'Thayers',
        'The Body Shop',
        'The Face Shop',
        'The Healing Garden',
        'The Inkey List',
        'The Ordinary',
        'The Organic Pharmacy',
        'The Skin House',
        'Tiam',
        'Tocobo',
        'Tony Moly',
        'Touch',
        'Toxskincare',
        'Tree Hut',
        'Ulta',
        'Unbranded',
        'Unica',
        'Untamed',
        'Vanicream',
        'Vaseline',
        'Veet',
        'Veetgold',
        'Vichy',
        'Vitabiotics',
        'Vitamin C Naturals',
        'Vitasense',
        'W7',
        'Wei East',
        'White Express',
        'Windmill',
        'Winstown',
        'WR',
        'Xtreme Brite',
        'Yardley',
        'Yc',
        'Yoko',
        'Yoni',
        'Young Living Essential Oils',
        'Yuri',
        'Zapzyt',
        'Zeenat',
        'Zeno',
        'ZGT',
        'Zia',
        'Zozu',
        'Dr Rasheal',
        'Dr Teal',
        'Dr Teals',
        "Dr. Miracle's",
        'Dr. Rashel',
        'Dynamic Health',
        'E45',
        'Easy Glow',
        'Edens Garden',
        'Eelhoe',
        'Egyptian Magic',
        'ELF',
        'Elie Saab',
        'Elizabeth Arden',
        'Ella Bache',
        'Emma Hardie',
        'Environ',
        'Erborian',
        'Etude House',
        'Eucerin',
        'Evanhealy',
        'Everyone',
        'Ex Skincare',
        'Ezanic',
        'Face Facts',
        'Fair & Lovely',
        'Fair & White',
        'Faith in Nature',
        'Fem',
        'Foreo',
        'Forever Living',
        'French Connection',
        'Fresh',
        'G.M. Collin',
        'Garnier',
        'Genie',
        'Gillette',
        'Glamglow',
        'Glow Half Cast',
        'Gluta- C',
        'Glutathione',
        'Golden Pearl',
        'GoldFlower',
        'Good Molecules',
        'GoodSkin Labs',
        'Grassroots',
        'Green People',
        'GreenHealth',
        'Hada Labo',
        'Half Cast',
        'Handmade',
        'Hatomugi',
        'Hawaiian Tropic',
        'Health Garde',
        'Healthy Origins',
        'Heel',
        'Heidi Klum Intimates',
        'Hemani',
        'Hempz',
        'Herb Pharm',
        'Herbal Essences',
        'Herbalife',
        'Himalaya',
        'Himalaya Health Care',
        'Himalaya Herbals',
        'Honest Beauty',
        'Image',
        'Imported',
        'Inner Beauty',
        'Instant White',
        'Isntree',
        'It Works',
        "It's Skin",
        'Jamberry',
        'Jergens',
        'Jimpo Ori',
        'Joey New York',
        'Johnson & Johnson',
        'Jovees',
        'Julie Diamond',
        'Jumiso',
        "Pond's",
        'Pretty Cowry',
        'Pure Body Naturals',
        'Pure Carrot',
        'Pure Egyptian',
        'Purederm',
        'Pureglow',
        "Puritan's Pride",
        'Qei+',
        'Queen Helene',
        'Radha Beauty',
        'Rdl',
        'Remeehi',
        'REN',
        'ReVive',
        'Revlon',
        'Revuele',
        'Right Guard',
        'Rimmel',
        'RoC',
        'Roushun',
        'Royal Glow Beauty Empire',
        'Sadoer',
        'Sanoflore',
        'Sante',
        'K.Brothers',
        'KAL',
        'Kao',
        'Kat Burki',
        'KIND',
        'Kirkland Signature',
        'Kiss My Face',
        'KleanColor',
        'Kneipp',
        'Koji White',
        'Kojie.San',
        'Kos',
        'Kose',
        'Kuu',
        'Kuu Spa',
        "L'Oreal",
        'La Roche-Posay',
        'Lacura',
        'Lanbena',
        'Lancome',
        'Laneige',
        'Lanocreme',
        'Lavera',
        'Lavolta',
        'LipSense',
        'Lipstick Queen',
        'Lirene',
        'LivingStone',
        'Longrich',
        'Lotus',
        'Lotus Herbals',
        'LR',
        'Lumene',
        'Luminesce',
        'Lus',
        'Ma',
        'Madam White',
        'Makari',
        'Mary Kay',
        'MD Skin Care',
        'Mederma',
        'Medix',
        'Medix 5.5',
        'Mena',
        'Menarini',
        'Mgc Philippines',
        'Microscrub',
        'Milani',
        'Mimi White',
        'Miracle Skin Transformer',
        'Missha',
        'Mistine',
        'Mooyam',
        'Moroccanoil',
        'Murad',
        'MyBody',
        'MyChelle',
        'Nadinola',
        'Natrol',
        'Natural Advantage',
        'Natural Factors',
        'Nature Made',
        'Nature Well',
        "Nature's Cure",
        "Nature's Life",
        "Nature's Way",
        'Naturium',
        'Neo G',
        'NeoCell',
        'Neutrogena',
        'Neutrotone',
        'New Look',
        'Nexxus',
        'Nivea',
        'Nixoderm',
        'Nordic Naturals',
        'Norland',
        'Nourish',
        'Now',
        'Nuskin',
        'NutriBiotic',
        "O'Carly",
        'Oilatum',
        'Olay',
        'Old Spice',
        'Ole Henriksen',
        'Organic India',
        'Organic Surge',
        'Oribe',
        'Origins',
        'Osmotics',
        'OXY',
        "Palmer's",
        'Pamper Glow',
        'PanOxyl',
        'Paris Hilton',
        'Parley Goldie',
        "Paula's Choice",
        'Peau De Lune',
        'Pei Mei',
        'Perlay Goldie',
        'Perlier',
        'Persol',
        'Pharmagel',
        'PHD',
        'PhytoScience',
        'Piment Doux',
        'Pixi',
        'other',
    ],
};
const healthTypes = {
    5601: [
        'Conditioners',
        'Styling Products',
        'Shampoos',
        'Heat Protectors',
        'Hair Treatments & Oils',
        'Hair Serums',
        'Hair Relaxers',
        'Hair Perms',
        'Hair Masks',
        'Hair Color Products',
        'Hair Extensions & Wigs',
        'Hair Brushes & Combs',
        'Hair Care & Styling Sets',
        'other',
    ],
    5602: [
        'Immune System Boosters',
        'Vitamin Supplements',
        'Detox Cleanses',
        'Weight-Loss Products',
        'Beauty Supplements',
        'Adrenal Support Supplements',
        'Amino Acids',
        'Anti-Aging Supplements',
        'Antioxidants',
        'Ayurveda Supplements',
        'Bee Products',
        'Bladder Supplements',
        'Blood Sugar Support Supplements',
        'Blood Supplements',
        'Bone, Joint & Cartilage Supplements',
        'Brain & Cognitive Supplements',
        "Children's Health Supplements",
        'Cholesterol Support Supplements',
        'Circulatory System Supplements',
        'Collagen Supplements',
        'Colon Supplements',
        'Common Cold & Flu Supplements',
        'Detox & Cleanse Supplements',
        'Diabetic Supplements',
        'Digestive System Supplements',
        'Ears Supplements',
        'Electrolytes Supplements',
        'Energy Boosters',
        'Energy Supplements',
        'Enzyme Nutritional Supplements',
        'Essential Fatty Acid Nutritional',
        'Eye Supplements',
        'Fat Acids',
        'Fertility Support',
        'Fish Oil & Omegas',
        'Glandular Extract',
        'Greens & Superfoods',
        'Hair, Skin & Nails Supplements',
        'Heart Supplements',
        'Herbal Supplements',
        'Hyaluronic Acid Nutritional Supplements',
        'Lipid Nutritional Supplements',
        'MCT Oil Nutritional Supplements',
        "Men's Health Supplements",
        'Menstrual & PMS Support Supplements',
        'Minerals Supplements',
        'Mood & Emotional Support Supplements',
        'MSM Nutritional Supplements',
        'Mushrooms Supplements',
        'Oral Health Supplements',
        'Pain Relief Supplements',
        'Prenatal Support',
        'Protein',
        'Respiratory System Supplements',
        'Senior Health Supplements',
        'Sexual Health Supplements',
        'Sleep Supplements',
        'Sports Supplements',
        'Thyroid Support Supplements',
        'Urinary Tract Health Supplements',
        "Women's Health Supplements",
        'Other',
    ],
    5603: [
        'Essential Oils',
        'Eau de Cologne',
        'Eau de Parfum',
        'Body Oils',
        'Eau de Fraiche',
        'Eau de Toilette',
        'Parfum',
    ],
    5604: [
        'Vibrators',
        'Sexual Supplements',
        'Massage Cream & Oil',
        'Fertility Supplements',
        'Lubricants',
        'Anal Sex Toys',
        'Better Sex for Her',
        'Better Sex for Him',
        'Blindfolds, Masks & Gag',
        'Bondage',
        'Bondage for Beginners',
        'Breast Enhancer',
        'Breast Stimulator',
        'Butt Plugs',
        'Chastity Devices',
        'Cock & Ball Toys',
        'Cock Rings',
        'Condoms',
        'Contraception',
        'Dildos',
        'Electro & Medical Fetish',
        'Erotic Lingerie Sets',
        'Fetish Clothing',
        'Handcuffs & Restraints',
        'Intimate Hygiene',
        'Love Eggs & Jiggle Balls',
        'Male Sex Toys',
        'Nipple & Clitoral Toys',
        'Sex Machine',
        'Sex Swings & Machines',
        'Sex Toys for Couples',
        'Sexual Duration Products',
        'Sexy Clothing',
        'Sexy Gifts & Games',
        'Spankers & Ticklers',
        'Strap-Ons',
        'Underwear for Men',
        'Wet Look Lingerie',
        'Other',
    ],
    5605: [
        'Tinted Moisturizers',
        'Setting Spray',
        'Pencils',
        'Mascaras',
        'Lip Balm & Treatment',
        'Liners',
        'Hair Relaxers',
        'Glitter Glue',
        'Make-Up Sets',
        'Blush',
        'Eyeshadows',
        'Foundations',
        'False Eyelashes',
        'Bronzers',
        'Eyelash Serums',
        'Eyebrow Gel',
        'Brushes & Applicators',
        'Blotting Papers',
        'BB Cream',
        'Contour',
        'Color Correctors',
        'Powders',
        'Lipstick',
        'CC Cream',
        'Facial Wipes',
        'Eyelash Glue',
        'Concealers',
        'Other',
        'Illuminators & Highlighters',
        'other',
    ],
    5606: [
        'Soaps',
        'Body Lotions',
        'Body Oils',
        'Shower Gels',
        'Toothpastes',
        'Antiseptics',
        'Bath Bombs & Fizzies',
        'Bath Brushes & Sponges',
        'Bath Foam',
        'Bath Salts',
        'Bath Sets & Kits',
        'Body Butters',
        'Body Creams',
        'Body Powders',
        'Body Scrubs',
        'Body Sprays',
        'Breath Fresheners',
        'Cotton Buds',
        'Dental Floss',
        'Deodorants & Aniperspirants',
        'Essential Oils',
        'Female Cleansers',
        'Hair Removal Creams',
        'Hand Washes',
        'Mouthwashes',
        'Panty Liners',
        'Sanitary Pads',
        'Scar & Stretch Mark Reducers',
        'Shower Caps',
        'Tampons',
        'Teeth Whitening Products',
        'Tongue Cleaner',
        'Toothbrushes',
        'Travel Bottles & Container',
        'Other',
    ],
    5607: [
        'Body Creams & Milks',
        'Face Creams & Gels',
        'Body Oils',
        'Body Wash & Soap',
        'Face Serums & Oils',
        'Advent Calendar',
        'BB & CC Creams',
        'Body Scrubs & Exfoliation',
        'Cosmetics Bags & Organizers',
        'Eye Creams & Treatments',
        'Face Scrubs & Exfoliants',
        'Face Wipes',
        'Face Wash & Cleansers',
        'Facial Peels',
        'Gift Sets',
        'Hydrogel Patches',
        'Lip Balms & Treatments',
        'Make-Up Remover',
        'Neck & Décolleté',
        'Night Creams',
        'Self-Tanners',
        'Skincare Tools',
        'Skin and Hair Ampoules',
        'Sun Care',
        'Toners',
        'Other',
    ],
    5608: [
        'Tins',
        'Snuff Boxes',
        'Pencils',
        'Rolling Paper Filter',
        'Rollers',
        'Pipes',
        'Papers',
        'Nicotine Pouches',
        'Laughing Gas',
        'Flavored Capsules Smoking',
        'Grinders',
        'Cigars',
        'E-Cig Cartridges',
        'Cigarettes',
        'Cases & Stands',
        'Bongs',
        'Ashtrays',
        'Lighters',
        'E-Liquids',
        'Vapes',
        'Hookahs & Accessories',
        'Other',
    ],
};
// Home and Accessories
const homeBrands = {
    5701: [
        'Remington',
        'Relax',
        'Pure Comfort',
        'PUR',
        'Pulaski',
        'Pro-Tec',
        'Prime Line Products',
        'Prime',
        'Powerline',
        'Polywood',
        'Platt',
        'Pioneer',
        'Pillow Perfect',
        'Pillow Decor',
        'Petra',
        'Perfect Home',
        'Pearl',
        'PartyLite',
        'Panasonic',
        'OTC',
        'Oriental Furniture',
        'Olympic',
        'Office Star Products',
        'NEXT',
        'New Leaf',
        'Nest',
        'Napoleon',
        'Mouka',
        "Member's Mark",
        'MasterCraft',
        'Master',
        'Mainstays',
        'MacKenzie-Childs',
        'Lv',
        'Lux',
        'Lodge',
        'Lock & Lock',
        'Living Accents',
        'Ligne Roset',
        'Lifetime',
        'Life Mate',
        'LG',
        'Leisure',
        'Legacy',
        'LDR',
        "Lands' End",
        'Kitchen Craft',
        'Kingston Brass',
        'King',
        'Kidkraft',
        'Keebler',
        'Wildkin',
        'Whitmor',
        'Whitehall',
        'White Mountain',
        'Weston',
        'Westcool',
        'west elm',
        'WENKO',
        'WEN',
        'Wedgwood',
        'Weber',
        'Waxman',
        'Watts',
        'Wamsutta',
        'Wallace',
        'Walker',
        'WAGNER',
        'Vollrath',
        'VIVERE',
        'Vita Foam',
        'Villeroy & Boch',
        'Viking',
        'Vigo',
        'VIG Furniture',
        'Victory',
        'Victorian Heart',
        'Vantage',
        'Valspar',
        'Valley Forge',
        'Uttermost',
        'Unifoam',
        'Unbranded',
        'Umbra',
        'Ultra',
        'U-Line',
        'Typhoon',
        'Twinings',
        'Tvilum',
        'Tropitone',
        'Triton',
        'Tripp Lite',
        'Toro',
        'Room Essentials',
        'Roche Bobois',
        'Restoration Hardware',
        'Remington',
        'Relax',
        'Pure Comfort',
        'PUR',
        'Pulaski',
        'Pro-Tec',
        'Prime Line Products',
        'Prime',
        'Powerline',
        'Polywood',
        'Platt',
        'Pioneer',
        'Pillow Perfect',
        'Pillow Decor',
        'Petra',
        'Perfect Home',
        'Pearl',
        'PartyLite',
        'Panasonic',
        'OTC',
        'Oriental Furniture',
        'Olympic',
        'Office Star Products',
        'NEXT',
        'New Leaf',
        'Nest',
        'Timex',
        'Tiffany & Co.',
        'Thermos',
        'The Home Depot',
        'Texsport',
        'Tesco',
        'Terraillon',
        'Tennsco',
        'Techni Mobili',
        'Taymor',
        'Taylor',
        'Target',
        'Tango',
        'SUPRA',
        'Stylemaster',
        'Style Selections',
        'Stressless',
        'Stout',
        'Stool International',
        'Stilnovo',
        'Sticks',
        'Stickley',
        'Sterilite',
        'Stearns & Foster',
        'Stanley Furniture',
        'Stanley',
        'Spa Sensations',
        'Sorbus',
        'Sony',
        'Solo',
        'Solar',
        'SofaSofa',
        'Sloan',
        'Slipstick',
        'Sligh',
        'Sleep Number',
        'Skyline Furniture',
        'Skyline',
        'Skye',
        'SK',
        'Simonton',
        'Signature Collection',
        'Sierra',
        'Sharp',
        'Seville Classics',
        'Serta',
        'Sentry',
        'SEI',
        'Sears',
        'Sealy',
        'Sauder',
        'Sara Foam',
        'SAIT',
        'Safco',
        'SAC',
        'Rubbermaid',
        'RST',
        'Royce Clothing',
        'Royalty',
        'Royal Doulton',
        'Royal Comfort',
        'Royal',
        'ROXY',
        'SWING',
        'Standard',
        'Home Interiors',
        'General',
        'Zojirushi',
        'Zinus',
        'Zenith',
        'Zack',
        'Z Gallerie',
        'Winsome',
        'Windsor',
        'Wilton',
        'Wildon Home',
        'White',
        'Whalen',
        'Wesco',
        'Weave',
        'Village Wrought Iron',
        'Toshiba',
        'Titan',
        'Tilia',
        'Sunbrella',
        'Streamlight',
        'Stein World',
        'Simplex',
        'Rosenthal',
        'Murphy Bed Company',
        'Malibu',
        'Longaberger',
        'King Canopy',
        'Intex',
        'Great Outdoors',
        'Boss Office Products',
        'Better Homes & Gardens',
        'Arden',
        'Other',
        'Zuo Modern',
        'Zodiac',
        'Zodax',
        'Zephyr',
        'ZAR',
        'Za',
        'YORK',
        'Yankee Candle',
        'Yamazaki',
        'Yale',
        'X Rocker',
        'Wright',
        'WORX',
        'Worlds Apart',
        'World Industries',
        'Workforce',
        'Wooster',
        'Woodstock',
        'Wooden Mallet',
        'Woodbridge',
        'Wood-Mode',
        'Wolf',
        'WMF',
        'Winchester',
        'Willow Tree',
        'Williams-Sonoma',
        'Johnson',
        'Jem',
        'Jahnke',
        'Jackson Furniture',
        'Jackson',
        'iSi',
        'International Caravan',
        'InterDesign',
        'IKEA',
        'Ideal',
        'Human Touch',
        'Howard Elliott',
        'Household Essentials',
        'Hooker',
        'HON',
        'Homelite',
        'Homeline',
        'HoMedics',
        'Home Trends',
        'Home Essentials',
        'Hickory Chair',
        'Herman Miller',
        'Heartwood',
        'Handmade',
        'Guardian',
        'GTO',
        'Green Machine',
        'Gree',
        'Golden Mattress',
        'Global',
        'Gemini',
        'GE',
        'GARDENA',
        'Furgle',
        'Fred',
        'Franklin',
        'Formica',
        'Ford',
        'other',
    ],
    5702: [
        '3M',
        'Accurate',
        'ACE',
        'Master',
        'Thermos',
        'AbsorbaStone',
        'Accoutrements',
        'Acme',
        'AcuRite',
        'Adams',
        'Adler',
        'AEG',
        'aerolatte',
        'AeroPress',
        'Aicok',
        'Al-De-Chef',
        'Aladdin',
        'All American',
        'All Star',
        'All-Clad',
        'Amana',
        'AMCO',
        'Amco Houseworks',
        'American Harvest',
        'AMF',
        'Amway Queen',
        'Anchor Hocking',
        'Andrea by Sadek',
        'Anne Taintor',
        'Anolon',
        'Anova',
        'Apex',
        'Applica',
        'Aquatec',
        'Arcoroc',
        'Armstrong',
        'AROMA',
        'Arrow',
        'Artcraft',
        'ArtGlass',
        'Arthur Court',
        'Ashley Furniture',
        'Astra',
        'Astro',
        'Ateco',
        'Atlas',
        'Avanti',
        'Avon',
        'bamix',
        'Baumalu',
        'Bella',
        'Berndes',
        'Better Chef',
        'Better Homes',
        'Better Homes & Gardens',
        'Binatone',
        'BKR',
        'BLACK & DECKER',
        'BlenderBottle',
        'Blendtec',
        'BLOCK',
        'bobble',
        'BODUM',
        'Bond',
        'BonJour',
        'Bormioli Rocco',
        'Bosch',
        'Boyd',
        'Brabantia',
        'Breadman',
        'Breville',
        'Bron',
        'Brondell',
        'Bruno',
        'BUILT',
        'Bull',
        'Butler',
        'Cake Boss',
        'Calphalon',
        'Camry',
        'CAN',
        'Canon',
        'Carlton',
        'Carrier',
        'CENTURY',
        'Certified',
        'Champion',
        'Charcoal Companion',
        'Charles Viancin',
        'Chef Craft',
        "Chef'sChoice",
        'Circulon',
        'Clover',
        'Cole & Mason',
        'Coleman',
        'Container Store',
        "Cook's",
        "Cook's Essentials",
        'Cooking Concepts',
        'Cooper',
        'Corona',
        'Country Living',
        'Craftsman',
        'Creative Home',
        'CRISTEL',
        'Crock-Pot',
        'Crystal Quest',
        'Cuisinart',
        'CUTIPOL',
        'Daewoo',
        'Dartington',
        'Deco',
        'Delta',
        'DEMDACO',
        'Denby',
        'Deni',
        'Descoware',
        'Dickies',
        'Dior',
        'Disney',
        'DMT',
        'Dora',
        'Duck',
        'DURABLE',
        'Eagle',
        'ECHO',
        'EKCO',
        'Element',
        'Ello',
        "Emeril's",
        'Essential Home',
        'Euro Cuisine',
        'Euro-Pro',
        'Everbrit',
        'Evergreen Solar',
        'Fagor',
        'Falcon',
        'Fiesta',
        'Fit & Fresh',
        'FoodSaver',
        'Ford',
        'Franciscan',
        'GE',
        'Genius',
        'Golden Rabbit',
        'Good Cook',
        'Gorham',
        'Gotham Steel',
        'Gourmet Settings',
        "Grace's Teaware",
        'GreenPan',
        'Haier',
        'Hamilton Beach',
        'Hampton',
        'Hampton Forg',
        'Handmade',
        'Hanson',
        'Happycall',
        'Harris',
        'Hello Kitty',
        'Hexagon',
        'Hisense',
        'Hoffmaster',
        'Hoffritz',
        'Home Basics',
        'Home Collection',
        'Home Essentials',
        'Home Trends',
        'Hostess',
        'Hotpoint',
        'Hurom',
        'Igloo',
        'IKEA',
        'Imperia',
        'Instant Pot',
        'InterDesign',
        'International Silver',
        'JET',
        'Johnson Brothers',
        'Joseph Joseph',
        'Joy',
        'Joyoung',
        'Juiceman',
        'Jura',
        'Kenmore',
        'Kenwood',
        'King',
        'Kitchen Concepts',
        'Kitchen Craft',
        'Kitchen Selectives',
        'KitchenAid',
        'Kiwi',
        'Klean Kanteen',
        'Kohler',
        'Lansky',
        'Laurie Gates',
        'Le Creuset',
        "Leed's",
        'LEM',
        'LG',
        'Libbey',
        'Lucks',
        'Luminarc',
        'Lux',
        'Magic Chef',
        'Manna',
        'Martha Stewart',
        'Max Factory',
        'Maxi-Matic',
        'Maxim',
        'Melannco',
        'Melitta',
        "Member's Mark",
        'Midea',
        'Miele',
        'Mighty Mug',
        'Mikasa',
        'MOTIV',
        'Moulinex',
        'National',
        'Ninja',
        'Nordic Ware',
        'Noritake',
        'Norwex',
        'NOVA',
        'NuWave',
        'OMEGA',
        'ONEIDA',
        'OTOTO',
        'OXO',
        'Panasonic',
        'Paragon',
        'PARK',
        'Pasabahce',
        'Pasta Express',
        'Pelican',
        'Pentek',
        'Perfect Portions',
        'Philips',
        'Picnic at Ascot',
        'PME',
        'Polder',
        'Portobello',
        'Premier',
        'Primo',
        'Princess House',
        'Progressive International',
        'PUR',
        'Rachael Ray',
        'Rainbow',
        'Regal',
        'Richard Ginori',
        'Roland',
        'Royal Albert',
        'Royal Doulton',
        'Royal Prestige',
        'Royalty',
        'Rubbermaid',
        'Russell Hobbs',
        'SABATIER',
        'Sachi',
        'Salter',
        'Salton',
        'Sambonet',
        'Samsung',
        'SANYO',
        'Scanfrost',
        'Sharp',
        'Siam Tropical',
        'Signature Housewares',
        'SiliconeZone',
        'Silverline',
        'Simplicity',
        'Sistema',
        'Smart Planet',
        'SMEG',
        'Snapware',
        'Square D',
        'Stanley',
        'Steelite International',
        'Sticks',
        'Studio Nova',
        'Suehiro',
        'Summit',
        'Supreme',
        'Swann',
        'Tefal',
        'Thermador',
        'Thinksport',
        'Threshold',
        'Tiger',
        'Titan',
        'Tools of the Trade',
        'Toshiba',
        'Towle',
        'Tramontina',
        'Typhoon',
        'Ultimate Chopper',
        'Unbranded',
        'Unicorn',
        'Universal',
        'Vacmaster',
        'Victory',
        'Villeroy & Boch',
        'Vitamix',
        'VonShef',
        'Watts',
        'Weber',
        'Wedgwood',
        'Whirlpool',
        'White',
        'Wilton',
        'WinCo',
        'Wolf',
        'World Tableware',
        'Yoshihiro',
        'Zepter',
        'Ziploc',
        'Zodiac',
        'Zyliss',
        'Other',
    ],
    5704: [
        'Aqua',
        'Dettol',
        'Finish',
        'General',
        'Tide',
        'ACE',
        'Admiral',
        'Air Wick',
        'Ajax',
        'Alpine',
        'Ariel',
        'AROMA',
        'Astonish',
        'Best',
        'Blanco',
        'Bubbly',
        'Cheer',
        'Clorox',
        'Comet',
        'Comfort',
        'Dawn',
        'Dometic',
        'Downy',
        'Eagle',
        'eco+',
        'Ecozone',
        'Elbow Grease',
        'EnviroCare',
        'Essentials',
        'Eureka',
        'Fabuloso',
        'Fairy',
        'Febreze',
        'Flash',
        'Fresh',
        'Gain',
        'GE',
        'Handmade',
        'Hyper',
        'Kirkland',
        'Kirkland Signature',
        'Kitchen Cleaner',
        'Lysol',
        'Members Mark',
        'Method',
        'Neolife',
        'OxiClean',
        'Pampers',
        'Pearl',
        'Persil',
        'Pure Comfort',
        'Purex',
        'Reinex',
        'Royal',
        'Smart Living',
        'Sniper',
        'Solis',
        'Sticks',
        'Unbranded',
        'Vanish',
        'Wd-40',
        'White',
        'Wind Fresh',
        'Woolite',
        'Zep',
        'Other',
    ],
    5705: [
        'Better Homes',
        'Bexel',
        'Binatone',
        'BKR',
        'BLACK & DECKER',
        'BlenderBottle',
        'Blendtec',
        'BLOCK',
        'Blomberg',
        'Blum',
        'Bomann',
        'Bona',
        'Bonavita',
        'Bond',
        'Bosch',
        'Boscon',
        'Braun',
        'Breville',
        'Brita',
        'Bruno',
        'Buchymix',
        'BUILT',
        'BUNN',
        'Burn Jikokoa',
        'Burton',
        'Bush',
        'Bushburgh',
        'Cake Boss',
        'Calor',
        'Cambro',
        'CAMCO',
        'Camp Chef',
        'Camry',
        'CAN',
        'Candy',
        'Cannon',
        'Canon',
        'Carrier',
        'Carson',
        'Caso',
        'CBK',
        'CDN',
        'CENTURY',
        'Cepsa(Butano)',
        'Certified',
        'Champion',
        'Charcoal Companion',
        'Cheerpower',
        'Chef Craft',
        "Chef'sChoice",
        'Chemex',
        'Chicago Metallic',
        'Chigo',
        'Citizens',
        'Cliff',
        'Clover',
        'Cntronic',
        'Coaster',
        'Cobra',
        'Comark',
        'Container Store',
        "Cook's",
        "Cook's Companion",
        "Cook's Essentials",
        'Cooking Concepts',
        'Cookwork',
        'Cooper',
        'Corona',
        'CRISTEL',
        'Crock-Pot',
        'Cway',
        'Daewoo',
        'Daichi',
        "De'Longhi",
        'Deco',
        'Delta',
        'Deluxe',
        'Dessini',
        'Digitrex',
        'Dove',
        'Dsp',
        'Dualit',
        'Dunelm',
        'Dura Volt',
        'DURABLE',
        'Dzire',
        'EKCO',
        'Elb',
        'Electra',
        'Electriq',
        'Electrolux',
        'Elite Products',
        'Emel',
        'Rite-tek',
        'Rohnson',
        'Royal Albert',
        'Royal Doulton',
        'Royal Family',
        'Royal Prestige',
        'Royal Swiss',
        'Royaltek',
        'Royaltronic',
        'Royalty',
        'Russ',
        'Russell Hobbs',
        'Saint Martins',
        'Saisho',
        'Salter',
        'Samsung',
        'Sandford',
        'Sanford',
        'SANYO',
        'Savanna',
        'Sayona',
        'Scanfrost',
        'SCANPAN',
        'Scarlett',
        'SCHOTT ZWIESEL',
        'Setro',
        'Severin',
        'Sf-400',
        'Shake And Take',
        'Sharp',
        'Sharper Image',
        'Siemens',
        'SiliconeZone',
        'Silver Crest',
        'Silverline',
        'Sinbo',
        'Sky-Oppien Turkey',
        'Skybar',
        'Skyline',
        'Sliver Crest',
        'Smart Home',
        'Smart Planet',
        'SMEG',
        'Smiths',
        'Snowsea',
        'Sokany',
        'Sonifer',
        'Sonik',
        'Sony',
        'Sq Professional',
        'Starlux',
        'Startek',
        'Sterling',
        'Stirling',
        'Su Tai',
        'Sunnex',
        'Super Crown',
        'Supersony',
        'Supreme',
        'Sur La Table',
        'Swan',
        'Swann',
        'Sweethome',
        'Syinix',
        'T.O.P.',
        'Taurus',
        'Tcl',
        'Techno Cool',
        'Tecno Cool',
        'Tefal',
        'Thermocool',
        'ThermoPro',
        'Thermos',
        'Tiger',
        'Toastmaster',
        'Tokunbo',
        'Tornado',
        'Toshiba',
        'Total Gas',
        'Towle',
        'Trifone',
        'Trinity',
        'Tristar',
        'Ugasun',
        'Ultimate Chopper',
        'Unbranded',
        'Universal',
        'Usha',
        'Vacuum Sealer',
        'Vera Wang',
        'Veronica',
        'Vertex',
        'Vinikiz',
        'Vitamix',
        'Vivateck',
        'VonShef',
        'Vtcl',
        'Waring',
        'Watts',
        'Westcool',
        'Westpoint',
        'Whirlpool',
        'White',
        'WinCo',
        'Winning Star',
        'Xper',
        'Yam Pounder',
        'Yohako',
        'Zanussi',
        'Zenker',
        'Zitalo',
        'Essential Home',
        'Euro Premium',
        'Euro-Pro',
        'Eurosonic',
        'Microwave',
        'Excella',
        'Fadar Plus',
        'Fagor',
        'Falcon',
        'Flavia',
        'Flavorwave',
        'Flourish',
        'FoodSaver',
        'Freezeclime',
        'Freshware',
        'Fridgemaster',
        'Frigidaire',
        'Fruit Press',
        'Gaggia',
        'GANZ',
        'Gas Cooker',
        'Gas Land',
        'Gasa',
        'Gates',
        'GE',
        'Geepas',
        'Gemat',
        'Genius',
        'George Foreman',
        'George Home',
        'Gibson',
        'Gift Master',
        'Glamstar',
        'Goldcrown',
        'Goldencrown',
        'Good Cook',
        'Gotham Steel',
        'Gourmet Settings',
        'Gourmia',
        'Gs',
        'GSR',
        'Haeger',
        'Haier',
        'Haier Thermocool',
        'Hamilton Beach',
        'Hana',
        'Handmade',
        'Happy Home',
        'Happycall',
        'Harri',
        'Havells',
        "Heinrich'S",
        'Henkel',
        'Hicel',
        'Hitachi',
        'Hobart',
        'Hoffman',
        'Hoffmaster',
        'Hoffner',
        'Home Basics',
        'Home Collection',
        'Home Essentials',
        'Home Styles',
        'Home Trends',
        'Homeflower',
        'Hoomex',
        'Hoover',
        'Horizon',
        'Hotpoint',
        'Hubert',
        'Hunter',
        'Hurom',
        'Husky',
        'Ideal',
        'Igloo',
        'Ignis',
        'IKEA',
        'IMAGE',
        'Indesit',
        'Instant Pot',
        'Itel',
        'Jd Smp',
        'Jenn-Air',
        'Jikokoa',
        'Johnson Brothers',
        'Joyoung',
        'Juiceman',
        'Kalorik',
        'Kanwood',
        'Kanzi',
        'Kenmore',
        'Kenstar',
        'Kilner',
        'Kinelco',
        'King',
        'King Kooker',
        'King Style',
        'Kitchen Concepts',
        'Kitchen Craft',
        'Kitchen Genie',
        'Kitchen Selectives',
        'KitchenAid',
        'KitchenIQ',
        'Krups',
        'Kuhn Rikon',
        'KUVINGS',
        'Lady Choice',
        'Lavazza',
        'Lec',
        'Legacy',
        'Legend',
        'Lexical',
        'Lexmark',
        'Liebherr',
        'Linkrich',
        'Logik',
        'Lontor',
        'Lux',
        'MAC Knife',
        'Madesmart',
        'Magic',
        'Magic Bullet',
        'Magic Chef',
        'Magic Mill',
        'Manna',
        'Marts Mac',
        'Master',
        'Master Chef',
        'Max Factory',
        'Maxi',
        'Maxi-Matic',
        'Maxim',
        'Maytag',
        'Medion',
        'Midea',
        'Miele',
        'Mika',
        'Mikachi',
        'Mikasa',
        'Montel',
        'Morphy Richards',
        'Mossy Oak',
        'Moulinex',
        'Mpm',
        'Mr. Steel',
        'Murphy Richards',
        'Nakai',
        'National',
        'NESCO',
        'Nespresso',
        'Nesta',
        'Newage',
        'Newcastle',
        'Newmatic',
        'Newtrend',
        'Nexus',
        'Nikai',
        'Nima',
        'Ninja',
        'Nobility Plate',
        'NOVA',
        'Nulek',
        'NutriBullet',
        'NuWave',
        'Omaha',
        'OMEGA',
        'Opaicn',
        'Oraimo',
        'Orienth',
        'Other Brand',
        'Otheritage',
        'Ottimo',
        'Padex',
        'Paloma',
        'Panasonic',
        'Petra',
        'Phiima',
        'Philips',
        'Phima',
        'Pinnacle',
        'PolyScience',
        'Polystar',
        'Power Deluxe',
        'Powerline',
        'Premier',
        'Prestige',
        'Presto',
        'Prime',
        'Primo',
        'Privilege',
        'Progress',
        'Rico',
        'Proline',
        'Pyramid',
        'Qasa',
        'Qlink',
        'Qualy',
        'Quinix',
        'Rada Cutlery',
        'Radof',
        'Raf',
        'Rangemaster',
        'Rangemate',
        'Rinnai',
        'Rashnik',
        'Regency',
        'Repsol',
        'Respoint',
        'Restpoint',
        'Other',
    ],
    5706: [
        'Home Interiors',
        'Powerline',
        'Royal Heritage',
        'VIP',
        'Abercrombie & Ferguson',
        'Adairs',
        'Adairs Kids',
        'Adam Home',
        'Adams',
        'AFC',
        'Agent Provocateur',
        'Agiville',
        'Air Wick',
        'AirCloud',
        'Akai',
        'Akt',
        'Aladdin',
        'Alamode Home',
        'Alfresco',
        'Allen',
        'ALLURE',
        'Aloha',
        'Alpine',
        'AmazonBasics',
        'Ambesonne',
        'Ambiance',
        'AmeliaHome',
        'Amity Home',
        'Amsons',
        'Amy Butler',
        'Andersen',
        'Anka',
        'ANN',
        'Ann Gish',
        'Anna Griffin',
        'Anne Stokes',
        'Any',
        'Apartmento',
        'Apc',
        'Apex',
        'April Cornell',
        'Archipelago',
        'Arctic',
        'Ardor',
        'Argos Home',
        'ARIGHTEX',
        'Ariston',
        'ARK',
        'Aromatique',
        'Artistic Accents',
        'Arya',
        'Ashley Furniture',
        'At Home',
        'Atlantique',
        'Authentic Models',
        'Avondale Manor',
        'Balenciaga',
        'Bali',
        'BALL',
        'Baloo',
        'Bambury',
        'Bar III',
        'Bare Home',
        'Baseus',
        'Bassett',
        'BeA',
        'Beautissu',
        'Becky Cameron',
        'Bed Bath & Beyond',
        'Bedding House',
        'BeddingOutlet',
        'Bedmaker',
        'Bedsure',
        'Beldray',
        'bella notte',
        'Bella Russo',
        'Bellora',
        'Bespoke',
        'BHS',
        'Binatone',
        'Bird',
        'Bktd',
        'Blancho Bedding',
        'BlessLiving',
        'bluebellgray',
        'Bluestone',
        'Bond',
        'Borg',
        'Brandream',
        'Brayden Studio',
        'Brentwood',
        'BRIELLE',
        'Brimix',
        'Brother',
        'Bull',
        'Bulldog',
        'Burlington',
        'Bush',
        'BW',
        'Cabbages & Roses',
        'California Design Den',
        'Calming Comf',
        'Candy',
        'Unbranded',
        'Unifoam',
        'Urban Unique',
        'VCNY',
        'VCNY HOME',
        'Vellmax',
        'Vemax',
        'Veratex',
        'Veron',
        'Versace',
        'Victoria',
        'Victoria Classics',
        'vidaXL',
        'Viking',
        'Vintage Design Homewares',
        'Vintage Maison',
        'Vita Supreme',
        'Vitafoam',
        'Vital Choice',
        'Vue',
        'Wallace',
        'Water Drum',
        'Waterford',
        'Westex',
        'WestPoint Home',
        'Westport',
        'Where The Polka Dots Roam',
        'White',
        'Whitney Home Textile',
        'Wildon Home',
        'Williams Sonoma Home',
        'Windsor',
        'Wolf',
        'Wongs Bedding',
        'Woolric',
        'Word of Dream',
        'Wright',
        'WWE',
        'Xforc',
        'Xg',
        'Xhilaration',
        'YEPINS',
        'Yh',
        'YnM',
        'YORK',
        'Yves Delorme',
        'Z Gallerie',
        'ZAR',
        'ZENSATIO',
        'ZHH',
        'Zodiac',
        'Cannon',
        'Carisder',
        'Caroline',
        'Casablanca',
        'Case',
        'Casper',
        'CAT',
        'Cathay Home',
        'Catimini',
        'Celine Linen',
        'Centa-Star',
        'Century',
        'Cepia',
        'Champion',
        'Charisma',
        'Charlton Home',
        'Chezmoi Collection',
        'Christy',
        'City Scene',
        'CL',
        'Classic Home',
        'Clean',
        'Clorox',
        'Cloth & Canopy',
        'CLOTHKNOW',
        'Clover',
        'Coastal',
        'Coca-Cola',
        'Cocoon',
        'Coleman',
        'Colourful Snail',
        'Comfort Spaces',
        'Company Kids',
        'Cooper',
        'Cotton House',
        'Cottonbox Kids',
        'Country Curtains',
        'Covers & Co',
        'Coyuchi',
        'CRAFT',
        'Creative Home',
        'Crystal',
        'CTI',
        'Ctorch',
        'Cubby House Kid',
        'Cuddledown',
        'D. Porthault',
        'D.light',
        'Dansk',
        'DaVinci',
        'DC',
        'DEA',
        'Debenham',
        'Deco',
        'Deny',
        'Descanso',
        'Design Art',
        'Design Port',
        'Designers Choice',
        'Designers Guild',
        'Disney',
        'Dobnig',
        'Dolce Mela',
        'Dolphin',
        'Donna Karan',
        'Dora',
        'DORMA',
        'Dp',
        'Dreaming Wapiti',
        'Duck',
        'DURABLE',
        'Eagle',
        'EASELAND',
        'Eastern Accents',
        'EasyFit',
        'ECHO',
        'Ecko',
        'Ecomin',
        'EDS',
        'Egyptian Bedding',
        'Elegance',
        'Elegant Comfort',
        'Elegant Home',
        'ELEMENTS',
        'Elepaq',
        'Elite Home Products',
        'Elite Products',
        'Empire',
        'en Vogue',
        'EnvioHome',
        'Essential Home',
        'Essentials',
        'Essina',
        'Estella',
        'Everyday',
        'Expressions',
        'Fab Organizers',
        'FABRIC FANTASTIC',
        'Family',
        'Fashion',
        'Fast',
        'FenDie',
        'Fine Linens',
        'Finlayson',
        'Firman',
        'Florence Broadhurst',
        'Fred',
        'Frette',
        'Frontgate',
        'GABEL',
        'GANZ',
        'Garnet Hill',
        'Geepee',
        'General',
        'Genie',
        'George',
        'Goldwell',
        'Goodcom',
        'Grand Hotel',
        'Gree',
        'Green Lion',
        'GSR',
        'Hampton',
        'Handboss',
        'Handicraft-Palace',
        'Handmade',
        'Happy Kids',
        'Happy Linen Company',
        'Harmony',
        'Harris',
        'Harrods',
        'HC COLLECTION',
        'Heart of House',
        'Hearth & Hand with Magnolia',
        'Hisense',
        'Hobby',
        'Hollander',
        'Home and Living',
        'Home Collection',
        'Home Decorators Collection',
        'Home Essence',
        'Home Essentials',
        'Homebase',
        'HOMEIDEAS',
        'Homescapes',
        'Hotel Collection',
        'House & Home',
        'Huawei',
        'Hunter',
        'Ideal',
        'IKEA',
        'Imex',
        'Imperial Rooms',
        'In Home',
        'Ingco',
        'Intelligent Design',
        'Italian Bed Linen',
        'Itel',
        'Iwin',
        'Jay Franco and Sons, Inc.',
        'JML',
        'John Lewis',
        'Just Home',
        'K Living',
        'KA',
        'Kamisafe',
        'Karcher',
        'Kaws',
        'Kenwood',
        'Kenyon',
        'Kiki',
        'KIND',
        'King',
        'KingLinen',
        'Kirkland',
        'Kitbag',
        'Koo',
        'Latitude Run',
        'Ldnio',
        'lemontree',
        'LG',
        'Liberty',
        'LIFEREVO',
        'Lifesmart',
        'Linden Street',
        'Linear',
        'Lobster Creek',
        'Lonen',
        'Lontor',
        'Loris',
        'Louisiana Bedding',
        'Lux',
        'Lux Decor Collection',
        'Lynx',
        'M&Co',
        'Marie Claire',
        'Martex',
        'Marvel',
        'Master',
        'Matt & Rose',
        'Maxim',
        "Member's Mark",
        'Mercer',
        'Mercury',
        'Merit Linens',
        'Merryfeel',
        'Midea',
        'Millefiori Milano',
        'Mindy',
        'Mixinini',
        'Mmaat',
        'Moon',
        'Moonlight Bedding',
        'Morris',
        'Morrisons',
        'Mothercare',
        'Mouka',
        'Mouka Foam',
        'Mucalis',
        'My World',
        'Natural Comfort',
        'Nautica',
        'Nedens',
        'Nest',
        'New Haven',
        'New Look',
        'Newgain',
        'Newline',
        'NEXT',
        'Night Comfort',
        'Noble Excellence',
        'Nordisk',
        'Normal Bedcover',
        'Nova',
        'Oake',
        'Oraimo',
        'Orange',
        'Orient Sense',
        'Orl',
        'Osram',
        'Ox',
        'Panasonic',
        'Papillon',
        'Patricia Rose',
        'Pearl',
        'Pendleton',
        'Pennine',
        'Pest Reject',
        'Peter Reed',
        'Philips',
        'Pillowfort',
        'Polystar',
        'Portobello',
        'Potter',
        'PRADA',
        'Premier',
        'Prime',
        'Prolinen',
        'PUR',
        'Pure Comfort',
        'Qasa',
        'Rachael Ray',
        'Rainbow',
        'Ralph Lauren',
        'Red Nomad',
        'Regency',
        'Republic',
        'RiNGLEY',
        'Room Essentials',
        'Rosebys',
        'Royal Comfort',
        'Royal Tradition',
        'Sacvin',
        'Scanfrost',
        'Scotsman',
        'Senwei',
        'Serena & Lily',
        'Shark',
        'Sheridan',
        'Shoe Rack',
        'Sia',
        'Signature Bedding',
        'Sijo',
        'Silentnight',
        'Silver',
        'Silver Crest',
        'Silverline',
        'Simon',
        'Simple Luxury',
        'Simplicity',
        'SK',
        'Sleep & Beyond',
        'Sleepcomfort',
        'SLEEPSCENE',
        'Sleeptime',
        'Sleepwell',
        'SNURK',
        'Softan',
        'Sokany',
        'Sona',
        'Sonia Moer',
        'Sonia Rykiel',
        'Sonik',
        'Sony',
        'Spiral',
        'Splendid',
        'Stanle',
        'Sterling',
        'Studio 3B',
        'Style & co',
        'Sumec Fireman',
        'Sunway',
        'Superior',
        'Supreme bedding',
        'Sutefoto',
        'Swan',
        'Sweet Home Collection',
        'Swift Home',
        'TAG',
        'Target',
        'TEC',
        'Ted Baker',
        'The Bed Linen Store',
        'The Better Sleep Company',
        'The Big Sleep',
        'The Company Store',
        'The Industrial Shop',
        'Thermocool',
        'Thermolineo',
        'Thomasville',
        'Threshold',
        'TJC',
        'Todd English',
        'Tommy Hilfiger',
        'Top Breeze',
        'Town',
        'Tranquility',
        'Trina Turk',
        'Truly Soft',
        'Tuya',
        'Ultra',
        'Other',
    ],
    5707: [
        'CENTURY',
        'Hisense',
        'LG',
        'Ox',
        'Panasonic',
        '2gig',
        '3M',
        '3Q',
        '4walls',
        'A&Bt',
        'Accubrush',
        'Accumulair',
        'Accuride',
        'Accuspray',
        'ACE',
        'Acme',
        'AcuRite',
        'Adams',
        'ADT',
        'Advantage',
        'AEG',
        'AEON',
        'Aero-Flo',
        'Aerus',
        'African Master',
        'Afrione',
        'Agri-Fab',
        'AIMS Power',
        'Air King',
        'Air Vent',
        'Air Wick',
        'Airfree',
        'Airlessco',
        'Akai',
        'Akira',
        'Akt',
        'Aladdin',
        'ALEKO',
        'Alfa',
        'Alfi',
        'All Star',
        'Allen',
        'Allen + Roth',
        'AllerAir',
        'Allis-Chalmers',
        'ALLURE',
        'ALNO',
        'Alpine',
        'Alsons',
        'Amaecom',
        'Amarr',
        'Amazon',
        'Amcor',
        'American Standard',
        'American Tourister',
        'AmerTac',
        'AMETEK',
        'AMF',
        'AMP',
        'Amtech',
        'Amway',
        'Andrakk',
        'Anker',
        'Anysew',
        'Apc',
        'Apex',
        'Apollo',
        'Apple',
        'Aqua Mix',
        'AquaSource',
        'Arctic',
        'Arctic Air Ultra',
        'Arctic King',
        'Argo',
        'Ariel',
        'Ariston',
        'ARK',
        'Aroma Coffee',
        'Arrow',
        'Astro',
        'Atlantic',
        'Atlas Homewares',
        'Aube',
        'Aucma',
        'Avon',
        'B-P',
        'Bai',
        'Bajaj',
        'Banan Appeal',
        'Baseus',
        'Baxi',
        'Bayco',
        'Bb',
        'BeA',
        'Beautiful',
        'Beckett',
        'Behr',
        'Beko',
        'Beldray',
        'Belkin',
        'Belwith',
        'Bemis',
        'Best Buy',
        'Bestek',
        'Beyond',
        'Bianco',
        'Bianco Power',
        'Binatone',
        'Bionaire',
        'BISSELL',
        'Black & Decker',
        'Blanco',
        'Blueair',
        'Bluegate',
        'BluWorld',
        'Blyss',
        'Bomann',
        'Bond',
        'Bosch',
        'Boscon',
        'Bostitch',
        'Bradley',
        'Braun',
        'Bravo',
        'Brentwood',
        'Breville',
        'Bright',
        'Brimix',
        'Brookstone',
        'Brother',
        'Bruce',
        'Bruhm',
        'BT',
        'Buddyfly',
        'Burnham Commercial',
        'Bush',
        'Butterfly',
        'C Power',
        'CAMCO',
        'Camry',
        'CAN',
        'Canadian Solar',
        'Candy',
        'Carlton',
        'Caroma',
        'Carrier',
        'Challenge',
        'Challenger',
        'Chicago Electric',
        'Chigo',
        'Citel',
        'Citizen',
        'Classic Home',
        'Cloud',
        'Coleman Cable',
        'Comfortaire',
        'Cooper',
        'Corolla',
        'Crossfire',
        'Crown',
        'Crownstar',
        'Cway',
        'Daewoo',
        'Daikin',
        'Danyo',
        'DBL',
        'Ddk 995+',
        'Deco',
        'Delta',
        'DEWALT',
        'Dimplex',
        'Djack',
        'DMP',
        'Do It Best',
        'Dp',
        'Dp.Led Light',
        'Dstv',
        'DURABLE',
        'DuraVent',
        'Duravit',
        'Duravolt',
        'DuroMax',
        'Dyson',
        'Easy Home',
        'eco+',
        'ELC',
        'Electrolux',
        'Elemax',
        'Elepaq',
        'Elite Products',
        'Emel',
        'Essential Home',
        'Ete',
        'Eurosonic',
        'EZ-FLO',
        'Fadar',
        'Famicare',
        'Fantech',
        'Fineco',
        'Fireman',
        'Flotec',
        'Frigidaire',
        'Fujitsu',
        'Gasa',
        'Gates',
        'GE',
        'Geepee Tank',
        'General',
        'General Tools',
        'Generator',
        'Generic',
        'Genesis',
        'Genius',
        'Glamstar',
        'Global',
        'Goldcrown',
        'Golden Breeze',
        'Golden Diamond',
        'Google',
        'Gotv',
        'Gp',
        'Gree',
        'Greenlee',
        'GSR',
        'Haier',
        'Haier Thermocool',
        'Harman',
        'Havells',
        'Havit',
        'Henry',
        'Hikvision',
        'Hillman',
        'Hitachi',
        'Homax',
        'Home Essentials',
        'Homebase',
        'HoMedics',
        'Homeflower',
        'Homeline',
        'HomeSafe',
        'HON',
        'Honda',
        'Honeywell',
        'Hoover',
        'Hornet',
        'Hotpoint',
        'HP',
        'Huawei',
        'Hudong',
        'Hyundai',
        'Idea',
        'IGNIS',
        'iHome',
        'IKEA',
        'Imose',
        'Indesit',
        'Ingco',
        'InterDesig',
        'Ipower',
        'iRobot',
        'ITE',
        'Itec',
        'Itel',
        'Iwin',
        'Jackson',
        'Jaki',
        'Janome',
        'Jason',
        'Jbl',
        'Jd Smp',
        'JET',
        'Jinling',
        'Jobar',
        'Johnson',
        'Jr',
        'Juki',
        'Juky',
        'Kamisafe',
        'Karcher',
        'Kartel',
        'Kawasaki',
        'KD',
        'Kdk',
        'Keg',
        'Kelvinator',
        'Kemage',
        'Kenmore',
        'Kenstar',
        'Kenwood',
        'Kiki',
        'Kinelco',
        'King',
        'Kingy',
        'Kitchen',
        'Lakewood',
        'LDR',
        'Legend',
        'LENNOX',
        'Lexical',
        'LG Sourcing',
        'Liebherr',
        'Logik',
        'Loki',
        'Longaberger',
        'Lontor',
        'Lucky',
        'Luminou',
        'Lutian',
        'Lutron',
        'Lux',
        'M.Maat',
        'MAC',
        'Majestic',
        'Makita',
        'Mars2',
        'Master Chef',
        'Max Mech',
        'Maxi',
        'Maxi-Torq',
        'Maxim',
        'Maxon',
        'Maxwell',
        'Maytag',
        'Midea',
        'Mercury',
        'Metabo',
        'Mewe',
        'Middle Atlantic Products',
        'Midea',
        'Miele',
        'Mikano',
        'MINI',
        'Mitsubishi',
        'Mkt',
        'Mooved',
        'Morphy Richards',
        'Mouka',
        'MrSteam',
        'Myfan',
        'National',
        'Navigator',
        'Necchi',
        'New Comfort',
        'Newcastle',
        'Newclime',
        'Nexus',
        'Nikai',
        'NOVA',
        'Ok',
        'Olympia',
        'Omaha',
        'Omron',
        'Oraimo',
        'Orbit',
        'ORICO',
        'Orl',
        'Oxygen',
        'Padex',
        'Peak',
        'Pelonis',
        'Perfect Home',
        'Pfaff',
        'Philips',
        'Pinnacle',
        'Polar Bear',
        'Polaris',
        'Poly Vision',
        'Polystar',
        'PONY',
        'Porodo',
        'Power Deluxe',
        'Power Pro',
        'PowerLine',
        'Powerology',
        'Powertec',
        'Prag',
        'Presto',
        'Privileg',
        'PRO',
        'Pro-Tec',
        'Pyramid',
        'Qasa',
        'Qlink',
        'QO',
        'RADOF',
        'Rashnik',
        'Restpoint',
        'Rico',
        'Ring',
        'Rite-Tek',
        'Rosewill',
        'Rowenta',
        'Royal',
        'Royal Sovereign',
        'RST',
        'Rubi',
        'Russ',
        'Russell Hobbs',
        'Ryobi',
        'Saisho',
        'Salpha',
        'Salter',
        'Samsonite',
        'Samsung',
        'Sanford',
        'SANYO',
        'Sara Foam',
        'Scanfrost',
        'Scotch',
        'SEM',
        'Senci',
        'Senwei',
        'Shark',
        'Sharp',
        'Sharp Gold',
        'Siemens',
        'Signature',
        'Silverline',
        'Simply Copper',
        'Singer',
        'SK',
        'Skye',
        'Skyrun',
        'SkyTech',
        'Smarthome',
        'SmartSecurity',
        'Smc',
        'Snowsea',
        'Sokany',
        'Solar',
        'Solarex',
        'Solis',
        'Solitec',
        'Solstar',
        'Sonik',
        'Sony',
        'Starlite',
        'StarTech',
        'Stc',
        'Steamist',
        'Sumec Firman',
        'Sumo Premium',
        'Sunking',
        'Super Master',
        'Super Vision',
        'SuperiorBilt',
        'Swann',
        'Sweethome',
        'SYINIX',
        'TCL',
        'TEC',
        'Techno Cool',
        'Tefal',
        'Thermocool',
        'Tiger',
        'Tiger Claw',
        'TMS',
        'Tmt',
        'Tobi',
        'Toro',
        'Toshiba',
        'Total',
        'Tower',
        'Toyota',
        'TPI',
        'Transparent',
        'Tuya',
        'Two Lion',
        'Ultra',
        'Unique',
        'Universal Tool',
        'USI Electric',
        'Vaporella',
        'Vax',
        'Vesta',
        'Village Wrought Iron',
        'Visonic',
        'Voltplus',
        'Wahl',
        'Water Ace',
        'Waterworks',
        'west elm',
        'Westpoint',
        'Whirlpool',
        'Wiha',
        'WinCo',
        'Wireless Intercom',
        'Woods',
        'Xiantypical',
        'Xiaomi',
        'Yamaha',
        'Yamata',
        'Yoko',
        'YORK',
        'Zanussi',
        'Zenith',
        'Zephyr',
        'Zk',
        'Other',
    ],
    default: [
        'AmazonBasics',
        'Best',
        'Better Homes & Gardens',
        'Garden',
        'General',
        'A B TOOLS',
        'ACE',
        'Allen',
        'AMES',
        'Amtech',
        'Antelco',
        'Aqualin',
        'Aussie',
        'Avon',
        'BLACK+DECKER',
        'Blue',
        'Briers',
        'Brookstone',
        'Bulldog',
        'Burgon & Ball',
        'CAMCO',
        'Case',
        'Craftsman',
        'DURABLE',
        'Falcon',
        'GARDENA',
        'Gardeners Supply Company',
        'Green Blade',
        'Heavy Duty',
        'Hilka',
        'hOme',
        'K Tool',
        'MacKenzie-Childs',
        'Mainstays',
        'McGuire-Nicholas',
        'PARK',
        'Parkside',
        'Perfect Home',
        'Professional',
        'Regal',
        'SE',
        'Spear & Jackson',
        'T.O.P.',
        'Trend',
        'Truper',
        'Wilkinson Sword',
        'WOLF-Garten',
        'Other',
    ],
};
const homeTypes = {
    5701: [
        'Chairs',
        'Tables',
        'Sofas',
        'Beds & Bed Frames',
        'TV Stands & Mounts',
        'Armchairs',
        'Bag Racks',
        'Bar Carts',
        'Bed Headboards & Footboards',
        'Benches, Stools & Bar Stool',
        'Bookcases & Shelving',
        'Cabinets & Cupboards',
        'CD & DVD Racks',
        'Couches',
        'Dining Sets',
        'Drawers',
        'Dressers',
        'Electric Fireplaces',
        'Frameless Furniture',
        'Furniture Accessories',
        'Furniture Parts',
        'Futons, Frames & Covers',
        'Hangers',
        'Hat Stands',
        'Home Office Desks',
        'Kitchen Cabinets & Islands',
        'Lockers',
        'Make-Up Stations',
        'Mattresses',
        'Mirrors',
        'Nightstands',
        'Plant Stands',
        'Poufs & Footstools',
        'Pulpits',
        'Screens & Room Dividers',
        'Shelving Units',
        'Shoe Racks',
        'Side Tables',
        'Sideboards & Buffets',
        'Sun Loungers',
        'Trunks & Chests',
        'Vanities & Makeup Tables',
        'Wardrobes',
        'Other',
    ],
    5702: [
        'Pots & Pans',
        'Cooking Utensils',
        'Flasks',
        'Dinner Sets',
        'Kitchen Racks',
        'Airfryer Liners',
        'Aprons',
        'Baking Utensils',
        'Bar & Cocktail Tools',
        'Bottle Stoppers & Corks',
        'Bowls',
        'Bread Boxes',
        'Butter Dishes',
        'Cake Decorations',
        'Cake Stands',
        'Can Openers',
        'Canisters & Jars',
        'Carafes & Water Pitchers',
        'Chippers',
        'Citrus Press',
        'Cling Film, Foil & Food Wraps',
        'Colanders, Strainers & Sifters',
        'Cooler Bags',
        'Corkscrews & Openers',
        'Cutting Boards',
        'Flatware Sets',
        'Food Dispensers',
        'Food Storage Bags',
        'Food Storage Containers',
        'Garlic Press',
        'Glassware',
        'Graters & Zesters',
        'Ice Buckets',
        'Ice Cubes, Trays & Molds',
        'Kettles & Teapots',
        'Kitchen & Steak Knives',
        'Kitchen Holders',
        'Kitchen Peelers & Slicers',
        'Lids & Covers',
        'Measuring Utensils',
        'Mortar And Pestle',
        'Mugs',
        'Napkins',
        'Oil Filters',
        'Oven Mitts & Pot Holders',
        'Pie, Flan & Tart Tins',
        'Plastic Dishes, Cups & Cutlery',
        'Plates',
        'Platters',
        'Salt & Pepper Shakers & Mills',
        'Scissors & Shears',
        'Sharpeners',
        'Single Flatware Pieces',
        'Straws',
        'Trays',
        'Wine Racks & Bottle Holders',
        'Other',
    ],
    5704: [
        'Multipurpose Liquid Soaps',
        'Laundry Detergents',
        'Toilet Cleaners',
        'Repellents',
        'Kitchen Cleaners',
        'Bathroom Cleaners',
        'Bleach',
        'Carpet and Rug Cleaners',
        'Descalers',
        'Dishwasher Detergents',
        'Disinfectants',
        'Floor Cleaners',
        'Glass Cleaners',
        'Rust Cleaners',
        'Sink & Drain Cleaners',
        'Stain Removers',
        'Tub & Tile Cleaners',
        'Other',
    ],
    5705: [
        'Refrigerators',
        'Cookers',
        'Freezers',
        'Blenders',
        'Microwaves',
        'Air Fryers',
        'Bread Makers',
        'Breakfast Machines',
        'Canisters & Storage',
        'Chafing Dishes',
        'Charcoal Stove',
        'Coffee Grinders',
        'Coffee Machines',
        'Cotton Candy Machines',
        'Deep Fryers',
        'Dehydrators',
        'Dishwashers',
        'Egg Cookers',
        'Food Choppers',
        'Food Grinders',
        'Food Processors',
        'Food Steamers',
        'Food Thermometers',
        'Food Warmers',
        'Gas Cylinders',
        'Gas Detectors',
        'Gas Lighters',
        'Grills & Outdoor Cooking',
        'Heating Mugs & Cups',
        'Hobs',
        'Hot Plates',
        'Ice Cream Makers',
        'Ice Makers',
        'Juicers',
        'Kettles',
        'Kitchen Scales',
        'Knife Sharpeners',
        'Meat Mincers',
        'Mixers',
        'Multi Cooker',
        'Oil Extractors',
        'Ovens',
        'Pancake Makers',
        'Pasta Machines',
        'Pizza Makers',
        'Popcorn Makers',
        'Preserving Cooker',
        'Range Hoods',
        'Rice Cookers',
        'Sandwich Makers',
        'Shawarma Machines',
        'Shawarma Toasters',
        'Slow Cookers',
        'Sous Vide Cookers',
        'Spice Grinders',
        'Thermo Pots',
        'Toasters',
        'Vacuum Sealers',
        'Waffle Irons',
        'Water Dispensers',
        'Water Filters',
        'Yam Pounding Machine',
        'Other',
    ],
    5706: [
        'Lighting',
        'Chandeliers',
        'Curtains, Drapes & Shades',
        'Rugs',
        'Wallpaper',
        '3D Wall Panels',
        'Air Fresheners & Diffusers',
        'Bathroom Textiles',
        'Bedding',
        'Buckets',
        'Candle Holders & Candle Accessories',
        'Candles',
        'Chair Covers',
        'Christmas Tree',
        'Cleaning Accessories',
        'Cleaning Brush',
        'Cleaning Tools',
        'Clocks',
        'Clothes Dryers',
        'Clothes Racks',
        'Curtain Rods & Rails',
        'Decorative Accessories',
        'Decorative Figurines & Statues',
        'Decorative Pillows & Cushion Covers',
        'Decorative Plates, Bowls & Dishes',
        'Dish Cloths',
        'Dish Rack & Dish Drainers',
        'Doormats',
        'Floodlights',
        'Gloves',
        'Hangers',
        'Incense Burners',
        'Ironing Boards',
        'Kitchen Hoods',
        'Kitchen Linens & Textiles',
        'Lanterns',
        'Laundry Accessories',
        'Laundry Baskets',
        'Laundry Cabinets & Shelving',
        'Lightbulbs',
        'Mirrors',
        'Mops',
        'Mosquito Killer',
        'Mosquito Lamps',
        'Mosquito Nets',
        'Noticeboards, Memo boards & Bulletin Boards',
        'Organizer',
        'Padlocks',
        'Pegs',
        'Pendant Lights',
        'Personal Scales',
        'Photo Frames',
        'Plant Pots & Stands',
        'Plants & Flowers',
        'Shoes Racks',
        'Soap Dispensers',
        'Soap Racks',
        'Storage Boxes',
        'Table Cloths & Runners',
        'Table Mats & Placemats',
        'Tissue Holders',
        'Toilet Brushes',
        'Toilet Roll Holder',
        'Toilet Seat Covers',
        'Toothbrush Holders',
        'Toothpaste Dispensers',
        'Vases',
        'Wall Brackets',
        'Wall Decor',
        'Wall Hangers',
        'Waste Bins',
        'Windows Blind',
        'Other',
    ],
    5707: [
        'Air Conditioners',
        'Washing Machines',
        'Fans',
        'Sewing Machines',
        'Irons',
        'Air Coolers',
        'Air Purifiers',
        'Alarm Systems',
        'Bathroom Scales',
        'Dehumidifiers',
        'Door Alarms',
        'Door Phones',
        'Doorbells',
        'Fire Alarms System',
        'Garment Steamer',
        'Hand Dryers',
        'High-Pressure Washers',
        'Humidifiers',
        'Landline Phones',
        'Room Heaters',
        'Smoke Detectors',
        'Towel Warmers',
        'Vacuum Cleaners',
        'Voltage Regulators',
        'Voltage Stabilizers',
        'Water Heaters',
        'Water Tanks',
        'Other',
    ],
    default: [
        'Artificial Grass',
        'Pressure Washers',
        'Plants',
        'Flower Pots',
        'Canopies',
        'Artificial Plants',
        'Bird Houses',
        'Garden & Lawn Stakes',
        'Garden Edging & Borders',
        'Garden Lighting',
        'Garden Sun Umbrellas',
        'Garden Swings',
        'Gardening Gloves & Protective Gear',
        'Gardening Hand Tools',
        'Gazebos',
        'Ground Reinforcement',
        'Hammocks',
        'Insect Traps & Baits',
        'Insect Zappers',
        'Insecticides',
        'Lawn Mowers',
        'Ornaments & Statues',
        'Pebbles, Stones & Step Stones',
        'Pergola',
        'Plant Stands',
        'Planters & Seeders',
        'Plaques & Signs',
        'Watering Equipment',
        'Wheelbarrow',
        'Other',
    ],
};
const homeMaterials = [
    'Fabric',
    'Leather',
    'Marble',
    'MDF',
    'Wood',
    'ABS',
    'Acacia',
    'Acrylic',
    'Acrylic Blend',
    'Agate',
    'Alde',
    'Aluminium',
    'Artificial Leather',
    'Ash',
    'Aspen',
    'Bakelite',
    'Bamboo',
    'Beech',
    'Beech Heartwood',
    'Birch',
    'Bras',
    'Bronze',
    'Cane',
    'Canvas',
    'Cast Iron',
    'Cedar',
    'Ceramic',
    'Cherry',
    'Chestnut',
    'Chrome',
    'Composite Wood',
    'Copper',
    'Cotton',
    'Cotton Blend',
    'Crystal',
    'Ebony',
    'Eucalyptus',
    'Faux Leather',
    'Fir',
    'Formica',
    'Fur',
    'Glass',
    'Gold',
    'Iron',
    'Jarra',
    'Lacquer',
    'Laminate',
    'Linen',
    'Mahogany',
    'Mango',
    'Maple',
    'MDF / Chipboard',
    'Melamine',
    'Metal',
    'Mirror',
    'Mother of Pearl',
    'Nickel',
    'Nylon',
    'Oak',
    'Particle Board',
    'Pewte',
    'Pine',
    'Plastic',
    'Plywood',
    'Polycotton',
    'Polyester',
    'Poplar',
    'Porcelain',
    'PVC',
    'Rattan',
    'Recycled Wood',
    'Resin',
    'Rosewood',
    'Rubber',
    'Rubberwood',
    'Satinwood',
    'Shell',
    'Silk',
    'Silver',
    'Solid Wood',
    'Spruce',
    'Stainless Steel',
    'Steel',
    'Sterling Silver',
    'Suede',
    'Synthetic',
    'Teak',
    'Timber',
    'Tin',
    'Velvet',
    'Vinyl',
    'Walnut',
    'Wicker',
    'Wire',
    'Wool',
    'Wrought Iron',
    'Yew',
    'Zinc Alloy',
    'Other',
];

// Tradesman
const tradesmanType = {
    5803: [
        'Physical Security',
        'Electronic Security',
        'Cybersecurity',
        'Event Security',
        'Transportation & Cargo Security',
        'Asset Protection',
        'Private Investigation',
        'Event Security Planning',
        'Home Security',
        'Government & Public Security',
    ],
    5804: [
        'Cabinetry',
        'Roofer',
        'Repair and Restoration',
        'Cabinetry',
        'Home Renovator',
        'Deck and Porch',
        'Wooden Stairs and Railings',
        'Custom Woodworking',
        'Custom Millwork',
        'Design Services',
        'other',
    ],
    5805: [
        'Residential Interior Designer',
        'Commercial Interior Designer',
        'Hospitality Interior Designer',
        'Healthcare Interior Designer',
        'Kitchen and Bath Designer',
        'Retail Interior Designer',
        'Sustainable Interior Designer',
        'Universal Design Specialist',
        'Set Designer',
        'Corporate Interior Designer',
        'Color Consultant',
        'Furniture and Product Designer',
        'Luxury Interior Designer',
        'Minimalist Interior Designer',
        'Scandinavian Interior Designer',
        'Retro or Vintage Decorator',
        'Virtual Interior Designer',
        'Eclectic Decorator',
    ],
    5806: ['Funmigation', 'Cleaning'],
    5807: [
        'Preventative Maintenance',
        'Residential Drain',
        'Commercial Drain',
        'Emergency Plumbing Services',
        'Hygienic Drain',
        'Septic System Maintenance',
        'Sump Pump Maintenance',
        'Storm Drain',
        'Grease Trap',
        'Gutter and Downspout',
        'Sewer Line',
        'Drain Cleaning',
    ],
    5808: ['Installation', 'Repair', 'Diagnostics', 'Inspection'],
    5809: [
        'Peel and Stick Tiling',
        'Outdoor Tiling',
        'Decorative Tiling',
        'Patterned Tiling',
        'Wood-Look Tiling',
        'Cement Tiling',
        'Terracotta Tiling',
        'Terracotta Tiling',
        'Travertine Tiling',
        'Natural Stone Tiling',
        'Glass Tiling',
        'Porcelain Tiling',
        'Ceramic Tiling',
    ],
    5810: [
        'Fleet Maintenance',
        'Hybrid & Electric Vehicle Technicians',
        'Performance & Tuning Specialists',
        'Diesel Engine Technicians',
        'Tire Technicians',
        'Collision Repair Technicians',
        'HVAC',
        'Electrical & Electronics Technicians',
        'Engine Technician',
        'Transmission Technician',
        'Brake & Suspension Technician',
        'Automotive Diagnostic',
        'Automotive Service Technicians',
    ],
    5811: [
        'Cardio',
        'Basketball',
        'Circuit Training',
        'Dance',
        'Fitness',
        'Football',
        'Swimming',
        'Tennis',
        'Virtual Training',
        'Weight Training',
        'Yoga',
        'Other',
    ],
    5812: [
        'Specialized',
        'E-commerce',
        'Cold Chain',
        'Reverse Logistics',
        'Customs Brokerage & Compliance',
        'Supply Chain Consulting',
        'Inventory Management',
        'Warehousing & Distribution',
        'Transportation Services',
        'Delivery Services',
    ],
    5813: [
        'Network Solutions',
        'Software Development',
        'Cybersecurity',
        'Cloud Computing',
        'Data Management & Analytics',
        'IT Support & Help Desk',
        'Hardware Solutions',
        'Virtualization & Cloud Services',
        'IT Consulting',
        'IT Project Management',
        'ERP (Enterprise Resource Planning)',
        'IoT (Internet of Things)',
        'Digital Transformation',
    ],
};
const tradesmanArea = {
    5802: [
        'Residential',
        'Industrial',
        'Commercial',
        'Upgrade & Installation',
        'Inspection',
        'Specialized services',
        'All',
    ],
    5804: ['Domestic', 'Industrial', 'Commercial', 'Real Estate', 'Corporate Sector', 'All'],
    5805: [
        'Residential',
        'Industrial',
        'Commercial',
        'Upgrade & Installation',
        'Inspection',
        'Specialized services',
        'All',
    ],
    5806: ['Residential', 'Industrial', 'Commercial', 'All'],
    5807: [
        'Residential',
        'Industrial',
        'Commercial',
        'Upgrade & Installation',
        'Inspection',
        'Specialized services',
        'All',
    ],
    5808: [
        'Residential',
        'Industrial',
        'Commercial',
        'Upgrade & Installation',
        'Emergency',
        'Inspection & Code Compliance',
        'Specialized services',
        'All',
    ],
    5809: [
        'Residential',
        'Industrial',
        'Commercial',
        'Upgrade & Installation',
        'Inspection',
        'Specialized services',
        'All',
    ],
    5810: ['Nationwide', 'International', 'Locally', 'All'],

    5812: ['Nationwide', 'International', 'Locally', 'All'],
    5813: [
        'IT Consultation',
        'Training & Knowledge Transfer',
        'Scalability & Upgrades',
        'Monitoring & Maintenance',
        'Security & Compliance',
        'IT Support & Help Desk',
        'Data Management',
        'Cloud Services',
        'Network Setup & Security',
        'Software Development',
        'Procurement & Implementation',
        'Solution Design',
    ],
    default: ['Residential', 'Industrial', 'Commercial', 'All'],
};

// Pets
const petBreeds = {
    6001: [
        'American Eskimo',
        'Boerboel',
        'Caucasian Shepherd',
        'German Shepherd',
        'Lhasa Apso',
        'Affenpinscher',
        'Akita',
        'American Bulldog',
        'American Bully',
        'American English Coonhound',
        'American Pit Bull Terrier',
        'Australian Shepherd',
        'Australian Terrier',
        'Basenji',
        'Basset Hound',
        'Beagle',
        'Belgian Malinois',
        'Belgian Sheepdog',
        'Bichon Frise',
        'Bolognese',
        'Border Terrier',
        'Boston Terrier',
        'Boxer',
        'Bull Terrier',
        'Bulldog',
        'Bullmastiff',
        'Cane Corso',
        'Chihuahua',
        'Chinese Shar-Pei',
        'Chinook',
        'Chow Chow',
        'Cocker Spaniel',
        'Collie',
        'Coton de Tulear',
        'Dalmatian',
        'Doberman Pinscher',
        'Dogo Argentino',
        'Dutch Shepherd',
        'English Cocker Spaniel',
        'English Setter',
        'English Toy Spaniel',
        'Finnish Spitz',
        'Fox Terrier',
        'French Bulldog',
        'German Shorthaired Pointer',
        'Golden Retriever',
        'Great Dane',
        'Havanese',
        'Jack Russell Terrier',
        'Japanese Spitz',
        'Labrador Retrieve',
        'Maltese',
        'Maltese Shih Tzu',
        'Mastiff',
        'Mongrel (No Breed)',
        'Neapolitan Mastiff',
        'Pekingese',
        'Pembroke Welsh Corgi',
        'Pocket Beagle',
        'Pomeranian',
        'Poodle',
        'Pug',
        'Puggle',
        'Puli',
        'Rat Terrier',
        'Rhodesian Ridgeback',
        'Rottweile',
        'Saint Bernard',
        'Samoyed',
        'Shih Tzu',
        'Siberian Husky',
        'Soft Coated Wheaten Terrier',
        'Standard Schnauzer',
        'Tibetan Mastiff',
        'Tibetan Spaniel',
        'Tibetan Terrier',
        'West Highland White Terrier',
        'Other',
    ],
    6004: [
        'American Shorthair',
        'Exotic',
        'Persian',
        'American Wirehair',
        'Turkish Angora',
        'Abyssinian',
        'American Bobtail',
        'American Curl',
        'Balinese',
        'Bengal',
        'Birman',
        'Bombay',
        'British Shorthair',
        'Egyptian Mau',
        'Maine Coon',
        'Mongrel (No Breed)',
        'Ocicat',
        'Scottish Fold',
        'Siamese',
        'Siberian',
        'Snowshoe',
        'Tabby',
        'Turkish Van',
        'Other',
    ],
};
const petTypes = {
    6002: ['Fish for aquariums', 'Air Stones', 'Air Blower', 'Fish for food', 'Other'],
    6003: [
        'Cages',
        'Pets foods',
        'Pet house',
        'The feeds',
        'Hygiene of Pets',
        'Toys',
        'Vitamins',
        'Collar',
        'Dog tag',
        'Leash',
        'Food and water bowls',
        'Harness',
        'Bed',
        'Poo bags (for walks)',
        'Crate and/or travel carrier',
        'Other',
    ],
    6005: [
        'Eagle',
        'Pigeon',
        'Finch',
        'Canary',
        'Crow',
        'Parrot',
        'Peacock',
        'Sparrow',
        'Woodpecker',
        'Other',
    ],
    default: ['Mixed Breed', 'Pure Breed'],
};
//babies category
const babiesBrands = {
    6102: [
        'Pep',
        'Crocs',
        'Fashion',
        'Hi-Way',
        'Nike',
        '2K',
        '3M',
        'A&BC',
        'A&G',
        'Abercrombie & Fitch',
        'Accessorize',
        'ACE',
        'Acme',
        'Active',
        'ACTON',
        'Adams',
        'Adidas',
        'adidas',
        'AdTec',
        'AE',
        'After Six',
        'Agatha Ruiz de la Prada',
        'Aigle',
        'Air Balance',
        'Air force',
        'AIRWALK',
        'Albatros',
        'Aldo',
        'All Star',
        'ALTA',
        'AMAZONAS',
        'Amelia',
        'AMI',
        'Amy Coe',
        'AND1',
        'Anderson Bean',
        'Andrea',
        'Angel',
        'Angels Shoes',
        'Annabelle',
        'Anniel',
        'Aquazzura',
        'ARMANI',
        'Athletic Works',
        'B&B',
        'Babybotte',
        'Back To School',
        'Balenciaga',
        'Barbie',
        'Beau',
        'bebe',
        'Bellissimo',
        'Beverly Hills Polo Club',
        'Birkenstock',
        'Bobbie Brooks',
        'Bobdog',
        'Bogs',
        'Boots',
        'BT',
        'Buckle',
        'Buckle my shoe',
        'Calvin Klein',
        'Candies',
        'Canvas',
        'Carter',
        "Carter's",
        'Cat & Jack',
        'Charlie',
        'China',
        'Clarks',
        'Claudia Ghizzani',
        'Conoli',
        'Converse',
        'Cortina',
        'Crystal',
        'Danskin',
        'Designer',
        'Dino',
        'Dior',
        'Disney',
        'Disney Baby',
        'Divine',
        'Easy',
        'Ecosoft',
        'Elefanten',
        'F&F',
        'FILA',
        'Frozen',
        'George',
        'Georgia',
        'Gioseppo',
        'Graceland',
        'Grosby',
        'Gucci',
        'H&M',
        'Hackett',
        'Handmade',
        'HL',
        'ID',
        'Italia',
        'John Lewis',
        'Jojo Siwa',
        'Jordan',
        'Jump',
        'Karl Lagerfeld',
        'Koala Baby',
        'LA',
        'Lilley',
        'Lilly',
        'Lipsy',
        'Ljt',
        'Loop',
        'Loulou',
        'Madden',
        'Magic',
        'Mario',
        'Marks and Spencer',
        'Mary Jane',
        'Matalan',
        'Max Shoes',
        'Meindl',
        'Meng Ke Xuan',
        'Michael Kors',
        'Mix',
        'Mothercare',
        'Natural World',
        'Nautica',
        'ND',
        'New',
        'New Balance',
        'NEXT',
        'Nickelodeon',
        'Nicole Miller',
        'Nike ACG',
        'No-Name',
        'Old Navy',
        'On',
        'Original',
        'Oscar',
        "OshKosh B'gosh",
        'Outdoor',
        'Papillio',
        'Paul Frank',
        'Polo Ralph Lauren',
        'Primark',
        'PRO',
        'PUMA',
        'Pure',
        'Ralph Lauren',
        'Reebok',
        'REN',
        'RIA Menorca',
        'River Island',
        'Roots',
        'Safe T Step',
        'Salvatore Ferragamo',
        'Sebago',
        'SKECHERS',
        'Smartfit',
        'Soft Touch',
        'SpongeBob',
        'Sporto',
        'Starbury',
        'Steve Madden',
        'Summer',
        "The Children's Place",
        'Theme',
        'Timberland',
        'Tingley',
        "Tom's",
        'Tommy Hilfiger',
        'TOP MODA',
        'TU',
        'US Brass',
        'Versace',
        'Wal Mart',
        'Wellington',
        'Wonder Nation',
        'Zara',
        'Other',
    ],
    6103: [
        'Baby King',
        'BabySmart',
        'Disney',
        'LEGO',
        'Little Tikes',
        'Accoutrements',
        'ALEX',
        'American Airlines',
        'Animal Planet',
        'Applause',
        'Athearn',
        'Atouch',
        'Audi',
        'Aurora',
        'Baby Einstein',
        'Baby First',
        'BABY LOOVI',
        'Bandai',
        'Barbie',
        'Barclay',
        'Battat',
        'Bebe',
        'Bestway',
        'Bmw',
        'Bmx',
        'Brick Game',
        'Bright Starts',
        'BRIO',
        'Character',
        'Chicco',
        'Compass',
        'Cool Mini or Not',
        'Costway',
        'Creative Baby',
        'DC Comics',
        'DEMDACO',
        'Discovery Toys',
        'Disney Pixar',
        'DreamWorks',
        'Duncan',
        'Dynacraft',
        'Earlyears',
        'EDUSHAPE',
        'Fantasy Flight Games',
        'Fat Brain Toys',
        'Ferrari',
        'Fisher-Price',
        'Fun Little Toys',
        'Funko',
        'Funtime',
        'Galoob',
        'GOOC',
        'Great Vision',
        'Green Toys',
        'GUND',
        'Hallmark',
        'Handmade',
        'Happy family',
        'Hasbro',
        'HOMOFY',
        'Huffy',
        'Idino',
        'IKEA',
        'Imagination Generation',
        'Infantino',
        'Intex',
        'iPlay, iLearn',
        'Jeep',
        'Judelink',
        "K's Kids",
        'Kidrobot',
        'Kids II',
        'Kids Preferred',
        'Lamaze',
        'LeapFrog',
        'Learning Resources',
        'Lexus',
        'Li-Link',
        'Lionel',
        'Lmv',
        'Marvel Toys',
        'MasterPieces',
        'Matchbox',
        'Mattel',
        'MEGA',
        'Melissa & Doug',
        'Mercedes-Benz',
        'Munchkin',
        'Nickelodeon',
        'Nintendo',
        'North American Bear Company',
        'Origins',
        'Parker Brothers',
        'Pilsan',
        'PlanToys',
        'PlayGo',
        'Playgro',
        'Playskool',
        'Post',
        'Princess',
        'R&L',
        'Racing Champions',
        'Range Rover',
        'Ravensburger',
        'Razor',
        'Rock Band',
        'Rolls Royce',
        'Russ',
        'Sassy',
        'Schleich',
        'SEGA',
        'Skip Hop',
        'Small World Toys',
        'Smoby',
        'Soft Play',
        'Spin Master',
        'Step2',
        'Taggies',
        'Teddy Bear',
        'The First Years',
        'Todays Kids',
        'TOP BRIGHT',
        'Toyk',
        'Toysmith',
        'Ty',
        'Unbranded',
        'Universal',
        'Vktech',
        'Volkswagen',
        'VTech',
        'Vtech Baby',
        'Warner Bros.',
        'WolVol',
        'Ypad',
        'Other',
    ],
    6104: [
        'Babytrend',
        'Chicco',
        'Graco',
        'Lmv',
        'Mothercare',
        'Britax',
        'Bugaboo',
        'Bumbleride',
        'Combi',
        'Cosco',
        'Evenflo',
        'Fisher Price',
        'Graceland',
        'Ingenuity',
        'Jeep',
        'Kolcraft',
        'Maclaren',
        'Mastela',
        'Maxi-Cosi',
        'Next Generation',
        'Orbit Baby',
        'Peg Perego',
        'Safety 1St',
        'Silver Cross',
        'Stokke',
        'Other',
    ],
    6105: [
        'Obaby',
        'Fridababy (NoseFrida)',
        'Tiny Tatty Teddy',
        'Red Kite',
        'Nuna',
        'Skip Hop',
        'Maxi-Cosi',
        'VTech',
        'Tiny Love',
        'Evenflo',
        'Bright Starts',
        'Chicco',
        'Joie',
        'Mamaroo (by 4moms)',
        'BabyBjörn',
        'Bright Starts',
        '4moms',
        'Ingenuity',
        'Graco',
        'Fisher-Price',
        'other',
    ],
    6109: [
        '3M',
        'ACE',
        'American Standard',
        'Graco',
        'Home Interiors',
        'Acme',
        'Adams',
        'Alera',
        'Alessi',
        'Altak',
        'Angel',
        'Arya',
        'Ashley Furniture',
        'Aussie',
        'Authentic Models',
        'Avanti',
        'Baby Trend',
        'Badger',
        'Bed Bath & Beyond',
        'Better Homes & Gardens',
        'Bird',
        'Blanco',
        'blomus',
        'Bravo',
        'BUILT',
        'Bull',
        'Cambridge',
        'CAN',
        'Casual Home',
        'Champion',
        'Chicago',
        'Chicco',
        'Comfort Research',
        'Company Kids',
        'Cosco',
        'Creative Home',
        'Deco',
        'Delta',
        'Disney',
        'Duck',
        'DURABLE',
        'Fisher-Price',
        'Fun Furnishings',
        'GE',
        'Handmade',
        'Hansa',
        'Happy Baby',
        'Home Made',
        'IKEA',
        'Ingenuity',
        'Intex',
        'Judelink',
        'KD',
        'Kidde',
        'Kidsline',
        'LEGO',
        'Little Tikes',
        'Lmv',
        'Mamakids',
        'Mastela',
        'Mothercare',
        'National',
        'Newline',
        'Papilon',
        'Premier',
        'Shaw',
        'Simmons',
        'Summer Infant',
        'SWING',
        'Triton',
        'Unbranded',
        'White',
        'Wood-Mode',
        'Other',
    ],
    6110: [
        '3M',
        'adidas',
        'Angel',
        "Carter's",
        "The Children's Place",
        '2B Real',
        '2XU',
        '3pommes',
        '5th & Ocean',
        '686',
        '7 For All Mankind',
        '77kids',
        'A&BC',
        'A&G',
        'A&W',
        'a.n.a',
        'Abercrombie & Fitch',
        'Absorba',
        'Academy',
        'Accent',
        'acdc',
        'Active',
        'AD',
        'Adam',
        'Adams',
        'Addison',
        'Admiral',
        'Aerie',
        'After Six',
        'AG Adriano Goldschmied',
        'Aigle',
        'AIKO',
        'Air force',
        'Alchemy',
        'Alexander Julian',
        'Alligator',
        'Allison',
        'Almost Famous',
        'Alpha',
        'Alpinestars',
        'Alviero Martini',
        'Amazon',
        'American Princess',
        "Amy's Closet",
        'Anavini',
        'AND1',
        'Anderson',
        'Andrew Fezza',
        'Angelina',
        'Angels',
        'ANNA',
        'Answer',
        'Anthony',
        'Anvil',
        'Apollo',
        'Apple',
        'Archer',
        'Arena',
        'ARMANI',
        'ASOS',
        'Aspen',
        'Aspire',
        'AST',
        'Athena',
        'Atmosphere',
        'Aurora',
        'Avanti',
        'B&G',
        'B.T. Kids',
        'B2',
        'Babolat',
        'Baby Sara',
        'Babylia',
        'BAD BOY',
        'Bailey',
        'Bailey Boys',
        'Balera',
        'Balmain',
        'Bandai',
        'BAPE',
        'Basic Editions',
        'BeBop',
        'Believe',
        'Ben Sherman',
        'Berry',
        'Bianco',
        'Big Chill',
        'Big Dogs',
        'Biscotti',
        'Blizzard',
        'Blossom',
        'Blueberi Boulevard',
        'Bluebird',
        'Bonnie Baby',
        'Bonnie Jean',
        'Brooks Brothers',
        'Brother',
        'Browning',
        'BTC',
        'Buffalo',
        'Burberry',
        'By Design',
        'Callaway',
        'Calvin Klein',
        'Cargo',
        'Cartoon Network',
        'Castles & Crowns',
        'CAT',
        'Cat & Jack',
        'CCM',
        'Celebrity Pink',
        'Champion',
        'Chanel',
        'Chaos',
        'Chaps',
        'Chaser',
        'Cheetah',
        'Cherokee',
        'Cinderella',
        'CL',
        'Clarks',
        'Classics',
        'Cloth',
        'Collections',
        'Comfort Colors',
        'Company Kids',
        'Cotton On Kids',
        'Country Kids',
        'Couture Princess',
        'Covington',
        'CRAFT',
        'Crazy 8',
        'Creative',
        'Cube',
        'Customized & Personalized',
        'D. Jeans',
        'Darling',
        'DB',
        'Denim & Co.',
        'Dickies',
        'Diesel',
        'Dimensions',
        'Dior',
        'Disney',
        'Disney Couture',
        'District',
        'Divided by H&M',
        'DKNY',
        'Dolce&Gabbana',
        'Dreamgirl',
        'Duck',
        'Dunnes',
        'Dunnes Store',
        'Early Days',
        'EF',
        'EG&G',
        'Element',
        'ESCADA',
        'ESS',
        'ET',
        'F&F',
        'Fancy Nancy',
        'FAS',
        'Fendi',
        'Ferugini',
        'FILA',
        'Fox',
        'Freestyle',
        'G&S',
        'GANT',
        'Gap',
        'Garanimals',
        'Garcia',
        'GB',
        'GB girls',
        'Generic Surplus',
        'Genuine Baby by OshKosh',
        'Genuine Stuff',
        'George',
        'Gerber',
        'Gina',
        'Givenchy',
        'GT',
        'Gucci',
        'H by Hudson',
        'H&M',
        'Halo',
        'Handmade',
        'Hanes',
        'Hang Ten',
        'Happy Fella',
        'Healthtex',
        'Hello Kitty',
        'Hibobi',
        'Hilfiger Denim',
        'Hudson',
        'HUGO BOSS',
        'Ideology',
        'Joe Boxer',
        'Jordan',
        'Joules',
        'Juicy Couture',
        'Jumping Beans',
        'Justice',
        'K2',
        'Karl Kani',
        'Key',
        'Kidgets',
        'Kids Headquarters',
        'KIKO MILANO',
        'Lacoste',
        "Lands' End",
        'Laura Ashley',
        'Lauren',
        'Lee',
        'Lily Rose',
        'Limited Too',
        'Little Darlings',
        'Little Lass',
        'LittleMissMatched',
        'Lola',
        'Looney Tunes',
        'Louis Vuitton',
        'Luvable Friends',
        'Lux',
        'Lv',
        "M&M's",
        'Mango',
        'Mario',
        'Marks and Spencer',
        'Matalan',
        'Maxx',
        'Maya',
        'Mayoral',
        'Metro',
        'MIA',
        'Mickey Mouse',
        'Mimi',
        'Mini Boden',
        'Missoni',
        'Moncler',
        'Monsoon',
        'Moschino',
        'Mothercare',
        'MUJI',
        'Nannette',
        'Nautica',
        'NCAA',
        'ND',
        'New Era',
        'NEXT',
        'Nickelodeon',
        'Nike',
        'Not Specified',
        'Nutmeg',
        'Okaidi',
        'Okie Dokie',
        'Olivia',
        'One A',
        'Orchestra',
        'Otto',
        'Ovs',
        'Papillon',
        'Petit Ami',
        'Pilot',
        'Polo Ralph Lauren',
        'Polo Sport',
        'Prada',
        'Prestige',
        'Primark',
        'Prince',
        'PUMA',
        'Quest',
        'Ralph Lauren',
        'Rare Editions',
        'Reebok',
        'RG Costumes',
        'Rockstar',
        'Santa Cruz',
        'Sergio Tacchini',
        'Signature',
        'Skatersocks',
        'Sky',
        'SO',
        'Sunny Fashion',
        'Superdry',
        'Sweet Dreams',
        'Sweet Kids',
        'Tahari',
        'Team Athletics',
        'Tommy Hilfiger',
        'Toughskins',
        'Tucker',
        'Tulle',
        'Tultex',
        'Tutu Du Monde',
        'Ty',
        'Underwraps Costumes',
        'Unik',
        'Unknown Factory',
        'US Polo Assn.',
        'Versace',
        "Victoria's Secret",
        'Vintage Red',
        'VIP',
        'Waves',
        'Wonder Nation',
        'Woodstock',
        'Woolrich',
        'Wrangler',
        'XOXO',
        'Young Hearts',
        'Youngland',
        'Zara',
        'Zella Girl',
        'Other',
    ],
    6111: [
        'Gerber',
        'Beech-Nut',
        "Ella's Kitchen",
        'Plum Organics',
        'Happy Family Organics',
        'Homemade Baby',
        'Sprout Organic',
        "Earth's Best Organic",
        "Parent's Choice",
        'Little Spoon',
        'Peter Rabbit Organics',
        'Organix (UK Brand)',
        'NurturMe',
        'Amara Organic',
        'Once Upon a Farm',
        'Pure Spoon',
        'Purity Organics',
        'Kiddo Feedo',
        'other',
    ],
    default: [
        'Babytrend',
        'Chicco',
        'Graco',
        'Lmv',
        'Mothercare',
        'Britax',
        'Bugaboo',
        'Bumbleride',
        'Combi',
        'Cosco',
        'Evenflo',
        'Fisher Price',
        'Graceland',
        'Ingenuity',
        'Jeep',
        'Kolcraft',
        'Maclaren',
        'Mastela',
        'Maxi-Cosi',
        'Next Generation',
        'Orbit Baby',
        'Peg Perego',
        'Safety 1St',
        'Silver Cross',
        'Stokke',
        'Other',
    ],
};
const babiesTypes = {
    6101: [
        'Food',
        'Diapers',
        'Feeding Bottles',
        'Lotions',
        'Bath Tubs',
        'Baby Bed Rails',
        'Baby Bed Sheets',
        'Baby Gates',
        'Baby Gift Sets',
        'Baby Grooming Kits',
        'Baby Manicure Sets',
        'Baby Monitors',
        'Baby Oil',
        'Baby Pillow Cases & Shams',
        'Baby Pillows',
        'Baby Powder',
        'Baby Proofing',
        'Baby Scales',
        'Baby Spoons',
        'Baby Wipe Warmers',
        'Bath Accessories',
        'Bathers',
        'Bibs',
        'Blankets & Throws',
        'Bottle Bags',
        'Bottle Brushes',
        'Bottle Drying Racks',
        'Bottle Nipples',
        'Bottle Sterilizers',
        'Bottle Warmers',
        'Bubble Bath',
        'Bumpers',
        'Changing Pads',
        'Changing Pads Covers',
        'Cloth Diapers',
        'Crib Netting & Canopies',
        'Cutlery Sets',
        'Decorative Nursery Pillows',
        'Diaper Bags',
        'Diaper Covers',
        'Diaper Disposal Supplies',
        'Duvet Covers & Sets',
        'Duvets',
        'Formula Dispensers',
        'Mattress Pads & Covers',
        'Nappy Cream',
        'Nappy Sacks',
        'Nasal Aspirators',
        'Nursery Bedding Sets',
        'Pacifier Brushes',
        'Pacifiers',
        'Plates',
        'Potty Training',
        'Shampoo',
        'Shawls',
        'Shower Caps',
        'Sippy Cups & Mugs',
        'Soap',
        'Starter Sets',
        'Sterilizing Tablets',
        'Swim Diapers',
        'Thermometers',
        'Toothbrushes',
        'Toothpaste',
        'Towels',
        'Training Pants',
        'Washcloths',
        'Water Bottles & Cups',
        'Wipes',
        'Other',
    ],
    6102: [
        'Sneakers',
        'School Shoes',
        'Flat Shoes',
        'Sandals',
        'Baby Shoes',
        'Ballet Flats',
        'Boots',
        'Clogs',
        'Flip-Flops',
        'Football Shoes',
        'High Heels',
        'Loafers',
        'Moccasins',
        'Slip-ons',
        'Slippers',
        'Tennis Shoes',
        'Other',
    ],
    6103: [
        'Educational Toys',
        'Bikes',
        'Vehicles',
        'Tricycles, Scooters & Wagons',
        'Outdoor Toys & Play Structures',
        'Action Figures',
        'Arts & Crafts',
        'Baby & Toddler Toys',
        'Balloons',
        'Balls',
        'Basketball Hoops',
        'Books & Coloring Pages',
        'Building Toys',
        'Cereal Toys',
        'Collectible Card Games',
        'Colorforms',
        'Dolls & Dollhouses Supplies',
        'Dress Up & Pretend Play',
        'Electronic & Wind-Up Toys',
        'Etch-A-Sketch',
        'Fast Food Toys',
        'Fidget Spinners',
        'Games',
        'Guns',
        'Jack-in-the-Box',
        'Musical Instruments',
        'Playing Mats',
        'Preschool Toys & Pretend Play',
        'Puppets & Puppet Theaters',
        'RC Models',
        'Robots',
        'Rocking Horses',
        "Rubik's Cube",
        'Slot Cars',
        'Space Toys',
        'Stuffed Animals & Plush Toys',
        'Toy Marbles',
        'Toy Models & Kits',
        'Toy Soldiers',
        'Vintage & Antique Toys',
        'Water Guns',
        'Other',
    ],
    6104: [
        'Rear-Facing Only Infant',
        'Rear-Facing Convertible',
        'Forward-Facing Convertible',
        'High-Back Booster',
        'Backless Booster',
        'Combination Car Seats',
        '3-in-1 Car Seats',
        'All-in-One Car Seats',
        'Special Needs Car Seats',
    ],
    6106: [
        'Breast Pumps',
        'Nursing Pillows',
        'Hospital Delivery Package',
        'Support Belts',
        'Nursing Bras',
        'Breast Pads',
        'Breastmilk Storage Bags',
        'Disposable Pants',
        'Dresses',
        'Fake Pregnancy Belly',
        'Fetal Doppler',
        'Night Gowns',
        'Nipple Shields',
        'Nursing Covers',
        'Pregnancy Seat Belt Adjuster',
        'Sanitary Pads',
        'Sitz Bath',
        'Stretch Marks Cream',
        'Tops',
        'Trousers',
        'Other',
    ],
    6109: [
        'Beds',
        'Chairs',
        'Wardrobes',
        'Tables',
        'Dressers & Drawers',
        'Bed Canopies',
        'Benches',
        'Changing Tables',
        'Desks',
        'Easels',
        'Hooks & Wall Organization',
        'Kids Armoires',
        "Kids' Vanities",
        'Mattresses',
        'Nursery Centers',
        'Nursery Furniture Sets',
        'Nursery Gliders, Rockers & Recliners',
        'Picnic Tables',
        'Play Tents',
        'Rugs',
        'Toy Boxes',
        'Other',
    ],
    6110: [
        'Clothing Sets',
        'Ball Gowns',
        'Dresses',
        'Costumes',
        'Shirts',
        'Agbada',
        'Ballet Camisole',
        'Ballet Dresses',
        'Bathrobes',
        'Bibs',
        'Blazers',
        'Blouses',
        'Bodysuits',
        'Caps',
        'Cardigans',
        'Christening Clothes',
        'Dungarees',
        'Hoodies',
        'Isi Agu',
        'Jeans',
        'Jeggings',
        'Jerseys',
        'Joggers',
        'Jumpsuits',
        'Leggings',
        'Nightwear',
        'Outwear',
        'Overalls',
        'Pants',
        'Pantyhose',
        'Polo Shirts',
        'Pullovers',
        'Rompers',
        'School Uniforms',
        'Shorts',
        'Singlets',
        'Skirts',
        'Socks',
        'Suits',
        'Sweaters',
        'Sweatshirts',
        'Swimwear',
        'T-Shirts',
        'Tops',
        'Tracksuits',
        'Trousers',
        'Underwear',
        'Vests',
        'Other',
    ],
    default: [
        'Jogging Strollers',
        'Double Strollers',
        'All-Terrain Strollers',
        'Carriage or Pram Strollers',
        'Sit and Stand Strollers',
        'High-End Luxury Strollers',
        'Compact/Foldable Strollers',
        'Off-Road or Trail Strollers',
        'Lightweight',
        'Standard',
        'Travel System',
        'Transformable',
        'Other',
    ],
};

// FIlter Form Data
const defaults = [
    {
        id: 'location',
        title: 'Location',
        type: 'modal',
        content_checkbox: false,
        content: [
            {
                type: 'modal',
            },
        ],
    },
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: price.map((price) => ({
            name: 'price',
            value: price.value,
            label: price.label,
        })),
    },
];

// Vehicles (50**)
export const filterFields = [
    {
        id: 'location',
        title: 'Location',
        type: 'modal',
        content_checkbox: false,
        content: [
            {
                type: 'modal',
            },
        ],
    },
    {
        id: 'seller_type',
        title: 'Seller Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'seller_type',
                value: 'dealer',
                label: 'Dealer',
            },
            {
                name: 'seller_type',
                value: 'private',
                label: 'Private',
            },
        ],
    },
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: vehcle_price.map((price) => ({
            name: 'price',
            value: price.value,
            label: price.label,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'vehicle_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition.map((vehicle_condition) => ({
            name: 'vehicle_condition',
            value: vehicle_condition.value,
            label: vehicle_condition.label,
        })),
    },
    {
        id: 'fuel_type',
        title: 'Fuel Type',
        type: 'checkbox',
        content_checkbox: false,
        content: fuel_type.map((fuel_type) => ({
            name: 'fuel_type',
            value: fuel_type.toLowerCase(),
            label: fuel_type,
        })),
    },
    {
        id: 'make',
        title: 'Make',
        type: 'checkbox',
        content_checkbox: false,
        content: make.map((val) => ({ name: 'make', value: val, label: val })),
    },
    {
        id: 'year',
        title: 'Manufacture Year',
        type: 'checkbox',
        content_checkbox: false,
        content: arrayRange(1990, parseInt(new Date().getFullYear()), 1)
            .reverse()
            .map((val) => ({
                name: 'year',
                value: val.toString(),
                label: val.toString(),
            })),
    },
    {
        id: 'transmission',
        title: 'Transmission',
        type: 'checkbox',
        content_checkbox: false,
        content: transmission.map((transmision) => ({
            name: 'transmission',
            value: transmision.toLowerCase(),
            label: transmision,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: vehicleAccessoriesType.map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'vehicle_body',
        title: 'Body',
        type: 'checkbox',
        content_checkbox: false,
        content: vehicle_body.map((vehicle_body) => ({
            name: 'vehicle_body',
            value: vehicle_body.toLowerCase(),
            label: vehicle_body.toUpperCase(),
        })),
    },
    {
        id: 'number_of_door',
        title: 'Doors',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'number_of_door',
                value: '',
                label: 'Any',
            },
            {
                name: 'number_of_door',
                value: '1',
                label: '1 Door',
            },
            {
                name: 'number_of_door',
                value: '2',
                label: '2 Doors',
            },
            {
                name: 'number_of_door',
                value: '3',
                label: '3 Doors',
            },
            {
                name: 'number_of_door',
                value: '4',
                label: '4 Doors',
            },
            {
                name: 'number_of_door',
                value: '5',
                label: '5 Doors',
            },
            {
                name: 'number_of_door',
                value: '6',
                label: 'Others',
            },
        ],
    },
    {
        id: 'millage',
        title: 'Millage',
        type: 'radio',
        content_checkbox: false,
        content: [
            {
                name: 'millage',
                value: '',
                label: 'Any',
            },
            {
                name: 'millage',
                value: '5000',
                label: 'Up to 5,000 miles',
            },
            {
                name: 'millage',
                value: '10000',
                label: 'Up to 10,000 miles',
            },
            {
                name: 'millage',
                value: '15000',
                label: 'Up to 15,000 miles',
            },
            {
                name: 'millage',
                value: '20000',
                label: 'Up to 20,000 miles',
            },
            {
                name: 'millage',
                value: '30000',
                label: 'Up to 30,000 miles',
            },
            {
                name: 'millage',
                value: '40000',
                label: 'Up to 40,000 miles',
            },
            {
                name: 'millage',
                value: '70000',
                label: 'Up to 70,000 miles',
            },
            {
                name: 'millage',
                value: '80000',
                label: 'Over 80,000 miles',
            },
        ],
    },
];
const cars = [
    {
        id: 'location',
        title: 'Location',
        type: 'modal',
        content_checkbox: false,
        content: [
            {
                type: 'modal',
            },
        ],
    },
    {
        id: 'seller_type',
        title: 'Seller Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'seller_type',
                value: 'dealer',
                label: 'Dealer',
            },
            {
                name: 'seller_type',
                value: 'private',
                label: 'Private',
            },
        ],
    },
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: vehcle_price.map((price) => ({
            name: 'price',
            value: price.value,
            label: price.label,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'vehicle_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'vehicle_condition',
                value: 'nigeria use',
                label: 'Nigerian Used',
            },
            {
                name: 'vehicle_condition',
                value: 'foreign use',
                label: 'Foreign Used',
            },
            {
                name: 'vehicle_condition',
                value: 'new',
                label: 'Brand New',
            },
        ],
    },
    {
        id: 'fuel_type',
        title: 'Fuel Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'fuel_type',
                value: 'hybrid',
                label: 'Hybrid',
            },
            {
                name: 'fuel_type',
                value: 'petrol',
                label: 'Petrol',
            },
            {
                name: 'fuel_type',
                value: 'diesel',
                label: 'Diesel',
            },
            {
                name: 'fuel_type',
                value: 'gas',
                label: 'Gas',
            },
        ],
    },
    {
        id: 'make',
        title: 'Make',
        type: 'checkbox',
        content_checkbox: false,
        content: make.map((val) => ({ name: 'make', value: val, label: val })),
    },
    {
        id: 'year',
        title: 'Manufacture Year',
        type: 'checkbox',
        content_checkbox: false,
        content: arrayRange(1990, parseInt(new Date().getFullYear()), 1)
            .reverse()
            .map((val) => ({
                name: 'year',
                value: val.toString(),
                label: val.toString(),
            })),
    },
    {
        id: 'transmission',
        title: 'Transmission',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'transmission',
                value: 'automatic',
                label: 'Automatic',
            },
            {
                name: 'transmission',
                value: 'manual',
                label: 'Manual',
            },
            {
                name: 'transmission',
                value: 'hybrid',
                label: 'Hybrid',
            },
            {
                name: 'transmission',
                value: 'cvt',
                label: 'CVT',
            },
        ],
    },
    {
        id: 'millage',
        title: 'Millage',
        type: 'radio',
        content_checkbox: false,
        content: [
            {
                name: 'millage',
                value: '',
                label: 'Any',
            },
            {
                name: 'millage',
                value: '5000',
                label: 'Up to 5,000 miles',
            },
            {
                name: 'millage',
                value: '10000',
                label: 'Up to 10,000 miles',
            },
            {
                name: 'millage',
                value: '15000',
                label: 'Up to 15,000 miles',
            },
            {
                name: 'millage',
                value: '20000',
                label: 'Up to 20,000 miles',
            },
            {
                name: 'millage',
                value: '30000',
                label: 'Up to 30,000 miles',
            },
            {
                name: 'millage',
                value: '40000',
                label: 'Up to 40,000 miles',
            },
            {
                name: 'millage',
                value: '70000',
                label: 'Up to 70,000 miles',
            },
            {
                name: 'millage',
                value: '80000',
                label: 'Over 80,000 miles',
            },
        ],
    },
];
const vans = [
    {
        id: 'location',
        title: 'Location',
        type: 'modal',
        content_checkbox: false,
        content: [
            {
                type: 'modal',
            },
        ],
    },
    {
        id: 'seller_type',
        title: 'Seller Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'seller_type',
                value: 'dealer',
                label: 'Dealer',
            },
            {
                name: 'seller_type',
                value: 'private',
                label: 'Private',
            },
        ],
    },
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: vehcle_price.map((price) => ({
            name: 'price',
            value: price.value,
            label: price.label,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'vehicle_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'vehicle_condition',
                value: 'nigeria use',
                label: 'Nigerian Used',
            },
            {
                name: 'vehicle_condition',
                value: 'foreign use',
                label: 'Foreign Used',
            },
            {
                name: 'vehicle_condition',
                value: 'new',
                label: 'Brand New',
            },
        ],
    },
    {
        id: 'fuel_type',
        title: 'Fuel Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'fuel_type',
                value: 'hybrid',
                label: 'Hybrid',
            },
            {
                name: 'fuel_type',
                value: 'petrol',
                label: 'Petrol',
            },
            {
                name: 'fuel_type',
                value: 'diesel',
                label: 'Diesel',
            },
            {
                name: 'fuel_type',
                value: 'gas',
                label: 'Gas',
            },
        ],
    },
    {
        id: 'make',
        title: 'Make',
        type: 'checkbox',
        content_checkbox: false,
        content: make.map((val) => ({ name: 'make', value: val, label: val })),
    },
    {
        id: 'year',
        title: 'Manufacture Year',
        type: 'checkbox',
        content_checkbox: false,
        content: arrayRange(1990, parseInt(new Date().getFullYear()), 1)
            .reverse()
            .map((val) => ({
                name: 'year',
                value: val.toString(),
                label: val.toString(),
            })),
    },
    {
        id: 'transmission',
        title: 'Transmission',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'transmission',
                value: 'automatic',
                label: 'Automatic',
            },
            {
                name: 'transmission',
                value: 'manual',
                label: 'Manual',
            },
            {
                name: 'transmission',
                value: 'hybrid',
                label: 'Hybrid',
            },
            {
                name: 'transmission',
                value: 'cvt',
                label: 'CVT',
            },
        ],
    },
    {
        id: 'millage',
        title: 'Millage',
        type: 'radio',
        content_checkbox: false,
        content: [
            {
                name: 'millage',
                value: '',
                label: 'Any',
            },
            {
                name: 'millage',
                value: '5000',
                label: 'Up to 5,000 miles',
            },
            {
                name: 'millage',
                value: '10000',
                label: 'Up to 10,000 miles',
            },
            {
                name: 'millage',
                value: '15000',
                label: 'Up to 15,000 miles',
            },
            {
                name: 'millage',
                value: '20000',
                label: 'Up to 20,000 miles',
            },
            {
                name: 'millage',
                value: '30000',
                label: 'Up to 30,000 miles',
            },
            {
                name: 'millage',
                value: '40000',
                label: 'Up to 40,000 miles',
            },
            {
                name: 'millage',
                value: '70000',
                label: 'Up to 70,000 miles',
            },
            {
                name: 'millage',
                value: '80000',
                label: 'Over 80,000 miles',
            },
        ],
    },
    {
        id: 'number_of_door',
        title: 'Doors',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'number_of_door',
                value: '',
                label: 'Any',
            },
            {
                name: 'number_of_door',
                value: '1',
                label: '1 Door',
            },
            {
                name: 'number_of_door',
                value: '2',
                label: '2 Doors',
            },
            {
                name: 'number_of_door',
                value: '3',
                label: '3 Doors',
            },
            {
                name: 'number_of_door',
                value: '4',
                label: '4 Doors',
            },
            {
                name: 'number_of_door',
                value: '5',
                label: '5 Doors',
            },
            {
                name: 'number_of_door',
                value: '6',
                label: 'Others',
            },
        ],
    },
];
const automobile = [
    {
        id: 'location',
        title: 'Location',
        type: 'modal',
        content_checkbox: false,
        content: [
            {
                type: 'modal',
            },
        ],
    },
    {
        id: 'seller_type',
        title: 'Seller Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'seller_type',
                value: 'dealer',
                label: 'Dealer',
            },
            {
                name: 'seller_type',
                value: 'private',
                label: 'Private',
            },
        ],
    },
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: vehcle_price.map((price) => ({
            name: 'price',
            value: price.value,
            label: price.label,
        })),
    },
    {
        id: 'vehicle_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'vehicle_condition',
                value: 'nigeria use',
                label: 'Nigerian Used',
            },
            {
                name: 'vehicle_condition',
                value: 'foreign use',
                label: 'Foreign Used',
            },
            {
                name: 'vehicle_condition',
                value: 'new',
                label: 'Brand New',
            },
        ],
    },
    {
        id: 'fuel_type',
        title: 'Fuel Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'fuel_type',
                value: 'hybrid',
                label: 'Hybrid',
            },
            {
                name: 'fuel_type',
                value: 'petrol',
                label: 'Petrol',
            },
            {
                name: 'fuel_type',
                value: 'diesel',
                label: 'Diesel',
            },
            {
                name: 'fuel_type',
                value: 'gas',
                label: 'Gas',
            },
        ],
    },
    {
        id: 'make',
        title: 'Make',
        type: 'checkbox',
        content_checkbox: false,
        content: make.map((val) => ({ name: 'make', value: val, label: val })),
    },
    {
        id: 'year',
        title: 'Manufacture Year',
        type: 'checkbox',
        content_checkbox: false,
        content: arrayRange(1990, parseInt(new Date().getFullYear()), 1)
            .reverse()
            .map((val) => ({
                name: 'year',
                value: val.toString(),
                label: val.toString(),
            })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: otherVehicleType.map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'vehicle_body',
        title: 'Body',
        type: 'checkbox',
        content_checkbox: false,
        content: vehicle_body.map((vehicle_body) => ({
            name: 'vehicle_body',
            value: vehicle_body.toLowerCase(),
            label: vehicle_body.toUpperCase(),
        })),
    },
];

// Properties.
const propertyFields = [
    {
        id: 'location',
        title: 'Location',
        type: 'modal',
        content_checkbox: false,
        content: [
            {
                type: 'modal',
            },
        ],
    },
    {
        id: 'seller_type',
        title: 'Seller Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'seller_type',
                value: 'dealer',
                label: 'Dealer',
            },
            {
                name: 'seller_type',
                value: 'private',
                label: 'Private',
            },
        ],
    },
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '1500000',
                label: 'Under 1.5m',
            },
            {
                name: 'price',
                value: '3000000',
                label: '1.5m to 3m',
            },
            {
                name: 'price',
                value: '7500000',
                label: '3m to 7.5m',
            },
            {
                name: 'price',
                value: '11000000',
                label: '7.5m to 11m',
            },
            {
                name: 'price',
                value: '>11000000',
                label: '11m and more',
            },
        ],
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((condition) => ({
            name: 'ad_condition',
            value: condition.value,
            label: condition.label,
        })),
    },
];
const propertyHouseApartment = [
    {
        id: 'location',
        title: 'Location',
        type: 'modal',
        content_checkbox: false,
        content: [
            {
                type: 'modal',
            },
        ],
    },
    {
        id: 'seller_type',
        title: 'Seller Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'seller_type',
                value: 'dealer',
                label: 'Dealer',
            },
            {
                name: 'seller_type',
                value: 'private',
                label: 'Private',
            },
        ],
    },
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: vehcle_price.map((price) => ({
            name: 'price',
            value: price.value,
            label: price.label,
        })),
    },
    {
        id: 'property_type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: propertyType.default?.map((type) => ({
            name: 'property_type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'facilities',
        title: 'Facilities',
        type: 'checkbox',
        content_checkbox: false,
        content: propertyFacilities.default.concat(propertyFacilities[5101])?.map((facility) => ({
            name: 'facilities',
            value: facility,
            label: facility,
        })),
    },
];

const propertyLand = [
    {
        id: 'location',
        title: 'Location',
        type: 'modal',
        content_checkbox: false,
        content: [
            {
                type: 'modal',
            },
        ],
    },
    {
        id: 'seller_type',
        title: 'Seller Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'seller_type',
                value: 'dealer',
                label: 'Dealer',
            },
            {
                name: 'seller_type',
                value: 'private',
                label: 'Private',
            },
        ],
    },
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: vehcle_price.map((price) => ({
            name: 'price',
            value: price.value,
            label: price.label,
        })),
    },
    {
        id: 'property_type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: propertyType[5105]?.map((type) => ({
            name: 'property_type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'facilities',
        title: 'Facilities',
        type: 'checkbox',
        content_checkbox: false,
        content: propertyFacilities[5105]?.map((facility) => ({
            name: 'facilities',
            value: facility,
            label: facility,
        })),
    },
];
const years = [
    { label: 'All', value: '' },
    { label: '0 - 5 years', value: '5' },
    { label: '5 - 10 years', value: '10' },
    { label: '10 - 15 years', value: '15' },
    { label: '15 - 20 years', value: '20' },
    { label: '20 years+', value: '>20' },
];
// services:
const serviceDefault = [
    ...defaults,
    {
        id: 'years',
        title: 'Years of Experience',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_years',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_years',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: years.map((year) => ({
            name: 'years',
            value: year.value,
            label: year.label,
        })),
    },
    {
        id: 'available_for_travel',
        title: 'Available to Travel?',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'available_for_travel',
                value: 'yes',
                label: 'Yes',
            },
            {
                name: 'available_for_travel',
                value: 'no',
                label: 'No',
            },
        ],
    },
];

const serviceOffice = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5201]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const serviceFood = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5202]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const serviceWeddings = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5203]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const serviceChildCare = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5204]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const serviceMaintenance = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5205]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const serviceTutorial = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5206]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'topic',
        title: 'Tutorial Type',
        type: 'checkbox',
        content_checkbox: false,
        content: tutorialTopics?.map((topic) => ({
            name: 'topic',
            value: topic,
            label: topic,
        })),
    },
];

const serviceClothing = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5207]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const serviceAutomotive = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5208]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const serviceEntertainment = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5209]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const serviceTravel = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5210]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const serviceGoods = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5211]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const serviceLegal = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5212]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const serviceTransport = [
    ...serviceDefault,
    {
        id: 'type',
        title: 'Service Type',
        type: 'checkbox',
        content_checkbox: false,
        content: servicesType[5213]?.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

// agriculture

const agric = [
    ...defaults,
    {
        id: 'type',
        title: 'Farm Filter',
        type: 'checkbox',
        content_checkbox: false,
        content: agricultureTypes[5301]
            .concat(agricultureTypes[5302], agricultureTypes[5303], agricultureTypes[5304])
            .map((farm) => ({
                name: farm,
                value: farm,
                label: farm,
            })),
    },
];

const agricultureAnimal = [
    ...defaults,
    {
        id: 'age',
        title: 'Years of Experience',
        type: 'radio',
        content_checkbox: false,
        content: [
            {
                name: 'age',
                value: '',
                label: 'All',
            },
            {
                name: 'age',
                value: '1-2',
                label: '1 - 2 years',
            },
            {
                name: 'age',
                value: '2-4',
                label: '2 - 4 years',
            },
            {
                name: 'age',
                value: '4-6',
                label: '4 - 6 years',
            },
            {
                name: 'age',
                value: '20',
                label: '6 - 8 years',
            },
            {
                name: 'age',
                value: '>8',
                label: '8 years+',
            },
        ],
    },
    {
        id: 'type',
        title: 'Animal Type',
        type: 'checkbox',
        content_checkbox: false,
        content: agricultureTypes[5301].map((animal) => ({
            name: animal,
            value: animal,
            label: animal,
        })),
    },
];

const agricultureFarm = [
    ...defaults,
    {
        id: 'type',
        title: 'Farm Produce',
        type: 'checkbox',
        content_checkbox: false,
        content: agricultureTypes[5302].map((farm) => ({
            name: farm,
            value: farm,
            label: farm,
        })),
    },
];

const agricultureEquipment = [
    ...defaults,
    {
        id: 'type',
        title: 'Farm Equipment',
        type: 'checkbox',
        content_checkbox: false,
        content: agricultureTypes[5303].map((equipment) => ({
            name: equipment,
            value: equipment,
            label: equipment,
        })),
    },
];

const agricultureFeed = [
    ...defaults,
    {
        id: 'type',
        title: 'Farm Seeds / Feeds',
        type: 'checkbox',
        content_checkbox: false,
        content: agricultureTypes[5304].map((feed) => ({
            name: feed,
            value: feed,
            label: feed,
        })),
    },
];

// Electronics Filter Form
const electronic = [
    ...defaults,
    {
        id: 'type',
        title: 'Electronic Type',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsType[5407]
            .concat(
                electronicsType[5404],
                electronicsType[5405],
                electronicsType[5408],
                electronicsType[5410]
            )
            .map((type) => ({
                name: 'type',
                value: type,
                label: type,
            })),
    },
    {
        id: 'type',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsBrands.default.map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'refurbished',
                label: 'Refurbished',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'New',
            },
        ],
    },
    {
        id: 'type',
        title: 'Display Size',
        type: 'checkbox',
        content_checkbox: false,
        content: displaySizes.map((size) => ({
            name: size,
            value: size,
            label: size,
        })),
    },
];

const electronics01 = [
    ...defaults,
    {
        id: 'type',
        title: 'Electronic Type',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsType[5407]
            .concat(
                electronicsType[5404],
                electronicsType[5405],
                electronicsType[5408],
                electronicsType[5410]
            )
            .map((type) => ({
                name: 'type',
                value: type,
                label: type,
            })),
    },
    {
        id: 'type',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsBrands[5401].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'refurbished',
                label: 'Refurbished',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'New',
            },
        ],
    },
];
const electronics02 = [
    ...defaults,
    {
        id: 'type',
        title: 'Electronic Type',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsType[5407]
            .concat(
                electronicsType[5404],
                electronicsType[5405],
                electronicsType[5408],
                electronicsType[5410]
            )
            .map((type) => ({
                name: 'type',
                value: type,
                label: type,
            })),
    },
    {
        id: 'type',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsBrands[5402].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((val) => ({
            name: 'ad_condition',
            value: val.value,
            label: val.label,
        })),
    },
];
const electronics03 = [
    ...defaults,
    {
        id: 'type',
        title: 'Electronic Type',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsType[5407]
            .concat(
                electronicsType[5404],
                electronicsType[5405],
                electronicsType[5408],
                electronicsType[5410]
            )
            .map((type) => ({
                name: 'type',
                value: type,
                label: type,
            })),
    },
    {
        id: 'type',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsBrands[5403].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((val) => ({
            name: 'ad_condition',
            value: val.value,
            label: val.label,
        })),
    },
];
const electronics06 = [
    ...defaults,
    {
        id: 'type',
        title: 'Electronic Type',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsType[5407]
            .concat(
                electronicsType[5404],
                electronicsType[5405],
                electronicsType[5408],
                electronicsType[5410]
            )
            .map((type) => ({
                name: 'type',
                value: type,
                label: type,
            })),
    },
    {
        id: 'type',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsBrands[5406].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((val) => ({
            name: 'ad_condition',
            value: val.value,
            label: val.label,
        })),
    },
];
const electronics09 = [
    ...defaults,
    {
        id: 'type',
        title: 'Electronic Type',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsType[5407]
            .concat(
                electronicsType[5404],
                electronicsType[5405],
                electronicsType[5408],
                electronicsType[5410]
            )
            .map((type) => ({
                name: 'type',
                value: type,
                label: type,
            })),
    },
    {
        id: 'type',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsBrands[5409].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((val) => ({
            name: 'ad_condition',
            value: val.value,
            label: val.label,
        })),
    },
];
const electronics04 = [
    ...defaults,
    {
        id: 'type',
        title: 'Electronic Type',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsType[5404].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'type',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsBrands[5404].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((val) => ({
            name: 'ad_condition',
            value: val.value,
            label: val.label,
        })),
    },
];
const electronics05 = [
    ...defaults,
    {
        id: 'type',
        title: 'Electronic Type',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsType[5405].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'type',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsBrands[5405].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((val) => ({
            name: 'ad_condition',
            value: val.value,
            label: val.label,
        })),
    },
];
const electronics07 = [
    ...defaults,
    {
        id: 'type',
        title: 'Electronic Type',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsType[5407].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'type',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsBrands[5407].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((val) => ({
            name: 'ad_condition',
            value: val.value,
            label: val.label,
        })),
    },
];
const electronics08 = [
    ...defaults,
    {
        id: 'type',
        title: 'Electronic Type',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsType[5408].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'type',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsBrands[5408].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((val) => ({
            name: 'ad_condition',
            value: val.value,
            label: val.label,
        })),
    },
];
const electronics10 = [
    ...defaults,
    {
        id: 'type',
        title: 'Electronic Type',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsType[5410].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'type',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: electronicsBrands[5410].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((val) => ({
            name: 'ad_condition',
            value: val.value,
            label: val.label,
        })),
    },
];

// Fashion
const fashion = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionBrands.default.map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionTypes.default.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: color,
            value: color,
            label: color,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'New',
            },
        ],
    },
    {
        id: 'size',
        title: 'Size',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionSizes.default.map((size) => ({
            name: size,
            value: size,
            label: size,
        })),
    },
    {
        id: 'material',
        title: 'Material',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionMaterials.default.map((material) => ({
            name: material,
            value: material,
            label: material,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
];

const fashion01 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionBrands[5501].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionTypes[5501].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: color,
            value: color,
            label: color,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub
            .filter((val) => val.value !== 'refurbished')
            .map((val) => ({
                name: 'ad_condition',
                value: val.value,
                label: val.label,
            })),
    },
    {
        id: 'size',
        title: 'Size',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionSizes[5501].map((size) => ({
            name: size,
            value: size,
            label: size,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
];

const fashion03 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionBrands[5503].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionTypes[5503].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: color,
            value: color,
            label: color,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'New',
            },
        ],
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
];

const fashion04 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionBrands.default.map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionTypes[5504].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: color,
            value: color,
            label: color,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'New',
            },
        ],
    },
    {
        id: 'material',
        title: 'Material',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionMaterials[5504].map((material) => ({
            name: material,
            value: material,
            label: material,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
];

const fashion06 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionBrands[5506].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'New',
            },
        ],
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
    {
        id: 'style',
        title: 'Style',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'style',
                value: 'business',
                label: 'Business',
            },
            {
                name: 'style',
                value: 'casual',
                label: 'Casual',
            },
            {
                name: 'style',
                value: 'sport',
                label: 'Sport',
            },
            {
                name: 'style',
                value: 'other',
                label: 'Other',
            },
        ],
    },
];

const fashion07 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionBrands[5507].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: fashionTypes[5507].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: color,
            value: color,
            label: color,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'New',
            },
        ],
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
];

// Health and Beauty
const health = [...defaults];
const health01 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: healthBrands[5601].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: healthTypes[5601].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: color,
            value: color,
            label: color,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'New',
            },
        ],
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
];

const health02 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: healthBrands[5602].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: healthTypes[5602].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'New',
            },
        ],
    },
    {
        id: 'age',
        title: 'Age Group',
        type: 'radio',
        content_checkbox: false,
        content: age_group.map((age) => ({
            name: 'age',
            value: age.toLowerCase(),
            label: age,
        })),
    },
    {
        id: 'formulation',
        title: 'Formulation',
        type: 'radio',
        content_checkbox: false,
        content: healthProductFormulation.default.map((formulation) => ({
            name: 'formulation',
            value: formulation.toLowerCase(),
            label: formulation,
        })),
    },
];

const health03 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: healthBrands[5603].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: healthTypes[5603].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'formulation',
        title: 'Formulation',
        type: 'radio',
        content_checkbox: false,
        content: healthProductFormulation[5603].map((formulation) => ({
            name: 'formulation',
            value: formulation.toLowerCase(),
            label: formulation,
        })),
    },
];

const health04 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: healthBrands[5604].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: healthTypes[5604].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const health05 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: healthBrands[5605].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: healthTypes[5605].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: color,
            value: color,
            label: color,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'New',
            },
        ],
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
];

const health06 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: healthBrands[5606].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: healthTypes[5606].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
];

const health07 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: healthBrands[5607].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: healthTypes[5607].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
];

const health08 = [
    ...defaults,
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: healthTypes[5608].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'New',
            },
        ],
    },
];

// Home and Accessories
const home = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: homeBrands.default.map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: homeTypes.default.map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'Brand New',
            },
            {
                name: 'ad_condition',
                value: 'refurbished',
                label: 'Refurbished',
            },
        ],
    },
];
const home01 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: homeBrands[5701].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: homeTypes[5701].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'Brand New',
            },
            {
                name: 'ad_condition',
                value: 'refurbished',
                label: 'Refurbished',
            },
        ],
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: color,
            value: color,
            label: color,
        })),
    },
    {
        id: 'material',
        title: 'Material',
        type: 'checkbox',
        content_checkbox: false,
        content: homeMaterials.map((material) => ({
            name: material,
            value: material,
            label: material,
        })),
    },
    {
        id: 'furniture',
        title: 'For',
        type: 'checkbox',
        content_checkbox: false,
        content: furnitureFor.map((furnitureUse) => ({
            name: furnitureUse,
            value: furnitureUse,
            label: furnitureUse,
        })),
    },
];
const home02 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: homeBrands[5702].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: homeTypes[5702].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'Brand New',
            },
            {
                name: 'ad_condition',
                value: 'refurbished',
                label: 'Refurbished',
            },
        ],
    },
];
const home04 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: homeBrands[5707].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: homeTypes[5707].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'Brand New',
            },
            {
                name: 'ad_condition',
                value: 'refurbished',
                label: 'Refurbished',
            },
        ],
    },
    {
        id: 'formulation',
        title: 'Formulation',
        type: 'checkbox',
        content_checkbox: false,
        content: healthProductFormulation.default.map((formulation) => ({
            name: 'formulation',
            value: formulation.toLowerCase(),
            label: formulation,
        })),
    },
];
const home05 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: homeBrands[5707].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: homeTypes[5707].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'Brand New',
            },
            {
                name: 'ad_condition',
                value: 'refurbished',
                label: 'Refurbished',
            },
        ],
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: color,
            value: color,
            label: color,
        })),
    },
];
const home06 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: homeBrands[5706].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: homeTypes[5706].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'Brand New',
            },
            {
                name: 'ad_condition',
                value: 'refurbished',
                label: 'Refurbished',
            },
        ],
    },
];
const home07 = [
    ...defaults,
    {
        id: 'brand',
        title: 'Brand',
        type: 'checkbox',
        content_checkbox: false,
        content: homeBrands[5707].map((brand) => ({
            name: brand,
            value: brand,
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type',
        type: 'checkbox',
        content_checkbox: false,
        content: homeTypes[5707].map((type) => ({
            name: 'type',
            value: type,
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'ad_condition',
                value: 'used',
                label: 'Used',
            },
            {
                name: 'ad_condition',
                value: 'new',
                label: 'Brand New',
            },
            {
                name: 'ad_condition',
                value: 'refurbished',
                label: 'Refurbished',
            },
        ],
    },
];
// Tradesman and construction
const tradesman = [
    {
        id: 'mode_of_charge',
        title: 'Mode of Charge',
        type: 'checkbox',
        content_checkbox: false,
        content: mode_of_charge.map((mode_of_charge) => ({
            name: mode_of_charge.name,
            value: mode_of_charge.value.toLowerCase(),
            label: mode_of_charge.name,
        })),
    },
    defaults[0],
    {
        id: 'type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5803]
            .concat(
                tradesmanType[5804],
                tradesmanType[5805],
                tradesmanType[5806],
                tradesmanType[5807],
                tradesmanType[5808],
                tradesmanType[5809],
                tradesmanType[5810],
                tradesmanType[5811],
                tradesmanType[5812],
                tradesmanType[5813]
            )
            .map((type) => ({
                name: 'type',
                value: type.toLowerCase(),
                label: type,
            })),
    },
    {
        id: 'service_type',
        title: 'Service In:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanArea.default.map((service_type) => ({
            name: service_type,
            value: service_type.toLowerCase(),
            label: service_type,
        })),
    },
    {
        id: 'available_for_travel',
        title: 'Available to Travel?',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'available_for_travel',
                value: 'yes',
                label: 'Yes',
            },
            {
                name: 'available_for_travel',
                value: 'no',
                label: 'No',
            },
        ],
    },
    {
        id: 'years',
        title: 'Years of Experience',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_years',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_years',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'years',
                value: '',
                label: 'All',
            },
            {
                name: 'years',
                value: '3',
                label: '0 - 3 years',
            },
            {
                name: 'years',
                value: '6',
                label: '3 - 6 years',
            },
            {
                name: 'years',
                value: '10',
                label: '6 - 10 years',
            },
            {
                name: 'years',
                value: '15',
                label: '10 - 15 years',
            },
            {
                name: 'years',
                value: '20',
                label: '15 - 20 years',
            },
            {
                name: 'years',
                value: '>20',
                label: '20 years+',
            },
        ],
    },
];
const tradesman06 = [
    defaults[0],
    {
        id: 'service_type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanArea[5806].map((service_type) => ({
            name: service_type,
            value: service_type.toLowerCase(),
            label: service_type,
        })),
    },
    {
        id: 'type',
        title: 'Service In:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5806].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'available_for_travel',
        title: 'Available to Travel?',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'available_for_travel',
                value: 'yes',
                label: 'Yes',
            },
            {
                name: 'available_for_travel',
                value: 'no',
                label: 'No',
            },
        ],
    },
];
const tradesman08 = [
    defaults[0],
    {
        id: 'service_type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanArea[5808].map((service_type) => ({
            name: service_type,
            value: service_type.toLowerCase(),
            label: service_type,
        })),
    },
    {
        id: 'type',
        title: 'Service In:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5808].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'available_for_travel',
        title: 'Available to Travel?',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'available_for_travel',
                value: 'yes',
                label: 'Yes',
            },
            {
                name: 'available_for_travel',
                value: 'no',
                label: 'No',
            },
        ],
    },
];
const tradesman11 = [
    defaults[0],
    {
        id: 'type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5811].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
];
const tradesman03 = [
    defaults[0],
    {
        id: 'type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5803].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
];
const tradesman02 = [
    defaults[0],
    {
        id: 'service_type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanArea[5802].map((service_type) => ({
            name: service_type,
            value: service_type.toLowerCase(),
            label: service_type,
        })),
    },
    {
        id: 'available_for_travel',
        title: 'Available to Travel?',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'available_for_travel',
                value: 'yes',
                label: 'Yes',
            },
            {
                name: 'available_for_travel',
                value: 'no',
                label: 'No',
            },
        ],
    },
];
const tradesman04 = [
    defaults[0],
    {
        id: 'service_type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanArea[5804].map((service_type) => ({
            name: service_type,
            value: service_type.toLowerCase(),
            label: service_type,
        })),
    },
    {
        id: 'type',
        title: 'Service In:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5804].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'available_for_travel',
        title: 'Available to Travel?',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'available_for_travel',
                value: 'yes',
                label: 'Yes',
            },
            {
                name: 'available_for_travel',
                value: 'no',
                label: 'No',
            },
        ],
    },
];
const tradesman09 = [
    defaults[0],
    {
        id: 'service_type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanArea[5809].map((service_type) => ({
            name: service_type,
            value: service_type.toLowerCase(),
            label: service_type,
        })),
    },
    {
        id: 'type',
        title: 'Service In:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5809].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'available_for_travel',
        title: 'Available to Travel?',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'available_for_travel',
                value: 'yes',
                label: 'Yes',
            },
            {
                name: 'available_for_travel',
                value: 'no',
                label: 'No',
            },
        ],
    },
];
const tradesman07 = [
    defaults[0],
    {
        id: 'service_type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanArea[5807].map((service_type) => ({
            name: service_type,
            value: service_type.toLowerCase(),
            label: service_type,
        })),
    },
    {
        id: 'type',
        title: 'Service In:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5807].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'available_for_travel',
        title: 'Available to Travel?',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'available_for_travel',
                value: 'yes',
                label: 'Yes',
            },
            {
                name: 'available_for_travel',
                value: 'no',
                label: 'No',
            },
        ],
    },
];
const tradesman05 = [
    defaults[0],
    {
        id: 'service_type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanArea[5805].map((service_type) => ({
            name: service_type,
            value: service_type.toLowerCase(),
            label: service_type,
        })),
    },
    {
        id: 'type',
        title: 'Service In:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5805].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'available_for_travel',
        title: 'Available to Travel?',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'available_for_travel',
                value: 'yes',
                label: 'Yes',
            },
            {
                name: 'available_for_travel',
                value: 'no',
                label: 'No',
            },
        ],
    },
];
const tradesman12 = [
    defaults[0],
    {
        id: 'service_type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanArea[5812].map((service_type) => ({
            name: service_type,
            value: service_type.toLowerCase(),
            label: service_type,
        })),
    },
    {
        id: 'type',
        title: 'Service In:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5812].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
];
const tradesman10 = [
    defaults[0],
    {
        id: 'service_type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanArea[5810].map((service_type) => ({
            name: service_type,
            value: service_type.toLowerCase(),
            label: service_type,
        })),
    },
    {
        id: 'type',
        title: 'Service In:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5810].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
];
const tradesman13 = [
    defaults[0],
    {
        id: 'service_type',
        title: 'Service Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanArea[5813].map((service_type) => ({
            name: service_type,
            value: service_type.toLowerCase(),
            label: service_type,
        })),
    },
    {
        id: 'type',
        title: 'Service In:',
        type: 'checkbox',
        content_checkbox: false,
        content: tradesmanType[5813].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'years',
        title: 'Years of Experience',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_years',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_years',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'years',
                value: '',
                label: 'All',
            },
            {
                name: 'years',
                value: '3',
                label: '0 - 3 years',
            },
            {
                name: 'years',
                value: '6',
                label: '3 - 6 years',
            },
            {
                name: 'years',
                value: '10',
                label: '6 - 10 years',
            },
            {
                name: 'years',
                value: '15',
                label: '10 - 15 years',
            },
            {
                name: 'years',
                value: '20',
                label: '15 - 20 years',
            },
            {
                name: 'years',
                value: '>20',
                label: '20 years+',
            },
        ],
    },
];

const software = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '1500000',
                label: 'Under 1.5m',
            },
            {
                name: 'price',
                value: '3000000',
                label: '1.5m to 3m',
            },
            {
                name: 'price',
                value: '7500000',
                label: '3m to 7.5m',
            },
            {
                name: 'price',
                value: '11000000',
                label: '7.5m to 11m',
            },
            {
                name: 'price',
                value: '>11000000',
                label: '11m and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Software Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: softwareTypes.map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'type',
        title: 'Plaftorm:',
        type: 'checkbox',
        content_checkbox: false,
        content: softwarePlatforms.default.map((platform) => ({
            name: platform,
            value: platform.toLowerCase(),
            label: platform,
        })),
    },
    {
        id: 'type',
        title: 'Game Genre:',
        type: 'checkbox',
        content_checkbox: false,
        content: gameGenre.map((genre) => ({
            name: genre,
            value: genre.toLowerCase(),
            label: genre,
        })),
    },
    {
        id: 'year',
        title: 'Manufacture Year',
        type: 'checkbox',
        content_checkbox: false,
        content: arrayRange(1990, parseInt(new Date().getFullYear()), 1)
            .reverse()
            .map((val) => ({
                name: 'year',
                value: val.toString(),
                label: val.toString(),
            })),
    },
];

const software01 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '1500000',
                label: 'Under 1.5m',
            },
            {
                name: 'price',
                value: '3000000',
                label: '1.5m to 3m',
            },
            {
                name: 'price',
                value: '7500000',
                label: '3m to 7.5m',
            },
            {
                name: 'price',
                value: '11000000',
                label: '7.5m to 11m',
            },
            {
                name: 'price',
                value: '>11000000',
                label: '11m and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Software Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: softwareTypes.map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'type',
        title: 'Plaftorm:',
        type: 'checkbox',
        content_checkbox: false,
        content: softwarePlatforms[5901].map((platform) => ({
            name: platform,
            value: platform.toLowerCase(),
            label: platform,
        })),
    },
    {
        id: 'type',
        title: 'Softwar Format:',
        type: 'checkbox',
        content_checkbox: false,
        content: softwareFormat.map((format) => ({
            name: format,
            value: format.toLowerCase(),
            label: format,
        })),
    },
];

const pet = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Breed Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: petTypes.default.map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'breed',
        title: 'Breed Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: petBreeds[6001].map((breed) => ({
            name: breed,
            value: breed.toLowerCase(),
            label: breed,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'years',
        title: 'Years of Experience',
        type: 'radio',
        content_checkbox: false,
        content: [
            {
                name: 'years',
                value: '',
                label: 'All',
            },
            {
                name: 'years',
                value: '2',
                label: '0 - 2 years',
            },
            {
                name: 'years',
                value: '4',
                label: '2 - 4 years',
            },
            {
                name: 'years',
                value: '6',
                label: '4 - 6 years',
            },
            {
                name: 'years',
                value: '8',
                label: '6 - 8 years',
            },
            {
                name: 'years',
                value: '>8',
                label: '8 years+',
            },
        ],
    },
];

const pet02 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: petTypes[6002].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
];

const pet03 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: petTypes[6003].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition.map((ad_condition) => ({
            name: 'ad_condition',
            value: ad_condition.value,
            label: ad_condition.label,
        })),
    },
];

const pet04 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Breed Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: petTypes.default.map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'breed',
        title: 'Breed:',
        type: 'checkbox',
        content_checkbox: false,
        content: petBreeds[6004].map((breed) => ({
            name: breed,
            value: breed.toLowerCase(),
            label: breed,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
    {
        id: 'years',
        title: 'Years of Experience',
        type: 'radio',
        content_checkbox: false,
        content: [
            {
                name: 'years',
                value: '',
                label: 'All',
            },
            {
                name: 'years',
                value: '2',
                label: '0 - 2 years',
            },
            {
                name: 'years',
                value: '4',
                label: '2 - 4 years',
            },
            {
                name: 'years',
                value: '6',
                label: '4 - 6 years',
            },
            {
                name: 'years',
                value: '8',
                label: '6 - 8 years',
            },
            {
                name: 'years',
                value: '>8',
                label: '8 years+',
            },
        ],
    },
];

const pet05 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: petTypes[6005].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
];

const babies = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesTypes.default.map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'brand',
        title: 'Brand:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesBrands.default.map((brand) => ({
            name: 'brand',
            value: brand.toLowerCase(),
            label: brand,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition.map((ad_condition) => ({
            name: 'ad_condition',
            value: ad_condition.value,
            label: ad_condition.label,
        })),
    },
];

const babies04 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesTypes[6104].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'brand',
        title: 'Brand:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesBrands[6104].map((brand) => ({
            name: 'brand',
            value: brand.toLowerCase(),
            label: brand,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition.map((ad_condition) => ({
            name: 'ad_condition',
            value: ad_condition.value,
            label: ad_condition.label,
        })),
    },
];

const babies06 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesTypes[6106].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition.map((ad_condition) => ({
            name: 'ad_condition',
            value: ad_condition.value,
            label: ad_condition.label,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
        ],
    },
];

const babies03 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'brand',
        title: 'Brand:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesBrands[6103].map((brand) => ({
            name: 'brand',
            value: brand.toLowerCase(),
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesTypes[6103].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition.map((ad_condition) => ({
            name: 'ad_condition',
            value: ad_condition.value,
            label: ad_condition.label,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
            {
                name: 'gender',
                value: 'u',
                label: 'Unisex',
            },
        ],
    },
];

const babies10 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'brand',
        title: 'Brand:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesBrands[6110].map((brand) => ({
            name: 'brand',
            value: brand.toLowerCase(),
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesTypes[6110].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((ad_condition) => ({
            name: 'ad_condition',
            value: ad_condition.value,
            label: ad_condition.label,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
            {
                name: 'gender',
                value: 'u',
                label: 'Unisex',
            },
        ],
    },
    //        {
    //       id: "age_group",
    //       title: "Years",
    //       type: "radio",
    //       content_checkbox: false,
    //       content: [
    //         {
    //           name: "age_group",
    //           value: "",
    //           label: "All",
    //         },
    //         {
    //           name: "age_group",
    //           value: "0.6",
    //           label: "0 - 6 months",
    //         },
    //         {
    //           name: "age_group",
    //           value: "2.4",
    //           label: "5 - 10 age_group",
    //         },
    //         {
    //           name: "age_group",
    //           value: "15",
    //           label: "10 - 15 age_group",
    //         },{
    //           name: "age_group",
    //           value: "20",
    //           label: "15 - 20 age_group",
    //         },{
    //           name: "age_group",
    //           value: ">20",
    //           label: "20 age_group+",
    //         },
    //       ],
    //     },
];

const babies01 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesTypes[6101].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((ad_condition) => ({
            name: 'ad_condition',
            value: ad_condition.value,
            label: ad_condition.label,
        })),
    },
    //        {
    //       id: "age_group",
    //       title: "Years",
    //       type: "radio",
    //       content_checkbox: false,
    //       content: [
    //         {
    //           name: "age_group",
    //           value: "",
    //           label: "All",
    //         },
    //         {
    //           name: "age_group",
    //           value: "0.6",
    //           label: "0 - 6 months",
    //         },
    //         {
    //           name: "age_group",
    //           value: "2.4",
    //           label: "5 - 10 age_group",
    //         },
    //         {
    //           name: "age_group",
    //           value: "15",
    //           label: "10 - 15 age_group",
    //         },{
    //           name: "age_group",
    //           value: "20",
    //           label: "15 - 20 age_group",
    //         },{
    //           name: "age_group",
    //           value: ">20",
    //           label: "20 age_group+",
    //         },
    //       ],
    //     },
];

const babies11 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'brand',
        title: 'Brand:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesBrands[6111].map((brand) => ({
            name: 'brand',
            value: brand.toLowerCase(),
            label: brand,
        })),
    },
    //        {
    //       id: "age_group",
    //       title: "Years",
    //       type: "radio",
    //       content_checkbox: false,
    //       content: [
    //         {
    //           name: "age_group",
    //           value: "",
    //           label: "All",
    //         },
    //         {
    //           name: "age_group",
    //           value: "0.6",
    //           label: "0 - 6 months",
    //         },
    //         {
    //           name: "age_group",
    //           value: "2.4",
    //           label: "5 - 10 age_group",
    //         },
    //         {
    //           name: "age_group",
    //           value: "15",
    //           label: "10 - 15 age_group",
    //         },{
    //           name: "age_group",
    //           value: "20",
    //           label: "15 - 20 age_group",
    //         },{
    //           name: "age_group",
    //           value: ">20",
    //           label: "20 age_group+",
    //         },
    //       ],
    //     },
];

const babies05 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'brand',
        title: 'Brand:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesBrands[6105].map((brand) => ({
            name: 'brand',
            value: brand.toLowerCase(),
            label: brand,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((ad_condition) => ({
            name: 'ad_condition',
            value: ad_condition.value,
            label: ad_condition.label,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    //        {
    //       id: "age_group",
    //       title: "Years",
    //       type: "radio",
    //       content_checkbox: false,
    //       content: [
    //         {
    //           name: "age_group",
    //           value: "",
    //           label: "All",
    //         },
    //         {
    //           name: "age_group",
    //           value: "0.6",
    //           label: "0 - 6 months",
    //         },
    //         {
    //           name: "age_group",
    //           value: "2.4",
    //           label: "5 - 10 age_group",
    //         },
    //         {
    //           name: "age_group",
    //           value: "15",
    //           label: "10 - 15 age_group",
    //         },{
    //           name: "age_group",
    //           value: "20",
    //           label: "15 - 20 age_group",
    //         },{
    //           name: "age_group",
    //           value: ">20",
    //           label: "20 age_group+",
    //         },
    //       ],
    //     },
];

const babies02 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'brand',
        title: 'Brand:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesBrands[6102].map((brand) => ({
            name: 'brand',
            value: brand.toLowerCase(),
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesTypes[6102].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((ad_condition) => ({
            name: 'ad_condition',
            value: ad_condition.value,
            label: ad_condition.label,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'gender',
        title: 'Gender',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'gender',
                value: 'm',
                label: 'Male',
            },
            {
                name: 'gender',
                value: 'f',
                label: 'Female',
            },
            {
                name: 'gender',
                value: 'u',
                label: 'Unisex',
            },
        ],
    },
    {
        id: 'size',
        title: 'Size',
        type: 'checkbox',
        content_checkbox: false,
        content: size.map((size) => ({
            name: 'size',
            value: size.toString(),
            label: size.toString(),
        })),
    },
    //        {
    //       id: "age_group",
    //       title: "Years",
    //       type: "radio",
    //       content_checkbox: false,
    //       content: [
    //         {
    //           name: "age_group",
    //           value: "",
    //           label: "All",
    //         },
    //         {
    //           name: "age_group",
    //           value: "0.6",
    //           label: "0 - 6 months",
    //         },
    //         {
    //           name: "age_group",
    //           value: "2.4",
    //           label: "5 - 10 age_group",
    //         },
    //         {
    //           name: "age_group",
    //           value: "15",
    //           label: "10 - 15 age_group",
    //         },{
    //           name: "age_group",
    //           value: "20",
    //           label: "15 - 20 age_group",
    //         },{
    //           name: "age_group",
    //           value: ">20",
    //           label: "20 age_group+",
    //         },
    //       ],
    //     },
];

const babies09 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'brand',
        title: 'Brand:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesBrands[6109].map((brand) => ({
            name: 'brand',
            value: brand.toLowerCase(),
            label: brand,
        })),
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: babiesTypes[6109].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub.map((ad_condition) => ({
            name: 'ad_condition',
            value: ad_condition.value,
            label: ad_condition.label,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    //        {
    //       id: "age_group",
    //       title: "Years",
    //       type: "radio",
    //       content_checkbox: false,
    //       content: [
    //         {
    //           name: "age_group",
    //           value: "",
    //           label: "All",
    //         },
    //         {
    //           name: "age_group",
    //           value: "0.6",
    //           label: "0 - 6 months",
    //         },
    //         {
    //           name: "age_group",
    //           value: "2.4",
    //           label: "5 - 10 age_group",
    //         },
    //         {
    //           name: "age_group",
    //           value: "15",
    //           label: "10 - 15 age_group",
    //         },{
    //           name: "age_group",
    //           value: "20",
    //           label: "15 - 20 age_group",
    //         },{
    //           name: "age_group",
    //           value: ">20",
    //           label: "20 age_group+",
    //         },
    //       ],
    //     },
];

const sport = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: sportTypes[6205].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub
            .filter((cond) => cond.values !== 'refurbished')
            .map((ad_condition) => ({
                name: 'ad_condition',
                value: ad_condition.value,
                label: ad_condition.label,
            })),
    },
];
const sport01 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: sportTypes[6201].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub
            .filter((cond) => cond.values !== 'refurbished')
            .map((ad_condition) => ({
                name: 'ad_condition',
                value: ad_condition.value,
                label: ad_condition.label,
            })),
    },
];
const sport04 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: sportTypes[6205].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
];
const sport02 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: sportTypes[6202].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub
            .filter((cond) => cond.values !== 'refurbished')
            .map((ad_condition) => ({
                name: 'ad_condition',
                value: ad_condition.value,
                label: ad_condition.label,
            })),
    },
    {
        id: 'brand',
        title: 'Brand:',
        type: 'checkbox',
        content_checkbox: false,
        content: sportBrands[6202].map((brand) => ({
            name: 'brand',
            value: brand.toLowerCase(),
            label: brand,
        })),
    },
];
const sport03 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: sportTypes[6203].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub
            .filter((cond) => cond.values !== 'refurbished')
            .map((ad_condition) => ({
                name: 'ad_condition',
                value: ad_condition.value,
                label: ad_condition.label,
            })),
    },
    {
        id: 'brand',
        title: 'Brand:',
        type: 'checkbox',
        content_checkbox: false,
        content: sportBrands[6203].map((brand) => ({
            name: 'brand',
            value: brand.toLowerCase(),
            label: brand,
        })),
    },
];
const sport06 = [
    defaults[0],
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '5000',
                label: '0 - 5k',
            },
            {
                name: 'price',
                value: '10000',
                label: '5k to 10k',
            },
            {
                name: 'price',
                value: '15000',
                label: '10k - 15k',
            },
            {
                name: 'price',
                value: '20000',
                label: '15k to 20k',
            },
            {
                name: 'price',
                value: '30000',
                label: '20k to 30k',
            },
            {
                name: 'price',
                value: '>20000',
                label: '30k and more',
            },
        ],
    },
    {
        id: 'type',
        title: 'Type:',
        type: 'checkbox',
        content_checkbox: false,
        content: sportTypes[6206].map((type) => ({
            name: 'type',
            value: type.toLowerCase(),
            label: type,
        })),
    },
    {
        id: 'ad_condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub
            .filter((cond) => cond.values !== 'refurbished')
            .map((ad_condition) => ({
                name: 'ad_condition',
                value: ad_condition.value,
                label: ad_condition.label,
            })),
    },
    {
        id: 'brand',
        title: 'Brand:',
        type: 'checkbox',
        content_checkbox: false,
        content: sportBrands[6206].map((brand) => ({
            name: 'brand',
            value: brand.toLowerCase(),
            label: brand,
        })),
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
];

const motorbike = [
    {
        id: 'location',
        title: 'Location',
        type: 'modal',
        content_checkbox: false,
        content: [
            {
                type: 'modal',
            },
        ],
    },
    {
        id: 'seller_type',
        title: 'Seller Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'seller_type',
                value: 'dealer',
                label: 'Dealer',
            },
            {
                name: 'seller_type',
                value: 'private',
                label: 'Private',
            },
        ],
    },
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '1500000',
                label: 'Under 1.5m',
            },
            {
                name: 'price',
                value: '3000000',
                label: '1.5m to 3m',
            },
            {
                name: 'price',
                value: '7500000',
                label: '3m to 7.5m',
            },
            {
                name: 'price',
                value: '11000000',
                label: '7.5m to 11m',
            },
            {
                name: 'price',
                value: '>11000000',
                label: '11m and more',
            },
        ],
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition.map((condition) => ({
            name: 'condition',
            value: condition.value,
            label: condition.label,
        })),
    },
    {
        id: 'fuel_type',
        title: 'Fuel Type',
        type: 'checkbox',
        content_checkbox: false,
        content: fuel_type.map((fuel_type) => ({
            name: 'fuel_type',
            value: fuel_type.toLowerCase(),
            label: fuel_type,
        })),
    },
    {
        id: 'make',
        title: 'Make',
        type: 'checkbox',
        content_checkbox: false,
        content: motorbikeMake[6301]
            .concat(motorbikeMake[6302])
            .map((val) => ({ name: 'make', value: val, label: val })),
    },
    {
        id: 'year',
        title: 'Manufacture Year',
        type: 'checkbox',
        content_checkbox: false,
        content: arrayRange(1990, parseInt(new Date().getFullYear()), 1)
            .reverse()
            .map((val) => ({
                name: 'year',
                value: val.toString(),
                label: val.toString(),
            })),
    },
    {
        id: 'transmission',
        title: 'Transmission',
        type: 'checkbox',
        content_checkbox: false,
        content: transmission.map((transmision) => ({
            name: 'transmission',
            value: transmision.toLowerCase(),
            label: transmision,
        })),
    },
    {
        id: 'millage',
        title: 'Millage',
        type: 'radio',
        content_checkbox: false,
        content: [
            {
                name: 'millage',
                value: '',
                label: 'Any',
            },
            {
                name: 'millage',
                value: '5000',
                label: 'Up to 5,000 miles',
            },
            {
                name: 'millage',
                value: '10000',
                label: 'Up to 10,000 miles',
            },
            {
                name: 'millage',
                value: '15000',
                label: 'Up to 15,000 miles',
            },
            {
                name: 'millage',
                value: '20000',
                label: 'Up to 20,000 miles',
            },
            {
                name: 'millage',
                value: '30000',
                label: 'Up to 30,000 miles',
            },
            {
                name: 'millage',
                value: '40000',
                label: 'Up to 40,000 miles',
            },
            {
                name: 'millage',
                value: '70000',
                label: 'Up to 70,000 miles',
            },
            {
                name: 'millage',
                value: '80000',
                label: 'Over 80,000 miles',
            },
        ],
    },
];
const motorbike01 = [
    {
        id: 'location',
        title: 'Location',
        type: 'modal',
        content_checkbox: false,
        content: [
            {
                type: 'modal',
            },
        ],
    },
    {
        id: 'seller_type',
        title: 'Seller Type',
        type: 'checkbox',
        content_checkbox: false,
        content: [
            {
                name: 'seller_type',
                value: 'dealer',
                label: 'Dealer',
            },
            {
                name: 'seller_type',
                value: 'private',
                label: 'Private',
            },
        ],
    },
    {
        id: 'price',
        title: 'Price ₦',
        type: 'radio',
        content_checkbox: false,
        options: [
            {
                name: 'min_price',
                type: 'text',
                placeholder: 'min',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
            {
                name: 'max_price',
                type: 'text',
                placeholder: 'max',
                className: 'md:w-20 w-24 lg:w-[8rem]  border-black',
            },
        ],
        content: [
            {
                name: 'price',
                value: '',
                label: 'All',
            },
            {
                name: 'price',
                value: '1500000',
                label: 'Under 1.5m',
            },
            {
                name: 'price',
                value: '3000000',
                label: '1.5m to 3m',
            },
            {
                name: 'price',
                value: '7500000',
                label: '3m to 7.5m',
            },
            {
                name: 'price',
                value: '11000000',
                label: '7.5m to 11m',
            },
            {
                name: 'price',
                value: '>11000000',
                label: '11m and more',
            },
        ],
    },
    {
        id: 'color',
        title: 'Color',
        type: 'checkbox',
        content_checkbox: false,
        content: colors.map((color) => ({
            name: 'color',
            value: color,
            label: color,
        })),
    },
    {
        id: 'condition',
        title: 'Condition',
        type: 'checkbox',
        content_checkbox: false,
        content: condition_refub
            .filter((val) => val.value !== 'refurbished')
            .map((condition) => ({
                name: 'condition',
                value: condition.value,
                label: condition.label,
            })),
    },
    {
        id: 'fuel_type',
        title: 'Fuel Type',
        type: 'checkbox',
        content_checkbox: false,
        content: fuel_type.map((fuel_type) => ({
            name: 'fuel_type',
            value: fuel_type.toLowerCase(),
            label: fuel_type,
        })),
    },
    {
        id: 'make',
        title: 'Make',
        type: 'checkbox',
        content_checkbox: false,
        content: motorbikeMake[6301].map((val) => ({ name: 'make', value: val, label: val })),
    },
    {
        id: 'type',
        title: 'Types',
        type: 'checkbox',
        content_checkbox: false,
        content: motorbikeType.map((val) => ({ name: 'type', value: val, label: val })),
    },
    {
        id: 'year',
        title: 'Manufacture Year',
        type: 'checkbox',
        content_checkbox: false,
        content: arrayRange(1990, parseInt(new Date().getFullYear()), 1)
            .reverse()
            .map((val) => ({
                name: 'year',
                value: val.toString(),
                label: val.toString(),
            })),
    },
    {
        id: 'transmission',
        title: 'Transmission',
        type: 'checkbox',
        content_checkbox: false,
        content: transmission.map((transmision) => ({
            name: 'transmission',
            value: transmision.toLowerCase(),
            label: transmision,
        })),
    },
    {
        id: 'millage',
        title: 'Millage',
        type: 'radio',
        content_checkbox: false,
        content: [
            {
                name: 'millage',
                value: '',
                label: 'Any',
            },
            {
                name: 'millage',
                value: '5000',
                label: 'Up to 5,000 miles',
            },
            {
                name: 'millage',
                value: '10000',
                label: 'Up to 10,000 miles',
            },
            {
                name: 'millage',
                value: '15000',
                label: 'Up to 15,000 miles',
            },
            {
                name: 'millage',
                value: '20000',
                label: 'Up to 20,000 miles',
            },
            {
                name: 'millage',
                value: '30000',
                label: 'Up to 30,000 miles',
            },
            {
                name: 'millage',
                value: '40000',
                label: 'Up to 40,000 miles',
            },
            {
                name: 'millage',
                value: '70000',
                label: 'Up to 70,000 miles',
            },
            {
                name: 'millage',
                value: '80000',
                label: 'Over 80,000 miles',
            },
        ],
    },
];

// FilterForm Controller, To avoid exporting everything to the page, we only return what is needed.
export const formToDisplay = (categoryId) => {
    switch (categoryId) {
        case 50:
        case 5005:
        case 5007:
            return filterFields;
        case 5003:
        case 5004:
            return vans;
        case 5001:
            return cars;
        case 5002:
            return automobile;
        case 51:
            return propertyFields;
        case 5101:
        case 5102:
        case 5103:
        case 5104:
        case 5106:
        case 5107:
        case 5108:
        case 5109:
            return propertyHouseApartment;
        case 5105:
            return propertyLand;
        case 52:
            return serviceDefault;
        case 5201:
            return serviceOffice;
        case 5202:
            return serviceFood;
        case 5203:
            return serviceWeddings;
        case 5204:
            return serviceChildCare;
        case 5205:
            return serviceMaintenance;
        case 5206:
            return serviceTutorial;
        case 5207:
            return serviceClothing;
        case 5208:
            return serviceAutomotive;
        case 5209:
            return serviceEntertainment;
        case 5210:
            return serviceTravel;
        case 5211:
            return serviceGoods;
        case 5212:
            return serviceLegal;
        case 5213:
            return serviceTransport;
        case 53:
            return agric;
        case 5301:
            return agricultureAnimal;
        case 5302:
            return agricultureFarm;
        case 5303:
            return agricultureEquipment;
        case 5304:
        case 5305:
            return agricultureFeed;
        case 54:
        case 5411:
            return electronic;
        case 5401:
            return electronics01;
        case 5402:
            return electronics02;
        case 5403:
            return electronics03;
        case 5404:
            return electronics04;
        case 5405:
            return electronics05;
        case 5406:
            return electronics06;
        case 5407:
            return electronics07;
        case 5408:
            return electronics08;
        case 5409:
            return electronics09;
        case 5410:
            return electronics10;
        case 55:
        case 5502:
        case 5505:
            return fashion;
        case 5501:
            return fashion01;
        case 5503:
            return fashion03;
        case 5504:
            return fashion04;
        case 5506:
            return fashion06;
        case 5507:
            return fashion07;
        case 56:
            return health;
        case 5601:
            return health01;
        case 5602:
            return health02;
        case 5603:
            return health03;
        case 5604:
            return health04;
        case 5605:
            return health05;
        case 5606:
            return health06;
        case 5607:
            return health07;
        case 5608:
            return health08;
        case 57:
        case 5703:
            return home;
        case 5701:
            return home01;
        case 5702:
            return home02;
        case 5704:
            return home04;
        case 5705:
            return home05;
        case 5706:
            return home06;
        case 5707:
            return home07;
        case 58:
        case 5801:
            return tradesman;
        case 5802:
            return tradesman02;
        case 5803:
            return tradesman03;
        case 5804:
            return tradesman04;
        case 5805:
            return tradesman05;
        case 5806:
            return tradesman06;
        case 5807:
            return tradesman07;
        case 5808:
            return tradesman08;
        case 5809:
            return tradesman09;
        case 5810:
            return tradesman10;
        case 5811:
            return tradesman11;
        case 5812:
            return tradesman12;
        case 5813:
            return tradesman13;
        case 59:
        case 5902:
        case 5903:
            return software;
        case 5901:
            return software01;
        case 60:
        case 6001:
        case 6006:
            return pet;
        case 6002:
            return pet02;
        case 6003:
            return pet03;
        case 6004:
            return pet04;
        case 6005:
            return pet05;
        case 61:
        case 6107:
        case 6108:
            return babies;
        case 6101:
            return babies01;
        case 6102:
            return babies02;
        case 6103:
            return babies03;
        case 6104:
            return babies04;
        case 6105:
            return babies05;
        case 6106:
            return babies06;
        case 6109:
            return babies09;
        case 6110:
            return babies10;
        case 6111:
            return babies11;
        case 62:
        case 6205:
            return sport;
        case 6201:
            return sport01;
        case 6202:
            return sport02;
        case 6203:
            return sport03;
        case 6204:
            return sport04;
        case 6206:
            return sport06;
        case 63:
        case 6302:
            return motorbike;
        case 6301:
            return motorbike01;
        default:
            return [];
    }
};
